import * as i0 from '@angular/core';
import { Injectable, Component, NgModule, Inject } from '@angular/core';
import { BehaviorSubject, Subject, throwError } from 'rxjs';
import { distinctUntilChanged, map, retry } from 'rxjs/operators';
import * as i2 from '@angular/common/http';
import { HttpClient } from '@angular/common/http';

class NtkCmsApiService {
    constructor() { }
}
NtkCmsApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NtkCmsApiService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
NtkCmsApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NtkCmsApiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NtkCmsApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

class NtkCmsApiComponent {
    constructor() { }
    ngOnInit() {
    }
}
NtkCmsApiComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NtkCmsApiComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
NtkCmsApiComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: NtkCmsApiComponent, selector: "lib-ntk-cms-api", ngImport: i0, template: `
    <p>
      ntk-cms-api works!
    </p>
  `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NtkCmsApiComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-ntk-cms-api', template: `
    <p>
      ntk-cms-api works!
    </p>
  ` }]
        }], ctorParameters: function () { return []; } });

class NtkCmsApiModule {
}
NtkCmsApiModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NtkCmsApiModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
NtkCmsApiModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: NtkCmsApiModule, declarations: [NtkCmsApiComponent], exports: [NtkCmsApiComponent] });
NtkCmsApiModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NtkCmsApiModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NtkCmsApiModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [NtkCmsApiComponent],
                    imports: [],
                    exports: [NtkCmsApiComponent]
                }]
        }] });

// Import the core angular services.
// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //
class CmsStore {
    // I initialize the simple store with the givne initial state value.
    constructor(initialState) {
        this.stateSubject = new BehaviorSubject(initialState);
    }
    // ---
    // PUBLIC METHODS.
    // ---
    // I get the current state as a stream (will always emit the current state value as
    // the first item in the stream).
    getState() {
        return (this.stateSubject.pipe(distinctUntilChanged()));
    }
    // I get the current state snapshot.
    getStateSnapshot() {
        return (this.stateSubject.getValue());
    }
    // I return the given top-level state key as a stream (will always emit the current
    // key value as the first item in the stream).
    select(key) {
        const selectStream = this.stateSubject.pipe(map((state) => {
            return (state[key]);
        }), distinctUntilChanged());
        return (selectStream);
    }
    // I move the store to a new state by merging the given partial state into the
    // existing state (creating a new state object).
    // --
    // CAUTION: Partial<T> does not currently project against "undefined" values. This is
    // a known type safety issue in TypeScript.
    setState(partialState) {
        const currentState = this.getStateSnapshot();
        const nextState = Object.assign({}, currentState, partialState);
        this.stateSubject.next(nextState);
    }
}

//@@tag-Version-2201011
class TokenInfoModel {
}

const initialState = {
    isLoading: true,
    tokenInfo: new TokenInfoModel(),
    inProcessingList: []
};
class NtkCmsApiStoreService {
    constructor() {
        this.sub = new Subject();
        this.state = {
            ntkCmsAPiState: initialState,
        };
        this.stateSubject = new BehaviorSubject(this.state);
        // @ts-ignore
        window.getInfo = () => this.state;
    }
    setState(param) {
        Object.assign(this.state.ntkCmsAPiState, stateReducer(this.state.ntkCmsAPiState, param));
        this.sub.next(this.state);
        this.stateSubject.next(this.state);
    }
    getState(mapFn) {
        if (typeof mapFn !== 'function') {
            throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
        }
        return this.sub.asObservable()
            .pipe(map(mapFn))
            .pipe(distinctUntilChanged());
    }
    getStateSnapshot() {
        return (this.stateSubject.getValue());
    }
    processStart(name) {
        if (this.state?.ntkCmsAPiState?.inProcessingList) {
            const index = this.state.ntkCmsAPiState.inProcessingList.indexOf(name);
            if (index < 0) {
                // console.log('processStart 1', this.state.ntkCmsAPiState.inProcessingList);
                const list = [...this.state.ntkCmsAPiState.inProcessingList];
                list.push(name);
                // console.log('processStart 2', this.state.ntkCmsAPiState.inProcessingList);
                this.setState({ type: SET_IN_PROCESSING_LIST, payload: list });
            }
        }
    }
    processStop(name) {
        if (this.state?.ntkCmsAPiState?.inProcessingList) {
            const index = this.state.ntkCmsAPiState.inProcessingList.indexOf(name);
            if (index >= 0) {
                // console.log('processStop 1', this.state.ntkCmsAPiState.inProcessingList);
                const list = [...this.state.ntkCmsAPiState.inProcessingList];
                list.splice(index, 1);
                // console.log('processStop 2', this.state.ntkCmsAPiState.inProcessingList);
                this.setState({ type: SET_IN_PROCESSING_LIST, payload: list });
            }
        }
    }
}
NtkCmsApiStoreService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NtkCmsApiStoreService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
NtkCmsApiStoreService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NtkCmsApiStoreService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NtkCmsApiStoreService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return []; } });
// REDUCERS
function stateReducer(state = initialState, action) {
    switch (action.type) {
        case SET_LOADING_STATE:
            return { ...state, isLoading: action.payload };
        case SET_TOKEN_INFO:
            return { ...state, tokenInfo: action.payload };
        case SET_IN_PROCESSING_LIST:
            return { ...state, inProcessingList: action.payload };
        default:
            return initialState;
    }
}
const SET_LOADING_STATE = 'SET_LOADING_STATE';
const SET_TOKEN_INFO = 'SET_TOKEN_INFO';
const SET_IN_PROCESSING_LIST = 'SET_IN_PROCESSING_LIST';
class SetLoadingState {
    constructor() {
        this.type = SET_LOADING_STATE;
    }
}
class SetTokenInfoState {
    constructor() {
        this.type = SET_TOKEN_INFO;
    }
}
class SetInProcessingList {
    constructor() {
        this.type = SET_IN_PROCESSING_LIST;
    }
}

class AccessHelper {
    AccessFieldsSet(access) {
        this.Access = access;
        this.AccessAddFields = {};
        this.AccessEditFields = {};
        this.AccessWatchFields = {};
        this.AccessSearchFields = {};
        access.fieldsInfo.filter((item) => {
            this.AccessAddFields[this.toLowerCaseFirstChar(item.fieldName)] = item.accessAddField;
            this.AccessEditFields[this.toLowerCaseFirstChar(item.fieldName)] = item.accessEditField;
            this.AccessWatchFields[this.toLowerCaseFirstChar(item.fieldName)] = item.accessWatchField;
            this.AccessSearchFields[this.toLowerCaseFirstChar(item.fieldName)] = item.accessSearchField;
        });
    }
    toLowerCaseFirstChar(str) {
        if (!str || str.length == 0)
            return '';
        if (str.length == 1)
            return str.toLowerCase();
        return str[0].toLowerCase() + str.slice(1);
    }
}

var ApiReceiveMethodEnum;
(function (ApiReceiveMethodEnum) {
    ApiReceiveMethodEnum[ApiReceiveMethodEnum["none"] = 0] = "none";
    ApiReceiveMethodEnum[ApiReceiveMethodEnum["Post"] = 1] = "Post";
    ApiReceiveMethodEnum[ApiReceiveMethodEnum["Get"] = 2] = "Get";
})(ApiReceiveMethodEnum || (ApiReceiveMethodEnum = {}));

var DayOfWeekEnum;
(function (DayOfWeekEnum) {
    //
    // Summary:
    //     Indicates Friday.
    DayOfWeekEnum[DayOfWeekEnum["Friday"] = 5] = "Friday";
    //
    // Summary:
    //     Indicates Monday.
    DayOfWeekEnum[DayOfWeekEnum["Monday"] = 1] = "Monday";
    //
    // Summary:
    //     Indicates Saturday.
    DayOfWeekEnum[DayOfWeekEnum["Saturday"] = 6] = "Saturday";
    //
    // Summary:
    //     Indicates Sunday.
    DayOfWeekEnum[DayOfWeekEnum["Sunday"] = 0] = "Sunday";
    //
    // Summary:
    //     Indicates Thursday.
    DayOfWeekEnum[DayOfWeekEnum["Thursday"] = 4] = "Thursday";
    //
    // Summary:
    //     Indicates Tuesday.
    DayOfWeekEnum[DayOfWeekEnum["Tuesday"] = 2] = "Tuesday";
    //
    // Summary:
    //     Indicates Wednesday.
    DayOfWeekEnum[DayOfWeekEnum["Wednesday"] = 3] = "Wednesday";
})(DayOfWeekEnum || (DayOfWeekEnum = {}));

var ClauseTypeEnum;
(function (ClauseTypeEnum) {
    ClauseTypeEnum[ClauseTypeEnum["Or"] = 1] = "Or";
    ClauseTypeEnum[ClauseTypeEnum["And"] = 2] = "And";
})(ClauseTypeEnum || (ClauseTypeEnum = {}));

var DeviceTypeEnum;
(function (DeviceTypeEnum) {
    DeviceTypeEnum[DeviceTypeEnum["none"] = 0] = "none";
    DeviceTypeEnum[DeviceTypeEnum["WebSite"] = 1] = "WebSite";
    DeviceTypeEnum[DeviceTypeEnum["Windows"] = 2] = "Windows";
    DeviceTypeEnum[DeviceTypeEnum["Android"] = 3] = "Android";
    DeviceTypeEnum[DeviceTypeEnum["AppleIOS"] = 4] = "AppleIOS";
})(DeviceTypeEnum || (DeviceTypeEnum = {}));

var ActionGoStepEnum;
(function (ActionGoStepEnum) {
    ActionGoStepEnum[ActionGoStepEnum["GoUp"] = 1] = "GoUp";
    ActionGoStepEnum[ActionGoStepEnum["GoDown"] = 2] = "GoDown";
})(ActionGoStepEnum || (ActionGoStepEnum = {}));

var ExportFileTypeEnum;
(function (ExportFileTypeEnum) {
    ExportFileTypeEnum[ExportFileTypeEnum["None"] = 0] = "None";
    ExportFileTypeEnum[ExportFileTypeEnum["Excel"] = 1] = "Excel";
    ExportFileTypeEnum[ExportFileTypeEnum["PDF"] = 2] = "PDF";
    ExportFileTypeEnum[ExportFileTypeEnum["Json"] = 3] = "Json";
    ExportFileTypeEnum[ExportFileTypeEnum["Report"] = 4] = "Report";
})(ExportFileTypeEnum || (ExportFileTypeEnum = {}));

var ExportReceiveMethodEnum;
(function (ExportReceiveMethodEnum) {
    ExportReceiveMethodEnum[ExportReceiveMethodEnum["Now"] = 0] = "Now";
    ExportReceiveMethodEnum[ExportReceiveMethodEnum["Email"] = 1] = "Email";
    ExportReceiveMethodEnum[ExportReceiveMethodEnum["FileManeger"] = 2] = "FileManeger";
})(ExportReceiveMethodEnum || (ExportReceiveMethodEnum = {}));

var FilterDataModelSearchTypesEnum;
(function (FilterDataModelSearchTypesEnum) {
    FilterDataModelSearchTypesEnum[FilterDataModelSearchTypesEnum["Equal"] = 0] = "Equal";
    FilterDataModelSearchTypesEnum[FilterDataModelSearchTypesEnum["NotEqual"] = 1] = "NotEqual";
    FilterDataModelSearchTypesEnum[FilterDataModelSearchTypesEnum["LessThan"] = 2] = "LessThan";
    FilterDataModelSearchTypesEnum[FilterDataModelSearchTypesEnum["GreaterThan"] = 3] = "GreaterThan";
    FilterDataModelSearchTypesEnum[FilterDataModelSearchTypesEnum["Between"] = 4] = "Between";
    FilterDataModelSearchTypesEnum[FilterDataModelSearchTypesEnum["Contains"] = 5] = "Contains";
    FilterDataModelSearchTypesEnum[FilterDataModelSearchTypesEnum["NotContains"] = 6] = "NotContains";
    FilterDataModelSearchTypesEnum[FilterDataModelSearchTypesEnum["BeginsWith"] = 7] = "BeginsWith";
    FilterDataModelSearchTypesEnum[FilterDataModelSearchTypesEnum["EndsWith"] = 8] = "EndsWith";
    FilterDataModelSearchTypesEnum[FilterDataModelSearchTypesEnum["LessThanOrEqualTo"] = 9] = "LessThanOrEqualTo";
    FilterDataModelSearchTypesEnum[FilterDataModelSearchTypesEnum["GreaterThanOrEqualTo"] = 10] = "GreaterThanOrEqualTo";
})(FilterDataModelSearchTypesEnum || (FilterDataModelSearchTypesEnum = {}));

var GenderTypeEnum;
(function (GenderTypeEnum) {
    GenderTypeEnum[GenderTypeEnum["None"] = 0] = "None";
    GenderTypeEnum[GenderTypeEnum["Man"] = 1] = "Man";
    GenderTypeEnum[GenderTypeEnum["Female"] = 2] = "Female";
    GenderTypeEnum[GenderTypeEnum["company"] = 3] = "company";
})(GenderTypeEnum || (GenderTypeEnum = {}));

var ManageUserAccessAreaTypesEnum;
(function (ManageUserAccessAreaTypesEnum) {
    ManageUserAccessAreaTypesEnum[ManageUserAccessAreaTypesEnum["None"] = 0] = "None";
    ManageUserAccessAreaTypesEnum[ManageUserAccessAreaTypesEnum["All"] = 1] = "All";
    ManageUserAccessAreaTypesEnum[ManageUserAccessAreaTypesEnum["BackgroundSystem"] = 2] = "BackgroundSystem";
    ManageUserAccessAreaTypesEnum[ManageUserAccessAreaTypesEnum["WindowsService"] = 3] = "WindowsService";
    ManageUserAccessAreaTypesEnum[ManageUserAccessAreaTypesEnum["ControlPanel"] = 4] = "ControlPanel";
    ManageUserAccessAreaTypesEnum[ManageUserAccessAreaTypesEnum["Website"] = 5] = "Website";
    ManageUserAccessAreaTypesEnum[ManageUserAccessAreaTypesEnum["WebService"] = 6] = "WebService";
    ManageUserAccessAreaTypesEnum[ManageUserAccessAreaTypesEnum["Application"] = 7] = "Application";
})(ManageUserAccessAreaTypesEnum || (ManageUserAccessAreaTypesEnum = {}));

var ManageUserAccessUserTypesEnum;
(function (ManageUserAccessUserTypesEnum) {
    ManageUserAccessUserTypesEnum[ManageUserAccessUserTypesEnum["None"] = 0] = "None";
    //////////////////////////////////////////////// سورس برنامه
    ManageUserAccessUserTypesEnum[ManageUserAccessUserTypesEnum["All"] = 99] = "All";
    ManageUserAccessUserTypesEnum[ManageUserAccessUserTypesEnum["SystemPayment"] = 101] = "SystemPayment";
    ManageUserAccessUserTypesEnum[ManageUserAccessUserTypesEnum["System"] = 104] = "System";
    //////////////////////////////////////////////// مدیریت سی ام اس
    ManageUserAccessUserTypesEnum[ManageUserAccessUserTypesEnum["AdminMainCms"] = 1] = "AdminMainCms";
    ManageUserAccessUserTypesEnum[ManageUserAccessUserTypesEnum["SupportMainCms"] = 2] = "SupportMainCms";
    ManageUserAccessUserTypesEnum[ManageUserAccessUserTypesEnum["MonitoringMainCms"] = 3] = "MonitoringMainCms";
    ManageUserAccessUserTypesEnum[ManageUserAccessUserTypesEnum["DemoMainCms"] = 4] = "DemoMainCms";
    ManageUserAccessUserTypesEnum[ManageUserAccessUserTypesEnum["ResellerMainCms"] = 5] = "ResellerMainCms";
    //////////////////////////////////////////////// مدیران سایت
    ManageUserAccessUserTypesEnum[ManageUserAccessUserTypesEnum["AdminCpSite"] = 11] = "AdminCpSite";
    ManageUserAccessUserTypesEnum[ManageUserAccessUserTypesEnum["SupportCpSite"] = 12] = "SupportCpSite";
    ManageUserAccessUserTypesEnum[ManageUserAccessUserTypesEnum["MonitoringCpCms"] = 13] = "MonitoringCpCms";
    ManageUserAccessUserTypesEnum[ManageUserAccessUserTypesEnum["DemoCpSite"] = 14] = "DemoCpSite";
    ManageUserAccessUserTypesEnum[ManageUserAccessUserTypesEnum["ResellerCpSite"] = 15] = "ResellerCpSite";
    ManageUserAccessUserTypesEnum[ManageUserAccessUserTypesEnum["ResellerEmployeeCpSite"] = 16] = "ResellerEmployeeCpSite";
    //////////////////////////////////////////////// کاربران  وب سایت
    ManageUserAccessUserTypesEnum[ManageUserAccessUserTypesEnum["GuestViewerWebSite"] = 21] = "GuestViewerWebSite";
    ManageUserAccessUserTypesEnum[ManageUserAccessUserTypesEnum["UserLoginWebSite"] = 22] = "UserLoginWebSite";
    ManageUserAccessUserTypesEnum[ManageUserAccessUserTypesEnum["DemoUserLoginWebSite"] = 23] = "DemoUserLoginWebSite";
    ////////////////////////////////////////////////
})(ManageUserAccessUserTypesEnum || (ManageUserAccessUserTypesEnum = {}));

var MenuPlaceTypeEnum;
(function (MenuPlaceTypeEnum) {
    MenuPlaceTypeEnum[MenuPlaceTypeEnum["All"] = 0] = "All";
    MenuPlaceTypeEnum[MenuPlaceTypeEnum["MenuUp"] = 1] = "MenuUp";
    MenuPlaceTypeEnum[MenuPlaceTypeEnum["MenuDown"] = 2] = "MenuDown";
    MenuPlaceTypeEnum[MenuPlaceTypeEnum["MenuRight"] = 3] = "MenuRight";
    MenuPlaceTypeEnum[MenuPlaceTypeEnum["MenuLeft"] = 4] = "MenuLeft";
    MenuPlaceTypeEnum[MenuPlaceTypeEnum["MenuMVCUser"] = 5] = "MenuMVCUser";
})(MenuPlaceTypeEnum || (MenuPlaceTypeEnum = {}));

var OperatingSystemTypeEnum;
(function (OperatingSystemTypeEnum) {
    OperatingSystemTypeEnum[OperatingSystemTypeEnum["none"] = 0] = "none";
    OperatingSystemTypeEnum[OperatingSystemTypeEnum["Windows"] = 1] = "Windows";
    OperatingSystemTypeEnum[OperatingSystemTypeEnum["AppleMacOS"] = 2] = "AppleMacOS";
    OperatingSystemTypeEnum[OperatingSystemTypeEnum["Linux"] = 3] = "Linux";
    OperatingSystemTypeEnum[OperatingSystemTypeEnum["AppleIOS"] = 4] = "AppleIOS";
    OperatingSystemTypeEnum[OperatingSystemTypeEnum["GoogleAndroid"] = 5] = "GoogleAndroid";
    OperatingSystemTypeEnum[OperatingSystemTypeEnum["OxygenOS"] = 6] = "OxygenOS";
    OperatingSystemTypeEnum[OperatingSystemTypeEnum["Chromium"] = 7] = "Chromium";
})(OperatingSystemTypeEnum || (OperatingSystemTypeEnum = {}));

var RecordStatusEnum;
(function (RecordStatusEnum) {
    RecordStatusEnum[RecordStatusEnum["Available"] = 1] = "Available";
    RecordStatusEnum[RecordStatusEnum["Disable"] = 2] = "Disable";
    RecordStatusEnum[RecordStatusEnum["Deleted"] = 3] = "Deleted";
    RecordStatusEnum[RecordStatusEnum["Pending"] = 4] = "Pending";
    RecordStatusEnum[RecordStatusEnum["DeniedConfirmed"] = 5] = "DeniedConfirmed";
    RecordStatusEnum[RecordStatusEnum["Archive"] = 6] = "Archive";
})(RecordStatusEnum || (RecordStatusEnum = {}));

var LanguageEnum;
(function (LanguageEnum) {
    LanguageEnum[LanguageEnum["None"] = 0] = "None";
    LanguageEnum[LanguageEnum["fa"] = 1] = "fa";
    LanguageEnum[LanguageEnum["en"] = 2] = "en";
    LanguageEnum[LanguageEnum["de"] = 3] = "de";
    LanguageEnum[LanguageEnum["fr"] = 4] = "fr";
    LanguageEnum[LanguageEnum["ch"] = 5] = "ch";
    LanguageEnum[LanguageEnum["jp"] = 6] = "jp";
    LanguageEnum[LanguageEnum["es"] = 7] = "es";
})(LanguageEnum || (LanguageEnum = {}));

var LanguageFullEnum;
(function (LanguageFullEnum) {
    LanguageFullEnum[LanguageFullEnum["None"] = 0] = "None";
    LanguageFullEnum[LanguageFullEnum["fa_IR"] = 1] = "fa_IR";
    LanguageFullEnum[LanguageFullEnum["en_US"] = 2] = "en_US";
    LanguageFullEnum[LanguageFullEnum["af_ZA"] = 3] = "af_ZA";
    LanguageFullEnum[LanguageFullEnum["am_ET"] = 4] = "am_ET";
    LanguageFullEnum[LanguageFullEnum["ar_AE"] = 5] = "ar_AE";
    LanguageFullEnum[LanguageFullEnum["ar_BH"] = 6] = "ar_BH";
    LanguageFullEnum[LanguageFullEnum["ar_DZ"] = 7] = "ar_DZ";
    LanguageFullEnum[LanguageFullEnum["ar_EG"] = 8] = "ar_EG";
    LanguageFullEnum[LanguageFullEnum["ar_IQ"] = 9] = "ar_IQ";
    LanguageFullEnum[LanguageFullEnum["ar_JO"] = 10] = "ar_JO";
    LanguageFullEnum[LanguageFullEnum["ar_KW"] = 11] = "ar_KW";
    LanguageFullEnum[LanguageFullEnum["ar_LB"] = 12] = "ar_LB";
    LanguageFullEnum[LanguageFullEnum["ar_LY"] = 13] = "ar_LY";
    LanguageFullEnum[LanguageFullEnum["ar_MA"] = 14] = "ar_MA";
    LanguageFullEnum[LanguageFullEnum["arn_CL"] = 15] = "arn_CL";
    LanguageFullEnum[LanguageFullEnum["ar_OM"] = 16] = "ar_OM";
    LanguageFullEnum[LanguageFullEnum["ar_QA"] = 17] = "ar_QA";
    LanguageFullEnum[LanguageFullEnum["ar_SA"] = 18] = "ar_SA";
    LanguageFullEnum[LanguageFullEnum["ar_SY"] = 19] = "ar_SY";
    LanguageFullEnum[LanguageFullEnum["ar_TN"] = 20] = "ar_TN";
    LanguageFullEnum[LanguageFullEnum["ar_YE"] = 21] = "ar_YE";
    LanguageFullEnum[LanguageFullEnum["as_IN"] = 22] = "as_IN";
    LanguageFullEnum[LanguageFullEnum["az_Cyrl_AZ"] = 23] = "az_Cyrl_AZ";
    LanguageFullEnum[LanguageFullEnum["az_Latn_AZ"] = 24] = "az_Latn_AZ";
    LanguageFullEnum[LanguageFullEnum["ba_RU"] = 25] = "ba_RU";
    LanguageFullEnum[LanguageFullEnum["be_BY"] = 26] = "be_BY";
    LanguageFullEnum[LanguageFullEnum["bg_BG"] = 27] = "bg_BG";
    LanguageFullEnum[LanguageFullEnum["bn_BD"] = 28] = "bn_BD";
    LanguageFullEnum[LanguageFullEnum["bn_IN"] = 29] = "bn_IN";
    LanguageFullEnum[LanguageFullEnum["bo_CN"] = 30] = "bo_CN";
    LanguageFullEnum[LanguageFullEnum["br_FR"] = 31] = "br_FR";
    LanguageFullEnum[LanguageFullEnum["bs_Cyrl_BA"] = 32] = "bs_Cyrl_BA";
    LanguageFullEnum[LanguageFullEnum["bs_Latn_BA"] = 33] = "bs_Latn_BA";
    LanguageFullEnum[LanguageFullEnum["ca_ES"] = 34] = "ca_ES";
    LanguageFullEnum[LanguageFullEnum["co_FR"] = 35] = "co_FR";
    LanguageFullEnum[LanguageFullEnum["cs_CZ"] = 36] = "cs_CZ";
    LanguageFullEnum[LanguageFullEnum["cy_GB"] = 37] = "cy_GB";
    LanguageFullEnum[LanguageFullEnum["da_DK"] = 38] = "da_DK";
    LanguageFullEnum[LanguageFullEnum["de_AT"] = 39] = "de_AT";
    LanguageFullEnum[LanguageFullEnum["de_CH"] = 40] = "de_CH";
    LanguageFullEnum[LanguageFullEnum["de_DE"] = 41] = "de_DE";
    LanguageFullEnum[LanguageFullEnum["de_LI"] = 42] = "de_LI";
    LanguageFullEnum[LanguageFullEnum["de_LU"] = 43] = "de_LU";
    LanguageFullEnum[LanguageFullEnum["dsb_DE"] = 44] = "dsb_DE";
    LanguageFullEnum[LanguageFullEnum["dv_MV"] = 45] = "dv_MV";
    LanguageFullEnum[LanguageFullEnum["el_GR"] = 46] = "el_GR";
    LanguageFullEnum[LanguageFullEnum["en_029"] = 47] = "en_029";
    LanguageFullEnum[LanguageFullEnum["en_AU"] = 48] = "en_AU";
    LanguageFullEnum[LanguageFullEnum["en_BZ"] = 49] = "en_BZ";
    LanguageFullEnum[LanguageFullEnum["en_CA"] = 50] = "en_CA";
    LanguageFullEnum[LanguageFullEnum["en_GB"] = 51] = "en_GB";
    LanguageFullEnum[LanguageFullEnum["en_IE"] = 52] = "en_IE";
    LanguageFullEnum[LanguageFullEnum["en_IN"] = 53] = "en_IN";
    LanguageFullEnum[LanguageFullEnum["en_JM"] = 54] = "en_JM";
    LanguageFullEnum[LanguageFullEnum["en_MY"] = 55] = "en_MY";
    LanguageFullEnum[LanguageFullEnum["en_NZ"] = 56] = "en_NZ";
    LanguageFullEnum[LanguageFullEnum["en_PH"] = 57] = "en_PH";
    LanguageFullEnum[LanguageFullEnum["en_SG"] = 58] = "en_SG";
    LanguageFullEnum[LanguageFullEnum["en_TT"] = 59] = "en_TT";
    LanguageFullEnum[LanguageFullEnum["en_ZA"] = 60] = "en_ZA";
    LanguageFullEnum[LanguageFullEnum["en_ZW"] = 61] = "en_ZW";
    LanguageFullEnum[LanguageFullEnum["es_AR"] = 62] = "es_AR";
    LanguageFullEnum[LanguageFullEnum["es_BO"] = 63] = "es_BO";
    LanguageFullEnum[LanguageFullEnum["es_CL"] = 64] = "es_CL";
    LanguageFullEnum[LanguageFullEnum["es_CO"] = 65] = "es_CO";
    LanguageFullEnum[LanguageFullEnum["es_CR"] = 66] = "es_CR";
    LanguageFullEnum[LanguageFullEnum["es_DO"] = 67] = "es_DO";
    LanguageFullEnum[LanguageFullEnum["es_EC"] = 68] = "es_EC";
    LanguageFullEnum[LanguageFullEnum["es_ES"] = 69] = "es_ES";
    LanguageFullEnum[LanguageFullEnum["es_GT"] = 70] = "es_GT";
    LanguageFullEnum[LanguageFullEnum["es_HN"] = 71] = "es_HN";
    LanguageFullEnum[LanguageFullEnum["es_MX"] = 72] = "es_MX";
    LanguageFullEnum[LanguageFullEnum["es_NI"] = 73] = "es_NI";
    LanguageFullEnum[LanguageFullEnum["es_PA"] = 74] = "es_PA";
    LanguageFullEnum[LanguageFullEnum["es_PE"] = 75] = "es_PE";
    LanguageFullEnum[LanguageFullEnum["es_PR"] = 76] = "es_PR";
    LanguageFullEnum[LanguageFullEnum["es_PY"] = 77] = "es_PY";
    LanguageFullEnum[LanguageFullEnum["es_SV"] = 78] = "es_SV";
    LanguageFullEnum[LanguageFullEnum["es_US"] = 79] = "es_US";
    LanguageFullEnum[LanguageFullEnum["es_UY"] = 80] = "es_UY";
    LanguageFullEnum[LanguageFullEnum["es_VE"] = 81] = "es_VE";
    LanguageFullEnum[LanguageFullEnum["et_EE"] = 82] = "et_EE";
    LanguageFullEnum[LanguageFullEnum["eu_ES"] = 83] = "eu_ES";
    LanguageFullEnum[LanguageFullEnum["fi_FI"] = 84] = "fi_FI";
    LanguageFullEnum[LanguageFullEnum["fil_PH"] = 85] = "fil_PH";
    LanguageFullEnum[LanguageFullEnum["fo_FO"] = 86] = "fo_FO";
    LanguageFullEnum[LanguageFullEnum["fr_BE"] = 87] = "fr_BE";
    LanguageFullEnum[LanguageFullEnum["fr_CA"] = 88] = "fr_CA";
    LanguageFullEnum[LanguageFullEnum["fr_CH"] = 89] = "fr_CH";
    LanguageFullEnum[LanguageFullEnum["fr_FR"] = 90] = "fr_FR";
    LanguageFullEnum[LanguageFullEnum["fr_LU"] = 91] = "fr_LU";
    LanguageFullEnum[LanguageFullEnum["fr_MC"] = 92] = "fr_MC";
    LanguageFullEnum[LanguageFullEnum["fy_NL"] = 93] = "fy_NL";
    LanguageFullEnum[LanguageFullEnum["ga_IE"] = 94] = "ga_IE";
    LanguageFullEnum[LanguageFullEnum["gd_GB"] = 95] = "gd_GB";
    LanguageFullEnum[LanguageFullEnum["gl_ES"] = 96] = "gl_ES";
    LanguageFullEnum[LanguageFullEnum["gsw_FR"] = 97] = "gsw_FR";
    LanguageFullEnum[LanguageFullEnum["gu_IN"] = 98] = "gu_IN";
    LanguageFullEnum[LanguageFullEnum["ha_Latn_NG"] = 99] = "ha_Latn_NG";
    LanguageFullEnum[LanguageFullEnum["he_IL"] = 100] = "he_IL";
    LanguageFullEnum[LanguageFullEnum["hi_IN"] = 101] = "hi_IN";
    LanguageFullEnum[LanguageFullEnum["hr_BA"] = 102] = "hr_BA";
    LanguageFullEnum[LanguageFullEnum["hr_HR"] = 103] = "hr_HR";
    LanguageFullEnum[LanguageFullEnum["hsb_DE"] = 104] = "hsb_DE";
    LanguageFullEnum[LanguageFullEnum["hu_HU"] = 105] = "hu_HU";
    LanguageFullEnum[LanguageFullEnum["hy_AM"] = 106] = "hy_AM";
    LanguageFullEnum[LanguageFullEnum["id_ID"] = 107] = "id_ID";
    LanguageFullEnum[LanguageFullEnum["ig_NG"] = 108] = "ig_NG";
    LanguageFullEnum[LanguageFullEnum["ii_CN"] = 109] = "ii_CN";
    LanguageFullEnum[LanguageFullEnum["is_IS"] = 110] = "is_IS";
    LanguageFullEnum[LanguageFullEnum["it_CH"] = 111] = "it_CH";
    LanguageFullEnum[LanguageFullEnum["it_IT"] = 112] = "it_IT";
    LanguageFullEnum[LanguageFullEnum["iu_Cans_CA"] = 113] = "iu_Cans_CA";
    LanguageFullEnum[LanguageFullEnum["iu_Latn_CA"] = 114] = "iu_Latn_CA";
    LanguageFullEnum[LanguageFullEnum["ja_JP"] = 115] = "ja_JP";
    LanguageFullEnum[LanguageFullEnum["ka_GE"] = 116] = "ka_GE";
    LanguageFullEnum[LanguageFullEnum["kk_KZ"] = 117] = "kk_KZ";
    LanguageFullEnum[LanguageFullEnum["kl_GL"] = 118] = "kl_GL";
    LanguageFullEnum[LanguageFullEnum["km_KH"] = 119] = "km_KH";
    LanguageFullEnum[LanguageFullEnum["kn_IN"] = 120] = "kn_IN";
    LanguageFullEnum[LanguageFullEnum["kok_IN"] = 121] = "kok_IN";
    LanguageFullEnum[LanguageFullEnum["ko_KR"] = 122] = "ko_KR";
    LanguageFullEnum[LanguageFullEnum["ky_KG"] = 123] = "ky_KG";
    LanguageFullEnum[LanguageFullEnum["lb_LU"] = 124] = "lb_LU";
    LanguageFullEnum[LanguageFullEnum["lo_LA"] = 125] = "lo_LA";
    LanguageFullEnum[LanguageFullEnum["lt_LT"] = 126] = "lt_LT";
    LanguageFullEnum[LanguageFullEnum["lv_LV"] = 127] = "lv_LV";
    LanguageFullEnum[LanguageFullEnum["mi_NZ"] = 128] = "mi_NZ";
    LanguageFullEnum[LanguageFullEnum["mk_MK"] = 129] = "mk_MK";
    LanguageFullEnum[LanguageFullEnum["ml_IN"] = 130] = "ml_IN";
    LanguageFullEnum[LanguageFullEnum["mn_MN"] = 131] = "mn_MN";
    LanguageFullEnum[LanguageFullEnum["mn_Mong_CN"] = 132] = "mn_Mong_CN";
    LanguageFullEnum[LanguageFullEnum["moh_CA"] = 133] = "moh_CA";
    LanguageFullEnum[LanguageFullEnum["mr_IN"] = 134] = "mr_IN";
    LanguageFullEnum[LanguageFullEnum["ms_BN"] = 135] = "ms_BN";
    LanguageFullEnum[LanguageFullEnum["ms_MY"] = 136] = "ms_MY";
    LanguageFullEnum[LanguageFullEnum["mt_MT"] = 137] = "mt_MT";
    LanguageFullEnum[LanguageFullEnum["nb_NO"] = 138] = "nb_NO";
    LanguageFullEnum[LanguageFullEnum["ne_NP"] = 139] = "ne_NP";
    LanguageFullEnum[LanguageFullEnum["nl_BE"] = 140] = "nl_BE";
    LanguageFullEnum[LanguageFullEnum["nl_NL"] = 141] = "nl_NL";
    LanguageFullEnum[LanguageFullEnum["nn_NO"] = 142] = "nn_NO";
    LanguageFullEnum[LanguageFullEnum["nso_ZA"] = 143] = "nso_ZA";
    LanguageFullEnum[LanguageFullEnum["oc_FR"] = 144] = "oc_FR";
    LanguageFullEnum[LanguageFullEnum["or_IN"] = 145] = "or_IN";
    LanguageFullEnum[LanguageFullEnum["pa_IN"] = 146] = "pa_IN";
    LanguageFullEnum[LanguageFullEnum["pl_PL"] = 147] = "pl_PL";
    LanguageFullEnum[LanguageFullEnum["prs_AF"] = 148] = "prs_AF";
    LanguageFullEnum[LanguageFullEnum["ps_AF"] = 149] = "ps_AF";
    LanguageFullEnum[LanguageFullEnum["pt_BR"] = 150] = "pt_BR";
    LanguageFullEnum[LanguageFullEnum["pt_PT"] = 151] = "pt_PT";
    LanguageFullEnum[LanguageFullEnum["qut_GT"] = 152] = "qut_GT";
    LanguageFullEnum[LanguageFullEnum["quz_BO"] = 153] = "quz_BO";
    LanguageFullEnum[LanguageFullEnum["quz_EC"] = 154] = "quz_EC";
    LanguageFullEnum[LanguageFullEnum["quz_PE"] = 155] = "quz_PE";
    LanguageFullEnum[LanguageFullEnum["rm_CH"] = 156] = "rm_CH";
    LanguageFullEnum[LanguageFullEnum["ro_RO"] = 157] = "ro_RO";
    LanguageFullEnum[LanguageFullEnum["ru_RU"] = 158] = "ru_RU";
    LanguageFullEnum[LanguageFullEnum["rw_RW"] = 159] = "rw_RW";
    LanguageFullEnum[LanguageFullEnum["sah_RU"] = 160] = "sah_RU";
    LanguageFullEnum[LanguageFullEnum["sa_IN"] = 161] = "sa_IN";
    LanguageFullEnum[LanguageFullEnum["se_FI"] = 162] = "se_FI";
    LanguageFullEnum[LanguageFullEnum["se_NO"] = 163] = "se_NO";
    LanguageFullEnum[LanguageFullEnum["se_SE"] = 164] = "se_SE";
    LanguageFullEnum[LanguageFullEnum["si_LK"] = 165] = "si_LK";
    LanguageFullEnum[LanguageFullEnum["sk_SK"] = 166] = "sk_SK";
    LanguageFullEnum[LanguageFullEnum["sl_SI"] = 167] = "sl_SI";
    LanguageFullEnum[LanguageFullEnum["sma_NO"] = 168] = "sma_NO";
    LanguageFullEnum[LanguageFullEnum["sma_SE"] = 169] = "sma_SE";
    LanguageFullEnum[LanguageFullEnum["smj_NO"] = 170] = "smj_NO";
    LanguageFullEnum[LanguageFullEnum["smj_SE"] = 171] = "smj_SE";
    LanguageFullEnum[LanguageFullEnum["smn_FI"] = 172] = "smn_FI";
    LanguageFullEnum[LanguageFullEnum["sms_FI"] = 173] = "sms_FI";
    LanguageFullEnum[LanguageFullEnum["sq_AL"] = 174] = "sq_AL";
    LanguageFullEnum[LanguageFullEnum["sr_Cyrl_BA"] = 175] = "sr_Cyrl_BA";
    LanguageFullEnum[LanguageFullEnum["sr_Cyrl_CS"] = 176] = "sr_Cyrl_CS";
    LanguageFullEnum[LanguageFullEnum["sr_Cyrl_ME"] = 177] = "sr_Cyrl_ME";
    LanguageFullEnum[LanguageFullEnum["sr_Cyrl_RS"] = 178] = "sr_Cyrl_RS";
    LanguageFullEnum[LanguageFullEnum["sr_Latn_BA"] = 179] = "sr_Latn_BA";
    LanguageFullEnum[LanguageFullEnum["sr_Latn_CS"] = 180] = "sr_Latn_CS";
    LanguageFullEnum[LanguageFullEnum["sr_Latn_ME"] = 181] = "sr_Latn_ME";
    LanguageFullEnum[LanguageFullEnum["sr_Latn_RS"] = 182] = "sr_Latn_RS";
    LanguageFullEnum[LanguageFullEnum["sv_FI"] = 183] = "sv_FI";
    LanguageFullEnum[LanguageFullEnum["sv_SE"] = 184] = "sv_SE";
    LanguageFullEnum[LanguageFullEnum["sw_KE"] = 185] = "sw_KE";
    LanguageFullEnum[LanguageFullEnum["syr_SY"] = 186] = "syr_SY";
    LanguageFullEnum[LanguageFullEnum["ta_IN"] = 187] = "ta_IN";
    LanguageFullEnum[LanguageFullEnum["te_IN"] = 188] = "te_IN";
    LanguageFullEnum[LanguageFullEnum["tg_Cyrl_TJ"] = 189] = "tg_Cyrl_TJ";
    LanguageFullEnum[LanguageFullEnum["th_TH"] = 190] = "th_TH";
    LanguageFullEnum[LanguageFullEnum["tk_TM"] = 191] = "tk_TM";
    LanguageFullEnum[LanguageFullEnum["tn_ZA"] = 192] = "tn_ZA";
    LanguageFullEnum[LanguageFullEnum["tr_TR"] = 193] = "tr_TR";
    LanguageFullEnum[LanguageFullEnum["tt_RU"] = 194] = "tt_RU";
    LanguageFullEnum[LanguageFullEnum["tzm_Latn_DZ"] = 195] = "tzm_Latn_DZ";
    LanguageFullEnum[LanguageFullEnum["ug_CN"] = 196] = "ug_CN";
    LanguageFullEnum[LanguageFullEnum["uk_UA"] = 197] = "uk_UA";
    LanguageFullEnum[LanguageFullEnum["ur_PK"] = 198] = "ur_PK";
    LanguageFullEnum[LanguageFullEnum["uz_Cyrl_UZ"] = 199] = "uz_Cyrl_UZ";
    LanguageFullEnum[LanguageFullEnum["uz_Latn_UZ"] = 200] = "uz_Latn_UZ";
    LanguageFullEnum[LanguageFullEnum["vi_VN"] = 201] = "vi_VN";
    LanguageFullEnum[LanguageFullEnum["wo_SN"] = 202] = "wo_SN";
    LanguageFullEnum[LanguageFullEnum["xh_ZA"] = 203] = "xh_ZA";
    LanguageFullEnum[LanguageFullEnum["yo_NG"] = 204] = "yo_NG";
    LanguageFullEnum[LanguageFullEnum["zh_CN"] = 205] = "zh_CN";
    LanguageFullEnum[LanguageFullEnum["zh_HK"] = 206] = "zh_HK";
    LanguageFullEnum[LanguageFullEnum["zh_MO"] = 207] = "zh_MO";
    LanguageFullEnum[LanguageFullEnum["zh_SG"] = 208] = "zh_SG";
    LanguageFullEnum[LanguageFullEnum["zh_TW"] = 209] = "zh_TW";
    LanguageFullEnum[LanguageFullEnum["zu_ZA"] = 210] = "zu_ZA";
})(LanguageFullEnum || (LanguageFullEnum = {}));

var SortTypeEnum;
(function (SortTypeEnum) {
    SortTypeEnum[SortTypeEnum["Descending"] = 0] = "Descending";
    SortTypeEnum[SortTypeEnum["Ascending"] = 1] = "Ascending";
    SortTypeEnum[SortTypeEnum["Random"] = 2] = "Random";
})(SortTypeEnum || (SortTypeEnum = {}));

var TransactionBankStatusEnum;
(function (TransactionBankStatusEnum) {
    TransactionBankStatusEnum[TransactionBankStatusEnum["None"] = 0] = "None";
    TransactionBankStatusEnum[TransactionBankStatusEnum["Error"] = 1] = "Error";
    TransactionBankStatusEnum[TransactionBankStatusEnum["Paid"] = 2] = "Paid";
    TransactionBankStatusEnum[TransactionBankStatusEnum["Pending"] = 3] = "Pending";
    TransactionBankStatusEnum[TransactionBankStatusEnum["Confirmed"] = 4] = "Confirmed";
    TransactionBankStatusEnum[TransactionBankStatusEnum["DeniedConfirmed"] = 5] = "DeniedConfirmed";
})(TransactionBankStatusEnum || (TransactionBankStatusEnum = {}));

var TransactionRecordStatusEnum;
(function (TransactionRecordStatusEnum) {
    TransactionRecordStatusEnum[TransactionRecordStatusEnum["None"] = 0] = "None";
    TransactionRecordStatusEnum[TransactionRecordStatusEnum["SendUserToBank"] = 1] = "SendUserToBank";
    TransactionRecordStatusEnum[TransactionRecordStatusEnum["BackUserFromBank"] = 2] = "BackUserFromBank";
    TransactionRecordStatusEnum[TransactionRecordStatusEnum["TransactionCheck"] = 3] = "TransactionCheck";
    TransactionRecordStatusEnum[TransactionRecordStatusEnum["TransactionSuccessful"] = 4] = "TransactionSuccessful";
    TransactionRecordStatusEnum[TransactionRecordStatusEnum["TransactionFailed"] = 5] = "TransactionFailed";
    TransactionRecordStatusEnum[TransactionRecordStatusEnum["GeneratStampValues"] = 6] = "GeneratStampValues";
    TransactionRecordStatusEnum[TransactionRecordStatusEnum["TimestampOk"] = 7] = "TimestampOk";
    TransactionRecordStatusEnum[TransactionRecordStatusEnum["TimestampError"] = 8] = "TimestampError";
    TransactionRecordStatusEnum[TransactionRecordStatusEnum["SendUserToBankOk"] = 9] = "SendUserToBankOk";
    TransactionRecordStatusEnum[TransactionRecordStatusEnum["SendUserToBankError"] = 10] = "SendUserToBankError";
    TransactionRecordStatusEnum[TransactionRecordStatusEnum["BackUserFromBankOk"] = 11] = "BackUserFromBankOk";
    TransactionRecordStatusEnum[TransactionRecordStatusEnum["BackUserFromBankError"] = 12] = "BackUserFromBankError";
    TransactionRecordStatusEnum[TransactionRecordStatusEnum["TransactionShopInvoiceReleaseCheck"] = 13] = "TransactionShopInvoiceReleaseCheck";
})(TransactionRecordStatusEnum || (TransactionRecordStatusEnum = {}));

var BuildStatusTypeEnum;
(function (BuildStatusTypeEnum) {
    BuildStatusTypeEnum[BuildStatusTypeEnum["BuildOrder"] = 1] = "BuildOrder";
    BuildStatusTypeEnum[BuildStatusTypeEnum["BuildMSMQAdd"] = 2] = "BuildMSMQAdd";
    BuildStatusTypeEnum[BuildStatusTypeEnum["BuildMSMQAddError"] = 3] = "BuildMSMQAddError";
    BuildStatusTypeEnum[BuildStatusTypeEnum["BuildMSMQRead"] = 4] = "BuildMSMQRead";
    BuildStatusTypeEnum[BuildStatusTypeEnum["BuildMSMQRun"] = 5] = "BuildMSMQRun";
    BuildStatusTypeEnum[BuildStatusTypeEnum["BuildError"] = 6] = "BuildError";
    BuildStatusTypeEnum[BuildStatusTypeEnum["BuildSuccessfully"] = 7] = "BuildSuccessfully";
    BuildStatusTypeEnum[BuildStatusTypeEnum["BuildUnsuccessfully"] = 8] = "BuildUnsuccessfully";
    BuildStatusTypeEnum[BuildStatusTypeEnum["BuildMSMQRunNowBuildTempPathCreate"] = 9] = "BuildMSMQRunNowBuildTempPathCreate";
    BuildStatusTypeEnum[BuildStatusTypeEnum["BuildMSMQRunNowFiledownloaded"] = 10] = "BuildMSMQRunNowFiledownloaded";
    BuildStatusTypeEnum[BuildStatusTypeEnum["BuildMSMQRunNowGitPull"] = 11] = "BuildMSMQRunNowGitPull";
    BuildStatusTypeEnum[BuildStatusTypeEnum["BuildMSMQRunNowBuildStart"] = 12] = "BuildMSMQRunNowBuildStart";
    BuildStatusTypeEnum[BuildStatusTypeEnum["BuildMSMQRunNowBuildEnd"] = 13] = "BuildMSMQRunNowBuildEnd";
    BuildStatusTypeEnum[BuildStatusTypeEnum["BuildMSMQRunNowFileCopy"] = 14] = "BuildMSMQRunNowFileCopy";
    BuildStatusTypeEnum[BuildStatusTypeEnum["CopyAppReleaseToExportApplication"] = 15] = "CopyAppReleaseToExportApplication";
    BuildStatusTypeEnum[BuildStatusTypeEnum["BuildMSMQRunNowBuildDownloadFiles"] = 16] = "BuildMSMQRunNowBuildDownloadFiles";
    BuildStatusTypeEnum[BuildStatusTypeEnum["BuildGitError"] = 17] = "BuildGitError";
    BuildStatusTypeEnum[BuildStatusTypeEnum["BuildUnsuccessfullyButFileNotExist"] = 18] = "BuildUnsuccessfullyButFileNotExist";
    BuildStatusTypeEnum[BuildStatusTypeEnum["BuildSuccessfullyAndCopyAppReleaseToExportApplicationfully"] = 20] = "BuildSuccessfullyAndCopyAppReleaseToExportApplicationfully";
})(BuildStatusTypeEnum || (BuildStatusTypeEnum = {}));

var NotificationTypeEnum;
(function (NotificationTypeEnum) {
    NotificationTypeEnum[NotificationTypeEnum["Message"] = 0] = "Message";
    NotificationTypeEnum[NotificationTypeEnum["Link"] = 1] = "Link";
    NotificationTypeEnum[NotificationTypeEnum["Ads"] = 2] = "Ads";
    NotificationTypeEnum[NotificationTypeEnum["ActionLogin"] = 3] = "ActionLogin";
    NotificationTypeEnum[NotificationTypeEnum["ActionLogout"] = 4] = "ActionLogout";
})(NotificationTypeEnum || (NotificationTypeEnum = {}));

var DeviceStatusEnum;
(function (DeviceStatusEnum) {
    DeviceStatusEnum[DeviceStatusEnum["none"] = 0] = "none";
    DeviceStatusEnum[DeviceStatusEnum["Install"] = 1] = "Install";
    DeviceStatusEnum[DeviceStatusEnum["Uninstall"] = 1] = "Uninstall";
})(DeviceStatusEnum || (DeviceStatusEnum = {}));

var ScheduleCronTypeEnum;
(function (ScheduleCronTypeEnum) {
    ScheduleCronTypeEnum[ScheduleCronTypeEnum["None"] = 0] = "None";
    ScheduleCronTypeEnum[ScheduleCronTypeEnum["Once"] = 1] = "Once";
    ScheduleCronTypeEnum[ScheduleCronTypeEnum["Hourly"] = 2] = "Hourly";
    ScheduleCronTypeEnum[ScheduleCronTypeEnum["Daily"] = 3] = "Daily";
    ScheduleCronTypeEnum[ScheduleCronTypeEnum["Weekly"] = 4] = "Weekly";
    ScheduleCronTypeEnum[ScheduleCronTypeEnum["Monthly"] = 5] = "Monthly";
    ScheduleCronTypeEnum[ScheduleCronTypeEnum["Yearly"] = 6] = "Yearly";
})(ScheduleCronTypeEnum || (ScheduleCronTypeEnum = {}));

var UserActivateTypesEnum;
(function (UserActivateTypesEnum) {
    UserActivateTypesEnum[UserActivateTypesEnum["ConfirmEmail"] = 0] = "ConfirmEmail";
    UserActivateTypesEnum[UserActivateTypesEnum["ConfirmMobile"] = 1] = "ConfirmMobile";
    UserActivateTypesEnum[UserActivateTypesEnum["RegisterByMobile"] = 2] = "RegisterByMobile";
    UserActivateTypesEnum[UserActivateTypesEnum["RegisterByEmail"] = 3] = "RegisterByEmail";
    UserActivateTypesEnum[UserActivateTypesEnum["ForgetPasswordByEmail"] = 4] = "ForgetPasswordByEmail";
    UserActivateTypesEnum[UserActivateTypesEnum["ForgetPasswordByMobile"] = 5] = "ForgetPasswordByMobile";
})(UserActivateTypesEnum || (UserActivateTypesEnum = {}));

var HyperShopPaymentTypeEnum;
(function (HyperShopPaymentTypeEnum) {
    HyperShopPaymentTypeEnum[HyperShopPaymentTypeEnum["none"] = 0] = "none";
    HyperShopPaymentTypeEnum[HyperShopPaymentTypeEnum["Online"] = 1] = "Online";
    HyperShopPaymentTypeEnum[HyperShopPaymentTypeEnum["OnPLace"] = 2] = "OnPLace";
    HyperShopPaymentTypeEnum[HyperShopPaymentTypeEnum["OnlineAndOnPlace"] = 3] = "OnlineAndOnPlace";
})(HyperShopPaymentTypeEnum || (HyperShopPaymentTypeEnum = {}));

var HyperShopOrderTypeEnum;
(function (HyperShopOrderTypeEnum) {
    HyperShopOrderTypeEnum[HyperShopOrderTypeEnum["Open"] = 0] = "Open";
    HyperShopOrderTypeEnum[HyperShopOrderTypeEnum["Payment"] = 1] = "Payment";
    HyperShopOrderTypeEnum[HyperShopOrderTypeEnum["StartDelivery"] = 2] = "StartDelivery";
    HyperShopOrderTypeEnum[HyperShopOrderTypeEnum["InDelivery"] = 3] = "InDelivery";
    HyperShopOrderTypeEnum[HyperShopOrderTypeEnum["EndDelivery"] = 4] = "EndDelivery";
    HyperShopOrderTypeEnum[HyperShopOrderTypeEnum["Close"] = 10] = "Close";
    HyperShopOrderTypeEnum[HyperShopOrderTypeEnum["Deleted"] = 11] = "Deleted";
})(HyperShopOrderTypeEnum || (HyperShopOrderTypeEnum = {}));

var HyperShopConnectionTypeEnum;
(function (HyperShopConnectionTypeEnum) {
    HyperShopConnectionTypeEnum[HyperShopConnectionTypeEnum["None"] = 0] = "None";
    HyperShopConnectionTypeEnum[HyperShopConnectionTypeEnum["Api"] = 1] = "Api";
    HyperShopConnectionTypeEnum[HyperShopConnectionTypeEnum["Application"] = 2] = "Application";
})(HyperShopConnectionTypeEnum || (HyperShopConnectionTypeEnum = {}));

var CmsSiteMenuAreaTypeEnum;
(function (CmsSiteMenuAreaTypeEnum) {
    CmsSiteMenuAreaTypeEnum[CmsSiteMenuAreaTypeEnum["All"] = 0] = "All";
    CmsSiteMenuAreaTypeEnum[CmsSiteMenuAreaTypeEnum["AfterLogin"] = 1] = "AfterLogin";
    CmsSiteMenuAreaTypeEnum[CmsSiteMenuAreaTypeEnum["BeforLogin"] = 2] = "BeforLogin";
})(CmsSiteMenuAreaTypeEnum || (CmsSiteMenuAreaTypeEnum = {}));

var PageAbilityTypeEnum;
(function (PageAbilityTypeEnum) {
    PageAbilityTypeEnum[PageAbilityTypeEnum["None"] = 0] = "None";
    PageAbilityTypeEnum[PageAbilityTypeEnum["Normal"] = 1] = "Normal";
    PageAbilityTypeEnum[PageAbilityTypeEnum["Master"] = 2] = "Master";
})(PageAbilityTypeEnum || (PageAbilityTypeEnum = {}));

var CmsPageUtilityToolsActionEnum;
(function (CmsPageUtilityToolsActionEnum) {
    CmsPageUtilityToolsActionEnum[CmsPageUtilityToolsActionEnum["Info"] = 0] = "Info";
    CmsPageUtilityToolsActionEnum[CmsPageUtilityToolsActionEnum["Run"] = 1] = "Run";
    CmsPageUtilityToolsActionEnum[CmsPageUtilityToolsActionEnum["BackupHtmlValueToExport3"] = 2] = "BackupHtmlValueToExport3";
})(CmsPageUtilityToolsActionEnum || (CmsPageUtilityToolsActionEnum = {}));

var SendSmsStatusTypeEnum;
(function (SendSmsStatusTypeEnum) {
    SendSmsStatusTypeEnum[SendSmsStatusTypeEnum["none"] = 0] = "none";
    SendSmsStatusTypeEnum[SendSmsStatusTypeEnum["Sending"] = 1] = "Sending";
    SendSmsStatusTypeEnum[SendSmsStatusTypeEnum["Sended"] = 2] = "Sended";
    SendSmsStatusTypeEnum[SendSmsStatusTypeEnum["SendParameterError"] = 3] = "SendParameterError";
    SendSmsStatusTypeEnum[SendSmsStatusTypeEnum["SendConnectionError"] = 4] = "SendConnectionError";
    SendSmsStatusTypeEnum[SendSmsStatusTypeEnum["SendServerApiError"] = 5] = "SendServerApiError";
})(SendSmsStatusTypeEnum || (SendSmsStatusTypeEnum = {}));

var FormSubmitedStatusEnum;
(function (FormSubmitedStatusEnum) {
    FormSubmitedStatusEnum[FormSubmitedStatusEnum["none"] = 0] = "none";
    FormSubmitedStatusEnum[FormSubmitedStatusEnum["Success"] = 1] = "Success";
    FormSubmitedStatusEnum[FormSubmitedStatusEnum["Error"] = 2] = "Error";
})(FormSubmitedStatusEnum || (FormSubmitedStatusEnum = {}));

var ManageUserAccessDataTypesEnum;
(function (ManageUserAccessDataTypesEnum) {
    ManageUserAccessDataTypesEnum[ManageUserAccessDataTypesEnum["None"] = 0] = "None";
    ManageUserAccessDataTypesEnum[ManageUserAccessDataTypesEnum["All"] = 1] = "All";
    ManageUserAccessDataTypesEnum[ManageUserAccessDataTypesEnum["Viewer"] = 2] = "Viewer";
    ManageUserAccessDataTypesEnum[ManageUserAccessDataTypesEnum["Editor"] = 3] = "Editor";
})(ManageUserAccessDataTypesEnum || (ManageUserAccessDataTypesEnum = {}));

var SiteStatusEnum;
(function (SiteStatusEnum) {
    SiteStatusEnum[SiteStatusEnum["Active"] = 1] = "Active";
    SiteStatusEnum[SiteStatusEnum["Inactive"] = 2] = "Inactive";
    SiteStatusEnum[SiteStatusEnum["Maintenance"] = 3] = "Maintenance";
    SiteStatusEnum[SiteStatusEnum["AllowedUser"] = 4] = "AllowedUser";
})(SiteStatusEnum || (SiteStatusEnum = {}));

var ErrorTypeEnum;
(function (ErrorTypeEnum) {
    ErrorTypeEnum[ErrorTypeEnum["None"] = 0] = "None";
    ErrorTypeEnum[ErrorTypeEnum["UserAuthenticationFail"] = 1] = "UserAuthenticationFail";
    ErrorTypeEnum[ErrorTypeEnum["BusinessFail"] = 2] = "BusinessFail";
    ErrorTypeEnum[ErrorTypeEnum["ApplicationError"] = 3] = "ApplicationError";
    ErrorTypeEnum[ErrorTypeEnum["NotFound"] = 4] = "NotFound";
    ErrorTypeEnum[ErrorTypeEnum["ValueInjected"] = 5] = "ValueInjected";
    ErrorTypeEnum[ErrorTypeEnum["SaveChangesisZero"] = 6] = "SaveChangesisZero";
    ErrorTypeEnum[ErrorTypeEnum["CurrentSiteId"] = 7] = "CurrentSiteId";
    ErrorTypeEnum[ErrorTypeEnum["BusinessFailAccessRowAdd"] = 8] = "BusinessFailAccessRowAdd";
    ErrorTypeEnum[ErrorTypeEnum["BusinessFailAccessRowDelete"] = 9] = "BusinessFailAccessRowDelete";
    ErrorTypeEnum[ErrorTypeEnum["BusinessFailAccessRowEdit"] = 10] = "BusinessFailAccessRowEdit";
    ErrorTypeEnum[ErrorTypeEnum["BusinessFailAccessRowWatch"] = 11] = "BusinessFailAccessRowWatch";
    ErrorTypeEnum[ErrorTypeEnum["BusinessFailDemoAccessRowAdd"] = 12] = "BusinessFailDemoAccessRowAdd";
    ErrorTypeEnum[ErrorTypeEnum["BusinessFailDemoAccessRowDelete"] = 13] = "BusinessFailDemoAccessRowDelete";
    ErrorTypeEnum[ErrorTypeEnum["BusinessFailDemoAccessRowUpdate"] = 14] = "BusinessFailDemoAccessRowUpdate";
    ErrorTypeEnum[ErrorTypeEnum["DeleteContentByChildForbid"] = 15] = "DeleteContentByChildForbid";
    ErrorTypeEnum[ErrorTypeEnum["SaveChangesisError"] = 16] = "SaveChangesisError";
    ErrorTypeEnum[ErrorTypeEnum["IPAddressAccessDinay"] = 17] = "IPAddressAccessDinay";
    ErrorTypeEnum[ErrorTypeEnum["File_handlingfile"] = 18] = "File_handlingfile";
    ErrorTypeEnum[ErrorTypeEnum["Core_ErrorId_edit_pagemaster"] = 19] = "Core_ErrorId_edit_pagemaster";
    ErrorTypeEnum[ErrorTypeEnum["Core_Loop_creation_error_between_parent_and_child"] = 20] = "Core_Loop_creation_error_between_parent_and_child";
    ErrorTypeEnum[ErrorTypeEnum["Core_This_module_has_already_been_dedicated_to_this_site"] = 21] = "Core_This_module_has_already_been_dedicated_to_this_site";
    ErrorTypeEnum[ErrorTypeEnum["Core_Page_disabled"] = 22] = "Core_Page_disabled";
    ErrorTypeEnum[ErrorTypeEnum["Article_LinkContentId_null"] = 23] = "Article_LinkContentId_null";
    ErrorTypeEnum[ErrorTypeEnum["Article_LinkCategoryId_Is_Null_Or_Zero"] = 24] = "Article_LinkCategoryId_Is_Null_Or_Zero";
    ErrorTypeEnum[ErrorTypeEnum["Core_Serial_number_is_duplicate"] = 25] = "Core_Serial_number_is_duplicate";
    ErrorTypeEnum[ErrorTypeEnum["Core_Domain_has_already_been_registered"] = 26] = "Core_Domain_has_already_been_registered";
    ErrorTypeEnum[ErrorTypeEnum["Core_Domain_name_or_subdomain_has_been_created"] = 27] = "Core_Domain_name_or_subdomain_has_been_created";
    ErrorTypeEnum[ErrorTypeEnum["Core_Duplicate"] = 28] = "Core_Duplicate";
    ErrorTypeEnum[ErrorTypeEnum["Core_Your_file_has_not_been_uploaded_to_Template"] = 29] = "Core_Your_file_has_not_been_uploaded_to_Template";
    ErrorTypeEnum[ErrorTypeEnum["Advertisement_This_ad_has_already_been_registered_for_this_property"] = 30] = "Advertisement_This_ad_has_already_been_registered_for_this_property";
    ErrorTypeEnum[ErrorTypeEnum["Core__Site_User_Already_Exists"] = 31] = "Core__Site_User_Already_Exists";
    ErrorTypeEnum[ErrorTypeEnum["Core_Username_has_been_used_for_another_user"] = 32] = "Core_Username_has_been_used_for_another_user";
    ErrorTypeEnum[ErrorTypeEnum["Core_Only_Admin_Can_Delete_User"] = 33] = "Core_Only_Admin_Can_Delete_User";
    ErrorTypeEnum[ErrorTypeEnum["Core_Enter_username"] = 34] = "Core_Enter_username";
    ErrorTypeEnum[ErrorTypeEnum["Core_Enter_the_password"] = 35] = "Core_Enter_the_password";
    ErrorTypeEnum[ErrorTypeEnum["Core_Acceess_to_register_this_site"] = 36] = "Core_Acceess_to_register_this_site";
    ErrorTypeEnum[ErrorTypeEnum["Core_User_group_not_found"] = 37] = "Core_User_group_not_found";
    ErrorTypeEnum[ErrorTypeEnum["Core_The_username_has_already_been_registered_in_the_system"] = 38] = "Core_The_username_has_already_been_registered_in_the_system";
    ErrorTypeEnum[ErrorTypeEnum["Core_ErrorService_Entity_Check_Decision_Before_Add"] = 39] = "Core_ErrorService_Entity_Check_Decision_Before_Add";
    ErrorTypeEnum[ErrorTypeEnum["Service_Content_not_selected_correctly"] = 40] = "Service_Content_not_selected_correctly";
    ErrorTypeEnum[ErrorTypeEnum["Service_LinkCategoryId_Is_Null_Or_Zero"] = 41] = "Service_LinkCategoryId_Is_Null_Or_Zero";
    ErrorTypeEnum[ErrorTypeEnum["ApiTelegram_Your_access_number_for_making_baht_has_expired"] = 42] = "ApiTelegram_Your_access_number_for_making_baht_has_expired";
    ErrorTypeEnum[ErrorTypeEnum["ApiTelegram_This_profile_has_already_been_registered"] = 43] = "ApiTelegram_This_profile_has_already_been_registered";
    ErrorTypeEnum[ErrorTypeEnum["Shop_There_is_a_duplicate_item"] = 44] = "Shop_There_is_a_duplicate_item";
    ErrorTypeEnum[ErrorTypeEnum["ImageGallery_Content_not_selected_correctly"] = 45] = "ImageGallery_Content_not_selected_correctly";
    ErrorTypeEnum[ErrorTypeEnum["Biography_Content_not_selected_correctly"] = 46] = "Biography_Content_not_selected_correctly";
    ErrorTypeEnum[ErrorTypeEnum["Blog_Content_not_selected_correctly"] = 47] = "Blog_Content_not_selected_correctly";
    ErrorTypeEnum[ErrorTypeEnum["Chart_Content_not_selected_correctly"] = 48] = "Chart_Content_not_selected_correctly";
    ErrorTypeEnum[ErrorTypeEnum["MovieGallery_Content_not_selected_correctly"] = 49] = "MovieGallery_Content_not_selected_correctly";
    ErrorTypeEnum[ErrorTypeEnum["Product_Content_not_selected_correctly"] = 50] = "Product_Content_not_selected_correctly";
    ErrorTypeEnum[ErrorTypeEnum["MusicGallery_Content_not_selected_correctly"] = 51] = "MusicGallery_Content_not_selected_correctly";
    ErrorTypeEnum[ErrorTypeEnum["Biography_LinkCategoryId_Is_Null_Or_Zero"] = 52] = "Biography_LinkCategoryId_Is_Null_Or_Zero";
    ErrorTypeEnum[ErrorTypeEnum["Blog_LinkCategoryId_Is_Null_Or_Zero"] = 53] = "Blog_LinkCategoryId_Is_Null_Or_Zero";
    ErrorTypeEnum[ErrorTypeEnum["Chart_LinkCategoryId_Is_Null_Or_Zero"] = 54] = "Chart_LinkCategoryId_Is_Null_Or_Zero";
    ErrorTypeEnum[ErrorTypeEnum["ImageGallery_The_file_is_duplicate"] = 55] = "ImageGallery_The_file_is_duplicate";
    ErrorTypeEnum[ErrorTypeEnum["ImageGallery_The_relevant_category_was_not_found"] = 56] = "ImageGallery_The_relevant_category_was_not_found";
    ErrorTypeEnum[ErrorTypeEnum["MovieGallery_The_file_is_duplicate"] = 57] = "MovieGallery_The_file_is_duplicate";
    ErrorTypeEnum[ErrorTypeEnum["MovieGallery_The_relevant_category_was_not_found"] = 58] = "MovieGallery_The_relevant_category_was_not_found";
    ErrorTypeEnum[ErrorTypeEnum["News_Content_not_selected_correctly"] = 59] = "News_Content_not_selected_correctly";
    ErrorTypeEnum[ErrorTypeEnum["Product_LinkCategoryId_Is_Null_Or_Zero"] = 60] = "Product_LinkCategoryId_Is_Null_Or_Zero";
    ErrorTypeEnum[ErrorTypeEnum["Polling_The_number_of_votes_allowed_for_a_poll_can_not_exceed_the_number_of_votes"] = 61] = "Polling_The_number_of_votes_allowed_for_a_poll_can_not_exceed_the_number_of_votes";
    ErrorTypeEnum[ErrorTypeEnum["Polling_The_relevant_category_was_not_found"] = 62] = "Polling_The_relevant_category_was_not_found";
    ErrorTypeEnum[ErrorTypeEnum["News_LinkCategoryId_Is_Null_Or_Zero"] = 63] = "News_LinkCategoryId_Is_Null_Or_Zero";
    ErrorTypeEnum[ErrorTypeEnum["Shop_The_relevant_category_was_not_found"] = 64] = "Shop_The_relevant_category_was_not_found";
    ErrorTypeEnum[ErrorTypeEnum["Job_This_ad_has_already_been_registered_for_this_property"] = 65] = "Job_This_ad_has_already_been_registered_for_this_property";
    ErrorTypeEnum[ErrorTypeEnum["Ticket_Dupplicate_Data"] = 66] = "Ticket_Dupplicate_Data";
    ErrorTypeEnum[ErrorTypeEnum["Job_LinkParentId_is_invalid"] = 67] = "Job_LinkParentId_is_invalid";
    ErrorTypeEnum[ErrorTypeEnum["Shop_To_create_an_invoice_the_site_user_or_system_user_must_be_specified"] = 68] = "Shop_To_create_an_invoice_the_site_user_or_system_user_must_be_specified";
    ErrorTypeEnum[ErrorTypeEnum["Shop_It_is_not_known_to_create_a_vendor_website_invoice"] = 69] = "Shop_It_is_not_known_to_create_a_vendor_website_invoice";
    ErrorTypeEnum[ErrorTypeEnum["Member_Vertical_values_are_empty"] = 70] = "Member_Vertical_values_are_empty";
    ErrorTypeEnum[ErrorTypeEnum["bankPeyment_The_unit_factor_of_the_store_should_be_greater_than_zero"] = 71] = "bankPeyment_The_unit_factor_of_the_store_should_be_greater_than_zero";
    ErrorTypeEnum[ErrorTypeEnum["Vehicle_This_ad_has_already_been_registered_for_this_property"] = 72] = "Vehicle_This_ad_has_already_been_registered_for_this_property";
    ErrorTypeEnum[ErrorTypeEnum["Workflow_LinkParentId_is_not_from_the_current_site"] = 73] = "Workflow_LinkParentId_is_not_from_the_current_site";
    ErrorTypeEnum[ErrorTypeEnum["Resrvation_Please_enter_the_date"] = 74] = "Resrvation_Please_enter_the_date";
    ErrorTypeEnum[ErrorTypeEnum["Resrvation_This_has_already_been_booked"] = 75] = "Resrvation_This_has_already_been_booked";
    ErrorTypeEnum[ErrorTypeEnum["Resrvation_The_expiration_date_of_this_reservation_has_expired"] = 76] = "Resrvation_The_expiration_date_of_this_reservation_has_expired";
    ErrorTypeEnum[ErrorTypeEnum["News_Entries_can_not_be_connected"] = 77] = "News_Entries_can_not_be_connected";
    ErrorTypeEnum[ErrorTypeEnum["Estate_This_ad_has_already_been_registered_for_this_property"] = 78] = "Estate_This_ad_has_already_been_registered_for_this_property";
    ErrorTypeEnum[ErrorTypeEnum["Discount_DiscountGroup_Is_Null"] = 79] = "Discount_DiscountGroup_Is_Null";
    ErrorTypeEnum[ErrorTypeEnum["Discount_This_Card_Deactivated"] = 80] = "Discount_This_Card_Deactivated";
    ErrorTypeEnum[ErrorTypeEnum["Discount_This_Card_Has_Sold"] = 81] = "Discount_This_Card_Has_Sold";
    ErrorTypeEnum[ErrorTypeEnum["Discount_This_Owner_Card_Is_Diffrent"] = 82] = "Discount_This_Owner_Card_Is_Diffrent";
    ErrorTypeEnum[ErrorTypeEnum["Reservation_The_date_has_already_been_registered"] = 83] = "Reservation_The_date_has_already_been_registered";
    ErrorTypeEnum[ErrorTypeEnum["Discount_Duplicate_PersonSeller"] = 84] = "Discount_Duplicate_PersonSeller";
    ErrorTypeEnum[ErrorTypeEnum["Discount_Please_Enter_Person_Information"] = 85] = "Discount_Please_Enter_Person_Information";
    ErrorTypeEnum[ErrorTypeEnum["Chat_Vertical_values_are_empty"] = 86] = "Chat_Vertical_values_are_empty";
    ErrorTypeEnum[ErrorTypeEnum["File_Loop_creation_error_between_parent_and_child"] = 87] = "File_Loop_creation_error_between_parent_and_child";
    ErrorTypeEnum[ErrorTypeEnum["Application_Your_access_number_for_making_baht_has_expired"] = 88] = "Application_Your_access_number_for_making_baht_has_expired";
    ErrorTypeEnum[ErrorTypeEnum["ExpireDateValue"] = 89] = "ExpireDateValue";
    ErrorTypeEnum[ErrorTypeEnum["UserTicketIsNull"] = 90] = "UserTicketIsNull";
    ErrorTypeEnum[ErrorTypeEnum["InputEntityIsNull"] = 91] = "InputEntityIsNull";
    ErrorTypeEnum[ErrorTypeEnum["The_site_can_not_be_your_parent"] = 92] = "The_site_can_not_be_your_parent";
    ErrorTypeEnum[ErrorTypeEnum["ErrorMessage_Reached_Maximum_Capacity"] = 93] = "ErrorMessage_Reached_Maximum_Capacity";
    ErrorTypeEnum[ErrorTypeEnum["The_site_link_is_empty"] = 94] = "The_site_link_is_empty";
    ErrorTypeEnum[ErrorTypeEnum["Folder_not_found"] = 95] = "Folder_not_found";
    ErrorTypeEnum[ErrorTypeEnum["Error_Creating_Folder"] = 96] = "Error_Creating_Folder";
    ErrorTypeEnum[ErrorTypeEnum["File_Not_Find"] = 97] = "File_Not_Find";
    ErrorTypeEnum[ErrorTypeEnum["Your_new_file_has_not_been_uploaded_correctly"] = 98] = "Your_new_file_has_not_been_uploaded_correctly";
    ErrorTypeEnum[ErrorTypeEnum["Shop_Invoice_not_found"] = 99] = "Shop_Invoice_not_found";
    ErrorTypeEnum[ErrorTypeEnum["FilteringQuery_Force_To_Null_query_Incorect_FilterModel"] = 100] = "FilteringQuery_Force_To_Null_query_Incorect_FilterModel";
    ErrorTypeEnum[ErrorTypeEnum["You_do_not_have_enough_access_to_this_operation"] = 101] = "You_do_not_have_enough_access_to_this_operation";
    ErrorTypeEnum[ErrorTypeEnum["You_do_not_have_access_levels_for_serial_registration_of_other_sites"] = 102] = "You_do_not_have_access_levels_for_serial_registration_of_other_sites";
    ErrorTypeEnum[ErrorTypeEnum["Error_replacing_file_on_server"] = 103] = "Error_replacing_file_on_server";
    ErrorTypeEnum[ErrorTypeEnum["Section_not_found_for_get_tickets"] = 104] = "Section_not_found_for_get_tickets";
    ErrorTypeEnum[ErrorTypeEnum["This_series_has_already_been_activated_for_you"] = 105] = "This_series_has_already_been_activated_for_you";
    ErrorTypeEnum[ErrorTypeEnum["This_serial_is_disabled"] = 106] = "This_serial_is_disabled";
    ErrorTypeEnum[ErrorTypeEnum["The_duration_of_the_use_of_this_series_has_been_completed"] = 107] = "The_duration_of_the_use_of_this_series_has_been_completed";
    ErrorTypeEnum[ErrorTypeEnum["The_allowed_number_of_this_series_is_over"] = 108] = "The_allowed_number_of_this_series_is_over";
    ErrorTypeEnum[ErrorTypeEnum["Site_not_selected"] = 109] = "Site_not_selected";
    ErrorTypeEnum[ErrorTypeEnum["Modules_list_is_empty"] = 110] = "Modules_list_is_empty";
    ErrorTypeEnum[ErrorTypeEnum["Website_Specifications_is_empty"] = 111] = "Website_Specifications_is_empty";
    ErrorTypeEnum[ErrorTypeEnum["Website_domain_Specification_is_empty"] = 112] = "Website_domain_Specification_is_empty";
    ErrorTypeEnum[ErrorTypeEnum["Website_type_not_selected"] = 113] = "Website_type_not_selected";
    ErrorTypeEnum[ErrorTypeEnum["Web_management_properties_are_empty"] = 114] = "Web_management_properties_are_empty";
    ErrorTypeEnum[ErrorTypeEnum["Username_is_not_logged_in_webmaster"] = 115] = "Username_is_not_logged_in_webmaster";
    ErrorTypeEnum[ErrorTypeEnum["Web_admin_password_not_logged"] = 116] = "Web_admin_password_not_logged";
    ErrorTypeEnum[ErrorTypeEnum["Your_requested_access_type_was_not_found"] = 117] = "Your_requested_access_type_was_not_found";
    ErrorTypeEnum[ErrorTypeEnum["Your_requested_website_type_was_not_found"] = 118] = "Your_requested_website_type_was_not_found";
    ErrorTypeEnum[ErrorTypeEnum["This_domain_has_already_been_registered_with_this_subdomain"] = 119] = "This_domain_has_already_been_registered_with_this_subdomain";
    ErrorTypeEnum[ErrorTypeEnum["This_domain_has_already_been_registered"] = 120] = "This_domain_has_already_been_registered";
    ErrorTypeEnum[ErrorTypeEnum["This_domain_has_already_been_registered_with_Alice_Domain_with_this_subdomain"] = 121] = "This_domain_has_already_been_registered_with_Alice_Domain_with_this_subdomain";
    ErrorTypeEnum[ErrorTypeEnum["This_domain_has_already_been_registered_with_Alice_Damien"] = 122] = "This_domain_has_already_been_registered_with_Alice_Damien";
    ErrorTypeEnum[ErrorTypeEnum["User_not_found"] = 123] = "User_not_found";
    ErrorTypeEnum[ErrorTypeEnum["The_account_has_expired_Contact_management"] = 124] = "The_account_has_expired_Contact_management";
    ErrorTypeEnum[ErrorTypeEnum["The_account_is_inactive_status_Contact_management"] = 125] = "The_account_is_inactive_status_Contact_management";
    ErrorTypeEnum[ErrorTypeEnum["The_account_is_in_the_status_of_deletion_Contact_management"] = 126] = "The_account_is_in_the_status_of_deletion_Contact_management";
    ErrorTypeEnum[ErrorTypeEnum["A_link_to_your_email_address_has_been_sent"] = 127] = "A_link_to_your_email_address_has_been_sent";
    ErrorTypeEnum[ErrorTypeEnum["Core_oldPassword_IsNullOrEmpty"] = 128] = "Core_oldPassword_IsNullOrEmpty";
    ErrorTypeEnum[ErrorTypeEnum["Core_newPassword_IsNullOrEmpty"] = 129] = "Core_newPassword_IsNullOrEmpty";
    ErrorTypeEnum[ErrorTypeEnum["Core_userTicket_Notfound"] = 130] = "Core_userTicket_Notfound";
    ErrorTypeEnum[ErrorTypeEnum["Core_userTicket_RecordStatus_NotAvailable"] = 131] = "Core_userTicket_RecordStatus_NotAvailable";
    ErrorTypeEnum[ErrorTypeEnum["Core_Password_with_old_password_is_not_equal"] = 132] = "Core_Password_with_old_password_is_not_equal";
    ErrorTypeEnum[ErrorTypeEnum["Core_User_information_not_found"] = 133] = "Core_User_information_not_found";
    ErrorTypeEnum[ErrorTypeEnum["Core_Link_password_reminder_not_found"] = 134] = "Core_Link_password_reminder_not_found";
    ErrorTypeEnum[ErrorTypeEnum["Core_Reminder_link_used_previously_apply_again"] = 135] = "Core_Reminder_link_used_previously_apply_again";
    ErrorTypeEnum[ErrorTypeEnum["Core_User_not_found"] = 136] = "Core_User_not_found";
    ErrorTypeEnum[ErrorTypeEnum["Core_The_account_has_expired_Contact_management"] = 137] = "Core_The_account_has_expired_Contact_management";
    ErrorTypeEnum[ErrorTypeEnum["Core_The_account_is_in_the_status_of_deletion_Contact_management"] = 138] = "Core_The_account_is_in_the_status_of_deletion_Contact_management";
    ErrorTypeEnum[ErrorTypeEnum["Core_The_account_is_inactive_status_Contact_management"] = 139] = "Core_The_account_is_inactive_status_Contact_management";
    ErrorTypeEnum[ErrorTypeEnum["Core_This_site_is_not_in_your_collection"] = 140] = "Core_This_site_is_not_in_your_collection";
    ErrorTypeEnum[ErrorTypeEnum["Core_This_user_has_high_access_and_you_do_not_have_permission_to_login"] = 141] = "Core_This_user_has_high_access_and_you_do_not_have_permission_to_login";
    ErrorTypeEnum[ErrorTypeEnum["Core_Your_account_has_been_disabled_for_1_hour"] = 142] = "Core_Your_account_has_been_disabled_for_1_hour";
    ErrorTypeEnum[ErrorTypeEnum["Core_Username_Or_Password_Incorrect"] = 143] = "Core_Username_Or_Password_Incorrect";
    ErrorTypeEnum[ErrorTypeEnum["Core_Your_account_on_this_website_is_disabled_by_contacting_the_management"] = 144] = "Core_Your_account_on_this_website_is_disabled_by_contacting_the_management";
    ErrorTypeEnum[ErrorTypeEnum["Core_You_have_another_access_type_on_this_website_and_your_requested_access_is_not_possible"] = 145] = "Core_You_have_another_access_type_on_this_website_and_your_requested_access_is_not_possible";
    ErrorTypeEnum[ErrorTypeEnum["Core_This_type_of_access_can_not_be_automatically_added_to_the_sites"] = 146] = "Core_This_type_of_access_can_not_be_automatically_added_to_the_sites";
    ErrorTypeEnum[ErrorTypeEnum["Core_Your_requested_access_type_was_not_found"] = 147] = "Core_Your_requested_access_type_was_not_found";
    ErrorTypeEnum[ErrorTypeEnum["Core_Your_requested_access_type_was_not_added_to_the_system"] = 148] = "Core_Your_requested_access_type_was_not_added_to_the_system";
    ErrorTypeEnum[ErrorTypeEnum["Core_You_do_not_have_an_account_on_this_website"] = 149] = "Core_You_do_not_have_an_account_on_this_website";
    ErrorTypeEnum[ErrorTypeEnum["Core_Activation_Code_is_invalid"] = 150] = "Core_Activation_Code_is_invalid";
    ErrorTypeEnum[ErrorTypeEnum["Core_FilteringQuery_Force_To_Null_query_Incorect_FilterModel"] = 151] = "Core_FilteringQuery_Force_To_Null_query_Incorect_FilterModel";
    ErrorTypeEnum[ErrorTypeEnum["bankPeyment_WebServiceUrl_IsNullOrEmpty"] = 152] = "bankPeyment_WebServiceUrl_IsNullOrEmpty";
    ErrorTypeEnum[ErrorTypeEnum["bankPeyment_ResCode"] = 153] = "bankPeyment_ResCode";
    ErrorTypeEnum[ErrorTypeEnum["bankPeyment_webServiceTimestamp"] = 154] = "bankPeyment_webServiceTimestamp";
    ErrorTypeEnum[ErrorTypeEnum["bankPeyment_bankPeymentPayRequest"] = 155] = "bankPeyment_bankPeymentPayRequest";
    ErrorTypeEnum[ErrorTypeEnum["bankPeyment_Error_RedirectInterfaceUrl_IsNullOrEmpty"] = 156] = "bankPeyment_Error_RedirectInterfaceUrl_IsNullOrEmpty";
    ErrorTypeEnum[ErrorTypeEnum["bankPeyment_successful"] = 157] = "bankPeyment_successful";
    ErrorTypeEnum[ErrorTypeEnum["bankPeyment_saleReferenceId_smaller_than_1000"] = 158] = "bankPeyment_saleReferenceId_smaller_than_1000";
    ErrorTypeEnum[ErrorTypeEnum["bankPeyment_RefId_IsNullOrEmpty"] = 159] = "bankPeyment_RefId_IsNullOrEmpty";
    ErrorTypeEnum[ErrorTypeEnum["bankPeyment_saleReferenceId_Is_Ziro"] = 160] = "bankPeyment_saleReferenceId_Is_Ziro";
    ErrorTypeEnum[ErrorTypeEnum["bankPeyment_saleOrderId_Is_Ziro"] = 161] = "bankPeyment_saleOrderId_Is_Ziro";
    ErrorTypeEnum[ErrorTypeEnum["bankPeyment_stampValues_ResCode_not_0"] = 162] = "bankPeyment_stampValues_ResCode_not_0";
    ErrorTypeEnum[ErrorTypeEnum["bankPeyment_requestSaleOrderId_not_stampValuesOrderId"] = 163] = "bankPeyment_requestSaleOrderId_not_stampValuesOrderId";
    ErrorTypeEnum[ErrorTypeEnum["bankPeyment_requestRefId_not_stampValuesRefId"] = 164] = "bankPeyment_requestRefId_not_stampValuesRefId";
    ErrorTypeEnum[ErrorTypeEnum["bankPeyment_WebServiceCheck_is_not_0"] = 165] = "bankPeyment_WebServiceCheck_is_not_0";
    ErrorTypeEnum[ErrorTypeEnum["bankPeyment_TransactionComplete_Is_OK"] = 166] = "bankPeyment_TransactionComplete_Is_OK";
    ErrorTypeEnum[ErrorTypeEnum["bankPeyment_WebServiceComplete"] = 167] = "bankPeyment_WebServiceComplete";
    ErrorTypeEnum[ErrorTypeEnum["bankPeyment_WebServiceTimestamp_Is_O"] = 168] = "bankPeyment_WebServiceTimestamp_Is_O";
    ErrorTypeEnum[ErrorTypeEnum["bankPeyment_WebCallBackUrl_IsNullOrEmpty"] = 169] = "bankPeyment_WebCallBackUrl_IsNullOrEmpty";
    ErrorTypeEnum[ErrorTypeEnum["bankPeyment_TransactionCheck_Is_Ok"] = 170] = "bankPeyment_TransactionCheck_Is_Ok";
    ErrorTypeEnum[ErrorTypeEnum["bankPeyment_RedirectInterfaceUrl_IsNullOrEmpty"] = 171] = "bankPeyment_RedirectInterfaceUrl_IsNullOrEmpty";
    ErrorTypeEnum[ErrorTypeEnum["bankPeyment_request_ResNum_isnot_stampValues_ResNum"] = 172] = "bankPeyment_request_ResNum_isnot_stampValues_ResNum";
    ErrorTypeEnum[ErrorTypeEnum["bankPeyment_RefNum_IsNullOrEmpty"] = 173] = "bankPeyment_RefNum_IsNullOrEmpty";
    ErrorTypeEnum[ErrorTypeEnum["bankPeyment_inputClass_State_Is_Not_Ok"] = 174] = "bankPeyment_inputClass_State_Is_Not_Ok";
    ErrorTypeEnum[ErrorTypeEnum["bankPeyment_verifyTransaction_Value_Differnt_By_Amount"] = 175] = "bankPeyment_verifyTransaction_Value_Differnt_By_Amount";
    ErrorTypeEnum[ErrorTypeEnum["bankPeyment_WebServiceCheck_smaller_than_0"] = 176] = "bankPeyment_WebServiceCheck_smaller_than_0";
    ErrorTypeEnum[ErrorTypeEnum["bankPeyment_inputClass_State_Not_equal_to_100"] = 177] = "bankPeyment_inputClass_State_Not_equal_to_100";
    ErrorTypeEnum[ErrorTypeEnum["bankPeyment_requestStatus_not_ok"] = 178] = "bankPeyment_requestStatus_not_ok";
    ErrorTypeEnum[ErrorTypeEnum["bankPeyment_requestAuthority_not_stampValuesAuthority"] = 179] = "bankPeyment_requestAuthority_not_stampValuesAuthority";
    ErrorTypeEnum[ErrorTypeEnum["bankPeyment_IsNullOrEmpty_inputClassAuthority"] = 180] = "bankPeyment_IsNullOrEmpty_inputClassAuthority";
    ErrorTypeEnum[ErrorTypeEnum["bankPeyment_WebServiceCheck_is_not_100"] = 181] = "bankPeyment_WebServiceCheck_is_not_100";
    ErrorTypeEnum[ErrorTypeEnum["bankPeyment_Success_RefId"] = 182] = "bankPeyment_Success_RefId";
    ErrorTypeEnum[ErrorTypeEnum["bankPeyment_You_do_not_have_enough_access_to_this_operation"] = 183] = "bankPeyment_You_do_not_have_enough_access_to_this_operation";
    ErrorTypeEnum[ErrorTypeEnum["bankPeyment_NTK_Custom_Error_Render_Type_Error"] = 184] = "bankPeyment_NTK_Custom_Error_Render_Type_Error";
    ErrorTypeEnum[ErrorTypeEnum["bankPeyment_NTK_Custom_Error_Render_Cast_Error"] = 185] = "bankPeyment_NTK_Custom_Error_Render_Cast_Error";
    ErrorTypeEnum[ErrorTypeEnum["bankPeyment_Transaction_details_are_empty"] = 186] = "bankPeyment_Transaction_details_are_empty";
    ErrorTypeEnum[ErrorTypeEnum["bankPeyment_Input_value_is_empty"] = 187] = "bankPeyment_Input_value_is_empty";
    ErrorTypeEnum[ErrorTypeEnum["bankPeyment_Bank_profile_is_empty"] = 188] = "bankPeyment_Bank_profile_is_empty";
    ErrorTypeEnum[ErrorTypeEnum["Email_Send_Sucessfull"] = 189] = "Email_Send_Sucessfull";
    ErrorTypeEnum[ErrorTypeEnum["Email_Send_Not_Sucessfull"] = 190] = "Email_Send_Not_Sucessfull";
    ErrorTypeEnum[ErrorTypeEnum["Email_You_do_not_have_enough_access_to_this_operation"] = 191] = "Email_You_do_not_have_enough_access_to_this_operation";
    ErrorTypeEnum[ErrorTypeEnum["Email_Send_path_is_not_specified"] = 192] = "Email_Send_path_is_not_specified";
    ErrorTypeEnum[ErrorTypeEnum["Email_Api_Item_is_null"] = 193] = "Email_Api_Item_is_null";
    ErrorTypeEnum[ErrorTypeEnum["Email_Your_request_is_not_valid"] = 194] = "Email_Your_request_is_not_valid";
    ErrorTypeEnum[ErrorTypeEnum["Email_EmailTask_PrivateSiteConfig_is_null"] = 195] = "Email_EmailTask_PrivateSiteConfig_is_null";
    ErrorTypeEnum[ErrorTypeEnum["Email_EmailTask_PublicConfig_is_null"] = 196] = "Email_EmailTask_PublicConfig_is_null";
    ErrorTypeEnum[ErrorTypeEnum["Email_NTK_Custom_Error_Render_Type_Error"] = 197] = "Email_NTK_Custom_Error_Render_Type_Error";
    ErrorTypeEnum[ErrorTypeEnum["Email_NTK_Custom_Error_Render_Cast_Error"] = 198] = "Email_NTK_Custom_Error_Render_Cast_Error";
    ErrorTypeEnum[ErrorTypeEnum["Application_You_do_not_have_enough_access_to_this_operation"] = 199] = "Application_You_do_not_have_enough_access_to_this_operation";
    ErrorTypeEnum[ErrorTypeEnum["Object_Vertical_values_are_empty"] = 200] = "Object_Vertical_values_are_empty";
    ErrorTypeEnum[ErrorTypeEnum["Shop_There_is_not_enough_inventory"] = 201] = "Shop_There_is_not_enough_inventory";
    ErrorTypeEnum[ErrorTypeEnum["Shop_Invalid_commodity_system_code"] = 202] = "Shop_Invalid_commodity_system_code";
    ErrorTypeEnum[ErrorTypeEnum["ContentBlocked"] = 203] = "ContentBlocked";
    ErrorTypeEnum[ErrorTypeEnum["ContentNeedAdminControl"] = 204] = "ContentNeedAdminControl";
    ErrorTypeEnum[ErrorTypeEnum["ContentNotAvailable"] = 205] = "ContentNotAvailable";
    ErrorTypeEnum[ErrorTypeEnum["ForbidDateSendStart"] = 206] = "ForbidDateSendStart";
    ErrorTypeEnum[ErrorTypeEnum["ForbidDateSendEnd"] = 207] = "ForbidDateSendEnd";
    ErrorTypeEnum[ErrorTypeEnum["NotFoundPrivateSiteConfig"] = 208] = "NotFoundPrivateSiteConfig";
    ErrorTypeEnum[ErrorTypeEnum["TaskScheduler_You_do_not_have_enough_access_to_this_operation"] = 209] = "TaskScheduler_You_do_not_have_enough_access_to_this_operation";
    ErrorTypeEnum[ErrorTypeEnum["CoreSite_Access_to_this_section_is_limited_to_the_entire_system_management"] = 210] = "CoreSite_Access_to_this_section_is_limited_to_the_entire_system_management";
    ErrorTypeEnum[ErrorTypeEnum["Email_Entries_can_not_be_connected"] = 211] = "Email_Entries_can_not_be_connected";
    ErrorTypeEnum[ErrorTypeEnum["Member_LinkMemberUserId_Is_Null"] = 212] = "Member_LinkMemberUserId_Is_Null";
    ErrorTypeEnum[ErrorTypeEnum["Object_LinkMemberUserId_Is_Null"] = 213] = "Object_LinkMemberUserId_Is_Null";
    ErrorTypeEnum[ErrorTypeEnum["Shop_You_do_not_have_enough_access_to_this_operation"] = 214] = "Shop_You_do_not_have_enough_access_to_this_operation";
    ErrorTypeEnum[ErrorTypeEnum["Reservation_Content_not_selected_correctly"] = 215] = "Reservation_Content_not_selected_correctly";
    ErrorTypeEnum[ErrorTypeEnum["Reservation_LinkCategoryId_Is_Null_Or_Zero"] = 216] = "Reservation_LinkCategoryId_Is_Null_Or_Zero";
    ErrorTypeEnum[ErrorTypeEnum["Reservation_Entries_can_not_be_connected"] = 217] = "Reservation_Entries_can_not_be_connected";
    ErrorTypeEnum[ErrorTypeEnum["PermissionIsAuthenticatedFail"] = 218] = "PermissionIsAuthenticatedFail";
    ErrorTypeEnum[ErrorTypeEnum["PermissionIsAuthenticatedDeviceIdFail"] = 219] = "PermissionIsAuthenticatedDeviceIdFail";
    ErrorTypeEnum[ErrorTypeEnum["AntiInjectionToken"] = 220] = "AntiInjectionToken";
    ErrorTypeEnum[ErrorTypeEnum["ErrorLoopContent"] = 221] = "ErrorLoopContent";
    ErrorTypeEnum[ErrorTypeEnum["bankPeyment_Bank_token_is_empty"] = 222] = "bankPeyment_Bank_token_is_empty";
    ErrorTypeEnum[ErrorTypeEnum["LinkManagement_The_site_link_is_empty"] = 223] = "LinkManagement_The_site_link_is_empty";
    ErrorTypeEnum[ErrorTypeEnum["LinkManagement_The_URL_is_not_in_accordance_with_the_URL_format"] = 224] = "LinkManagement_The_URL_is_not_in_accordance_with_the_URL_format";
    ErrorTypeEnum[ErrorTypeEnum["Error_was_successfully_logged"] = 225] = "Error_was_successfully_logged";
    ErrorTypeEnum[ErrorTypeEnum["MemBer_This_Item_has_already_been_registered"] = 226] = "MemBer_This_Item_has_already_been_registered";
    ErrorTypeEnum[ErrorTypeEnum["Member_The_ability_to_move_access_from_a_website_to_another_website_is_not_possible"] = 227] = "Member_The_ability_to_move_access_from_a_website_to_another_website_is_not_possible";
    ErrorTypeEnum[ErrorTypeEnum["Shop_Content_not_selected_correctly"] = 228] = "Shop_Content_not_selected_correctly";
    ErrorTypeEnum[ErrorTypeEnum["Please_Login"] = 229] = "Please_Login";
    ErrorTypeEnum[ErrorTypeEnum["Comment_LinkContentId_null"] = 230] = "Comment_LinkContentId_null";
    ErrorTypeEnum[ErrorTypeEnum["Comment_Text_null"] = 231] = "Comment_Text_null";
    ErrorTypeEnum[ErrorTypeEnum["Comment_Writer_null"] = 232] = "Comment_Writer_null";
    ErrorTypeEnum[ErrorTypeEnum["Content_LinkCategoryId_Is_Null_Or_Zero"] = 233] = "Content_LinkCategoryId_Is_Null_Or_Zero";
    ErrorTypeEnum[ErrorTypeEnum["WebDesigner_The_site_link_is_empty"] = 234] = "WebDesigner_The_site_link_is_empty";
    ErrorTypeEnum[ErrorTypeEnum["WebDesigner_The_URL_is_not_in_accordance_with_the_URL_format"] = 235] = "WebDesigner_The_URL_is_not_in_accordance_with_the_URL_format";
    ErrorTypeEnum[ErrorTypeEnum["Core_Email_Is_Null"] = 236] = "Core_Email_Is_Null";
    ErrorTypeEnum[ErrorTypeEnum["Core_Email_Confermed"] = 237] = "Core_Email_Confermed";
    ErrorTypeEnum[ErrorTypeEnum["Core_Mobile_Is_Null"] = 238] = "Core_Mobile_Is_Null";
    ErrorTypeEnum[ErrorTypeEnum["Core_Mobile_Confermed"] = 239] = "Core_Mobile_Confermed";
    ErrorTypeEnum[ErrorTypeEnum["Core_ActivateCode_Is_Null"] = 240] = "Core_ActivateCode_Is_Null";
    ErrorTypeEnum[ErrorTypeEnum["Exist_Similar_Data"] = 241] = "Exist_Similar_Data";
    ErrorTypeEnum[ErrorTypeEnum["EmptyData"] = 242] = "EmptyData";
    ErrorTypeEnum[ErrorTypeEnum["CaptchaIncorect"] = 243] = "CaptchaIncorect";
    ErrorTypeEnum[ErrorTypeEnum["Core_Not_Find"] = 244] = "Core_Not_Find";
    ErrorTypeEnum[ErrorTypeEnum["Core_InputValueIsNull"] = 245] = "Core_InputValueIsNull";
    ErrorTypeEnum[ErrorTypeEnum["Application_Theme_Is_Null"] = 246] = "Application_Theme_Is_Null";
    ErrorTypeEnum[ErrorTypeEnum["Length_Max"] = 247] = "Length_Max";
    ErrorTypeEnum[ErrorTypeEnum["Ticketing_LinkTaskId_Is_Closed"] = 248] = "Ticketing_LinkTaskId_Is_Closed";
    ErrorTypeEnum[ErrorTypeEnum["Ticketing_LinkTaskId_Is_Null"] = 249] = "Ticketing_LinkTaskId_Is_Null";
    ErrorTypeEnum[ErrorTypeEnum["Ticketing_LinkTaskId_Is_Not_Correct"] = 250] = "Ticketing_LinkTaskId_Is_Not_Correct";
    ErrorTypeEnum[ErrorTypeEnum["Shop_Invoice_Old_Is_Open"] = 251] = "Shop_Invoice_Old_Is_Open";
    ErrorTypeEnum[ErrorTypeEnum["ID_Is_Ziro"] = 252] = "ID_Is_Ziro";
    ErrorTypeEnum[ErrorTypeEnum["LinkParent_is_invalid"] = 253] = "LinkParent_is_invalid";
    ErrorTypeEnum[ErrorTypeEnum["ResultAccessBase_FieldsInfo_IS_NULL"] = 254] = "ResultAccessBase_FieldsInfo_IS_NULL";
    ErrorTypeEnum[ErrorTypeEnum["Donate_The_site_link_is_empty"] = 255] = "Donate_The_site_link_is_empty";
    ErrorTypeEnum[ErrorTypeEnum["Donate_The_URL_is_not_in_accordance_with_the_URL_format"] = 256] = "Donate_The_URL_is_not_in_accordance_with_the_URL_format";
    ErrorTypeEnum[ErrorTypeEnum["Captcha_Need"] = 257] = "Captcha_Need";
    ErrorTypeEnum[ErrorTypeEnum["This_serial_Error_DatePeriodStart"] = 258] = "This_serial_Error_DatePeriodStart";
    ErrorTypeEnum[ErrorTypeEnum["This_serial_Error_DatePeriodEnd"] = 259] = "This_serial_Error_DatePeriodEnd";
    ErrorTypeEnum[ErrorTypeEnum["OnlyAdminAccountAccess"] = 260] = "OnlyAdminAccountAccess";
    ErrorTypeEnum[ErrorTypeEnum["Input_value_is_empty"] = 261] = "Input_value_is_empty";
    ErrorTypeEnum[ErrorTypeEnum["ErrorApi"] = 262] = "ErrorApi";
    ErrorTypeEnum[ErrorTypeEnum["Format_Not_Correct"] = 263] = "Format_Not_Correct";
})(ErrorTypeEnum || (ErrorTypeEnum = {}));

var NotificationModuleTypeEnum;
(function (NotificationModuleTypeEnum) {
    NotificationModuleTypeEnum[NotificationModuleTypeEnum["Core"] = 0] = "Core";
    NotificationModuleTypeEnum[NotificationModuleTypeEnum["hyperShop"] = 1] = "hyperShop";
})(NotificationModuleTypeEnum || (NotificationModuleTypeEnum = {}));

var NotificationConnectionStatusEnum;
(function (NotificationConnectionStatusEnum) {
    NotificationConnectionStatusEnum[NotificationConnectionStatusEnum["Connected"] = 0] = "Connected";
    NotificationConnectionStatusEnum[NotificationConnectionStatusEnum["Diconnect"] = 1] = "Diconnect";
    NotificationConnectionStatusEnum[NotificationConnectionStatusEnum["Standby"] = 2] = "Standby";
})(NotificationConnectionStatusEnum || (NotificationConnectionStatusEnum = {}));

var MicroServiceConnectionStatusEnum;
(function (MicroServiceConnectionStatusEnum) {
    MicroServiceConnectionStatusEnum[MicroServiceConnectionStatusEnum["Connected"] = 0] = "Connected";
    MicroServiceConnectionStatusEnum[MicroServiceConnectionStatusEnum["Diconnect"] = 1] = "Diconnect";
    MicroServiceConnectionStatusEnum[MicroServiceConnectionStatusEnum["Standby"] = 2] = "Standby";
})(MicroServiceConnectionStatusEnum || (MicroServiceConnectionStatusEnum = {}));

var MicroServiceConnectionTypeEnum;
(function (MicroServiceConnectionTypeEnum) {
    MicroServiceConnectionTypeEnum[MicroServiceConnectionTypeEnum["restApi"] = 0] = "restApi";
    MicroServiceConnectionTypeEnum[MicroServiceConnectionTypeEnum["signalr"] = 1] = "signalr";
    MicroServiceConnectionTypeEnum[MicroServiceConnectionTypeEnum["webSoocket"] = 2] = "webSoocket";
})(MicroServiceConnectionTypeEnum || (MicroServiceConnectionTypeEnum = {}));

var MicroServiceModuleTypeEnum;
(function (MicroServiceModuleTypeEnum) {
    MicroServiceModuleTypeEnum[MicroServiceModuleTypeEnum["Core"] = 0] = "Core";
    MicroServiceModuleTypeEnum[MicroServiceModuleTypeEnum["hyperShop"] = 1] = "hyperShop";
})(MicroServiceModuleTypeEnum || (MicroServiceModuleTypeEnum = {}));

var NotificationConnectionTypeEnum;
(function (NotificationConnectionTypeEnum) {
    NotificationConnectionTypeEnum[NotificationConnectionTypeEnum["restApi"] = 0] = "restApi";
    NotificationConnectionTypeEnum[NotificationConnectionTypeEnum["Signalr"] = 1] = "Signalr";
    NotificationConnectionTypeEnum[NotificationConnectionTypeEnum["FireBase"] = 2] = "FireBase";
    NotificationConnectionTypeEnum[NotificationConnectionTypeEnum["WebSoocket"] = 3] = "WebSoocket";
})(NotificationConnectionTypeEnum || (NotificationConnectionTypeEnum = {}));

//@@tag-Version-2201011
class DataFieldInfoModel {
    constructor() {
        this.accessSearchField = false;
        this.accessWatchField = false;
        this.accessEditField = false;
        this.accessAddField = false;
        this.accessExportField = false;
    }
}

//@@tag-Version-2201011
class FieldInfoModel {
}

//@@tag-Version-2201011
class FieldInputDataSourceModel {
}

//@@tag-Version-2201011
class GetPropertiesInfoModel extends FieldInfoModel {
}

//@@tag-Version-2201011
class AccessModel {
    constructor() {
        this.accessDeleteRow = false;
        this.accessWatchRow = false;
        this.accessCountRow = false;
        this.accessEditRow = false;
        this.accessAddRow = false;
        this.accessExportFile = false;
        this.accessRowInPanelDemo = false;
        this.accessRowWatchInSharingCategory = false;
        this.accessWatchRowOtherSiteId = false;
        this.accessWatchRowOtherCreatedBy = false;
        this.accessCountRowOtherSiteId = false;
        this.accessCountRowOtherCreatedBy = false;
        this.accessEditRowOtherSiteId = false;
        this.accessEditRowOtherCreatedBy = false;
        this.accessDeleteRowOtherCreatedBy = false;
    }
}

//@@tag-Version-2201011
class BaseEntity {
    constructor() {
        this.recordStatus = RecordStatusEnum.Available;
        //endregion AniInjection
    }
}

//@@tag-Version-2201011
class BaseModuleEntity extends BaseEntity {
}

//@@tag-Version-2201011
class CaptchaModel {
}

//@@tag-Version-2201011
class InfoEnumModel {
}

//@@tag-Version-2201011
class ErrorExceptionResultBase {
    constructor() {
        this.status = 0;
        this.isSuccess = true;
    }
}

//@@tag-Version-2201011
class ErrorExceptionResult extends ErrorExceptionResultBase {
    constructor() {
        super(...arguments);
        this.access = new AccessModel();
    }
}

//@@tag-Version-2201011
class ErrorExceptionResultExportFile extends ErrorExceptionResultBase {
    constructor() {
        super(...arguments);
        this.status = 0;
        this.isSuccess = true;
    }
}

//@@tag-Version-2201011
class ExportFileModel {
}

//@@tag-Version-2201011
class FilterDataModel {
    constructor() {
        this.filters = new Array();
    }
}

//@@tag-Version-2201011
class FilterModel {
    constructor() {
        this.countLoad = false;
        this.accessLoad = false;
        this.skipRowData = 0;
        this.currentPageNumber = 1;
        this.rowPerPage = 20;
        this.sortType = 1;
        this.filters = new Array();
    }
}

class FormInfoModel {
    constructor() {
        this.formTitle = '';
        this.formDescription = '';
        this.formAlert = '';
        this.formError = '';
        this.formErrorStatus = false;
        this.formSubmitAllow = true;
        this.formSubmitedStatus = FormSubmitedStatusEnum.none;
        this.buttonSubmittedEnabled = true;
        this.viewlodingEnabled = false;
    }
}

class ItemState {
    constructor() {
        this.actionStart = false;
        this.actionEnd = false;
    }
}

class PageModel {
    constructor() {
        this.pageNumber = 0;
        this.size = 20;
    }
}

class SearchTagModel {
}

class ApiServerBase {
    constructor(http, cmsApiStore) {
        this.http = http;
        this.cmsApiStore = cmsApiStore;
        this.baseUrl = 'https://apicms.ir/api/v2/';
        this.userToken = '';
        this.deviceToken = '';
        this.configApiRetry = 0;
        this.keyUserToken = 'userToken';
        this.keyDeviceToken = 'deviceToken';
        this.keyBaseUrl = 'baseUrl';
        this.accessLoad = false;
        this.childConstructor();
        this.headers = new Map();
    }
    setConfig(url, apiRetry = 1) {
        this.baseUrl = url;
        localStorage.setItem(this.keyBaseUrl, url);
        this.configApiRetry = apiRetry;
    }
    childConstructor() {
        // test
    }
    getBaseUrl() {
        const BaseUrl = localStorage.getItem(this.keyBaseUrl);
        if (BaseUrl && BaseUrl.length > 0) {
            return BaseUrl;
        }
        return this.baseUrl;
    }
    getModuleControllerUrl() {
        return 'Empty';
    }
    setHeaders(key, value) {
        this.headers.set(key, value);
    }
    setAccessLoad(status = true) {
        this.accessLoad = status;
    }
    setAccessDataType(status) {
        this.accessDataType = status;
    }
    getUserToken() {
        if (this.userToken && this.userToken.length > 0) {
            return this.userToken;
        }
        const token = localStorage.getItem(this.keyUserToken);
        if (token && token.length > 0) {
            return token;
        }
        const title = 'تایید توکن';
        const message = 'لطفا مجددا وارد حساب کاربری خود شوید';
        return '';
    }
    getDeviceToken() {
        if (this.deviceToken && this.deviceToken.length > 0) {
            return this.deviceToken;
        }
        const token = localStorage.getItem(this.keyDeviceToken);
        if (token && token.length > 0) {
            return token;
        }
        return '';
    }
    setToken(userToken, deviceToken, refreshToken) {
        if ((!userToken || userToken.length === 0) && (!deviceToken || deviceToken.length === 0)) {
            localStorage.removeItem(this.keyUserToken);
            localStorage.removeItem(this.keyDeviceToken);
            return;
        }
        localStorage.setItem(this.keyUserToken, userToken);
        if (deviceToken && deviceToken.length > 0) {
            localStorage.setItem(this.keyDeviceToken, deviceToken);
        }
        // localStorage.setItem('refreshToken', refreshToken);
    }
    removeToken() {
        localStorage.removeItem(this.keyUserToken);
        localStorage.removeItem(this.keyDeviceToken);
    }
    getHeaders() {
        /*Authorization*/
        if (this.getUserToken() && this.getUserToken().length > 1) {
            this.headers.set('Authorization', this.getUserToken());
        }
        else if (this.headers.has('Authorization')) {
            this.headers.delete('Authorization');
        }
        /*DeviceToken*/
        if (this.getDeviceToken() && this.getDeviceToken().length > 1) {
            this.headers.set('DeviceToken', this.getDeviceToken());
        }
        else if (this.headers.has('DeviceToken')) {
            this.headers.delete('DeviceToken');
        }
        /*AccessLoad*/
        if (this.accessLoad) {
            this.headers.set('AccessLoad', 'true');
        }
        else if (this.headers.has('AccessLoad')) {
            this.headers.delete('AccessLoad');
        }
        /*AccessDataType*/
        if (this.accessDataType) {
            this.headers.set('AccessDataType', this.accessDataType.toString());
        }
        else if (this.headers.has('AccessDataType')) {
            this.headers.delete('AccessDataType');
        }
        const retOut = Object.create(null);
        for (const [k, v] of this.headers) {
            retOut[k] = v; // look out! Key must be a string!
        }
        return retOut;
    }
    errorExceptionResultCheck(model) {
        if (model) {
            if (!model.isSuccess) {
                const title = 'خطا در دریافت اطلاعات از سرور';
                const message = model.errorMessage;
            }
        }
        return model;
    }
    errorExceptionResultBaseCheck(model) {
        if (model) {
            if (!model.isSuccess) {
                const title = 'خطا در دریافت اطلاعات از سرور';
                const message = model.errorMessage;
            }
        }
        // this.loadingStatus=false;
        return model;
    }
    errorExceptionResultCheckExportFile(model) {
        if (model) {
            if (!model.isSuccess) {
                const title = 'خطا در دریافت اطلاعات از سرور';
                const message = model.errorMessage;
            }
        }
        // this.loadingStatus=false;
        return model;
    }
    handleError(error, caught) {
        let errorMessage = error.message;
        if (error && error.status) {
            // server-side error
            errorMessage = `Cms Error Code: ${error.status}\nMessage: ${error.message}`;
            if (error.status === 401 || error.status === '401') {
                const title = 'خطای امنیتی';
                const message = 'لطفا مجدد وارد سیستم شود';
            }
        }
        else if (error.error instanceof ErrorEvent) {
            // client-side error
            errorMessage = `Cms Error: ${error.error.message}`;
        }
        return throwError(errorMessage);
    }
}
ApiServerBase.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApiServerBase, deps: [{ token: HttpClient }, { token: NtkCmsApiStoreService }], target: i0.ɵɵFactoryTarget.Injectable });
ApiServerBase.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApiServerBase });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApiServerBase, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i2.HttpClient, decorators: [{
                    type: Inject,
                    args: [HttpClient]
                }] }, { type: NtkCmsApiStoreService }]; } });

class ApiServerConfigSiteBase extends ApiServerBase {
    getModuleControllerUrl() {
        return 'Empty';
    }
    ServiceSiteConfigDefault() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + 'Configuration/SiteConfigDefault', {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceSiteConfigDefaultSave(model) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + 'Configuration/SiteConfigDefault', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceSiteStorage(id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + 'Configuration/SiteStorage/' + id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceSiteStorageSave(Siteid, model) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + 'Configuration/SiteStorage/' + Siteid, model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceSiteConfig(id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + 'Configuration/SiteConfig/' + id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceSiteConfigSave(Siteid, model) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + 'Configuration/SiteConfig/' + Siteid, model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceSiteAccess(Siteid) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + 'Configuration/SiteAccess/' + Siteid, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceSiteAccessSave(Siteid, model) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + 'Configuration/SiteAccess/' + Siteid, model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceSiteAccessDefault() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + 'Configuration/SiteAccessDefault/', {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceSiteAccessDefaultSave(model) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + 'Configuration/SiteAccessDefault/', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceAdminMain() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + 'Configuration/AdminMain/', {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceAdminMainSave(model) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + 'Configuration/AdminMain/', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceCheckSite(id = 0) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + 'Configuration/CheckSite/' + id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceCheckUser(id = 0) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + 'Configuration/CheckUser/' + id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}

class CoreConfigurationService extends ApiServerConfigSiteBase {
    getModuleControllerUrl() {
        return 'Core';
    }
    ServiceUserMembershipRule() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + 'Configuration/UserMembershipRule', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceIp() {
        return this.http
            .get(this.getBaseUrl() + 'ip', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return ret;
        }));
    }
}
CoreConfigurationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreConfigurationService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreConfigurationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreConfigurationService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreConfigurationService, decorators: [{
            type: Injectable
        }] });

class ApiCmsServerBase extends ApiServerBase {
    ServiceViewModel() {
        // this.loadingStatus=true;
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/ViewModel', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceReportFileGetAll() {
        // this.loadingStatus=true;
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/ReportFileGetAll', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAll(model) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/getAll', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllEditor(model) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/getAllEditor', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetOneById(id) {
        // this.loadingStatus=true;
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/' + id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetCount(model) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/Count', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceSetStatus(id, recordStatus) {
        // this.loadingStatus=true;
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/SetStatus/' + id + "/" + recordStatus, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetExist(model) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/exist', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceExportFile(model) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/ExportFile', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheckExportFile(ret);
        }));
    }
    ServiceExportFileGetOne(id, model) {
        // this.loadingStatus=true;
        if (model == null) {
            model = new ExportFileModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/ExportFile/' + id, model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheckExportFile(ret);
        }));
    }
    ServiceAdd(model) {
        // this.loadingStatus=true;
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceEdit(model) {
        // this.loadingStatus=true;
        return this.http
            .put(this.getBaseUrl() + this.getModuleControllerUrl() + '/', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceDelete(id) {
        // this.loadingStatus=true;
        return this.http
            .delete(this.getBaseUrl() + this.getModuleControllerUrl() + '/' + id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceDeleteList(ids) {
        // this.loadingStatus=true;
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/DeleteList', ids, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceDeleteEntity(model) {
        // this.loadingStatus=true;
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/delete', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceMemoAdd(model) {
        // this.loadingStatus=true;
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/MemoAdd', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceMemoDelete(id) {
        // this.loadingStatus=true;
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/MemoDelete/' + id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceMemoGetAll() {
        // this.loadingStatus=true;
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/MemoGetAll/', {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceMemoGetAllEntity(id) {
        // this.loadingStatus=true;
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/MemoGetAll/' + id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    /**comment */
    ServiceCommentAdd(model) {
        // this.loadingStatus=true;
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/CommentAdd', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceCommentDelete(id) {
        // this.loadingStatus=true;
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/CommentDelete/' + id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceCommentGetAll() {
        // this.loadingStatus=true;
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/CommentGetAll/', {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceCommentGetAllEntity(id) {
        // this.loadingStatus=true;
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/CommentGetAll/' + id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    /**comment */
    ServiceShowKeyAdd(model) {
        // this.loadingStatus=true;
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/ShowKeyAdd', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceShowKeyGetAll(id) {
        // this.loadingStatus=true;
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/ShowKeyGetAll/' + id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
ApiCmsServerBase.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApiCmsServerBase, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ApiCmsServerBase.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApiCmsServerBase });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApiCmsServerBase, decorators: [{
            type: Injectable
        }] });

class EditStepDtoModel {
}

class CoreCpMainMenuService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreCpMainMenu';
    }
    ServiceGetAllTree(model) {
        if (model == null) {
            model = new FilterModel();
        }
        model.rowPerPage = 200;
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllTree', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllMenu(model) {
        if (model == null) {
            model = new FilterModel();
        }
        model.rowPerPage = 200;
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllMenu', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            // if (ret.item != null) {
            //   this.coreCpMainMenu.next(ret.listItems);
            // }
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceEditStep(model) {
        if (!model) {
            model = new EditStepDtoModel();
        }
        return this.http
            .put(this.getBaseUrl() + this.getModuleControllerUrl() + '/EditStep', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
}
CoreCpMainMenuService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreCpMainMenuService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreCpMainMenuService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreCpMainMenuService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreCpMainMenuService, decorators: [{
            type: Injectable
        }] });

class CoreCpMainMenuCmsUserGroupService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreCpMainMenuCmsUserGroup';
    }
}
CoreCpMainMenuCmsUserGroupService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreCpMainMenuCmsUserGroupService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreCpMainMenuCmsUserGroupService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreCpMainMenuCmsUserGroupService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreCpMainMenuCmsUserGroupService, decorators: [{
            type: Injectable
        }] });

class CoreEnumService extends ApiServerBase {
    getModuleControllerUrl() {
        return 'CoreEnum';
    }
    ServiceRecordStatusEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/RecordStatusEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceLocationTypeEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/LocationTypeEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceUserLanguageEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/UserLanguageEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ////
    // EnumUserLanguage
    ////
    ServiceGenderEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/GenderEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceMenuPlaceTypeEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/MenuPlaceTypeEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceSiteStatusEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/SiteStatusEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGenderTypeEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/GenderTypeEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceCmsSiteMenuAreaTypeEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/CmsSiteMenuAreaTypeEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceLanguageEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/LanguageEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceDeviceTypeEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/DeviceTypeEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceOperatingSystemTypeEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/OperatingSystemTypeEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceManageUserAccessAreaTypesEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/ManageUserAccessAreaTypesEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceManageUserAccessUserTypesEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/ManageUserAccessUserTypesEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceSendSmsStatusTypeEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/SendSmsStatusTypeEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceCmsModuleSaleItemTypeEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/CmsModuleSaleItemTypeEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceReportFileTypeEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/ReportFileTypeEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceUserClaimKindsEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/UserClaimKindsEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceUserClaimGroupActionTypeEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/UserClaimGroupActionTypeEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceInputDataTypeEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/InputDataTypeEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
CoreEnumService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreEnumService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreEnumService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreEnumService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreEnumService, decorators: [{
            type: Injectable
        }] });

class CoreGuideService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreGuide';
    }
    ServiceGetAllTree(model) {
        if (model == null) {
            model = new FilterModel();
        }
        model.rowPerPage = 200;
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllTree', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceEditStep(model) {
        if (!model) {
            model = new EditStepDtoModel();
        }
        return this.http
            .put(this.getBaseUrl() + this.getModuleControllerUrl() + '/EditStep', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceGetOneByKey(key) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/key/' + key, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
CoreGuideService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreGuideService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreGuideService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreGuideService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreGuideService, decorators: [{
            type: Injectable
        }] });

class CoreCurrencyService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreCurrency';
    }
}
CoreCurrencyService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreCurrencyService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreCurrencyService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreCurrencyService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreCurrencyService, decorators: [{
            type: Injectable
        }] });

class CoreLocationService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreLocation';
    }
    ServiceGetOneIncludeChild(id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetOneIncludeChild/' + id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetOneIncludeParent(id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetOneIncludeParent/' + id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllTree(model) {
        if (model == null) {
            model = new FilterModel();
        }
        model.rowPerPage = 200;
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllTree', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllProvinces(model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllProvinces', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllCities(model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllCities', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllNeighbourhoods(model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllNeighbourhoods', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllCountry(model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllCountry', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
CoreLocationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreLocationService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreLocationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreLocationService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreLocationService, decorators: [{
            type: Injectable
        }] });

class CoreModuleService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreModule';
    }
    ServiceEditStep(model) {
        if (!model) {
            model = new EditStepDtoModel();
        }
        return this.http
            .put(this.getBaseUrl() + this.getModuleControllerUrl() + '/EditStep', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceAutoAdd() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/AutoAdd/', {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceConfig(MoudleClassName) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/Config/', MoudleClassName, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetOneWithModuleConfig(model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetOneWithModuleConfig/', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetViewModelWithModuleConfig(id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetViewModelWithModuleConfig/' + id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllModuleName(model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllModuleName/', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllByCategorySiteId(CategorySiteId, model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllByCategorySiteId/' + CategorySiteId, model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
CoreModuleService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreModuleService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleService, decorators: [{
            type: Injectable
        }] });

class CoreModuleEntityService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreModuleEntity';
    }
    ServiceAutoAdd() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/AutoAdd/', {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
CoreModuleEntityService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleEntityService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreModuleEntityService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleEntityService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleEntityService, decorators: [{
            type: Injectable
        }] });

class CoreModuleEntityReportFileService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreModuleEntityReportFile';
    }
}
CoreModuleEntityReportFileService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleEntityReportFileService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreModuleEntityReportFileService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleEntityReportFileService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleEntityReportFileService, decorators: [{
            type: Injectable
        }] });

class CoreModuleProcessService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreModuleProcess';
    }
    ServiceAutoAdd() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/AutoAdd/', {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetOneWithJsonFormatter(model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetOneWithJsonFormatter/', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllWithJsonFormatter(model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithJsonFormatter/', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
CoreModuleProcessService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleProcessService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreModuleProcessService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleProcessService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleProcessService, decorators: [{
            type: Injectable
        }] });

class CoreModuleProcessCustomizeService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreModuleProcessCustomize';
    }
}
CoreModuleProcessCustomizeService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleProcessCustomizeService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreModuleProcessCustomizeService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleProcessCustomizeService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleProcessCustomizeService, decorators: [{
            type: Injectable
        }] });

class CoreModuleSiteService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreModuleSite';
    }
    ServiceConfigSite(model) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/ConfigSite', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceEditConfigSite(model) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/EditConfigSite', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllById(id, model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAll/' + id, model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
CoreModuleSiteService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleSiteService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreModuleSiteService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleSiteService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleSiteService, decorators: [{
            type: Injectable
        }] });

class CoreSiteService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreSite';
    }
    ServiceModuleDataOptimaze(linkSiteId) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/DataOptimaze/' + linkSiteId, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceModuleDataInfo(linkSiteId) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/DataInfo/' + linkSiteId, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceWebScreenshot(model) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/WebScreenshot', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetRessellerChart(linkSiteId) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetRessellerChart/' + linkSiteId, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceCurrectSite() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/CurrectSite', {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceSupportSite() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/SupportSite', {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceAddFirstSite(model) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/AddFirstSite', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllWithAlias(model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithAlias', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllChildWithAlias(model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllChildWithAlias', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceSearchNew(model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/SearchNew', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceSearch(model) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/Search', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetCurrencyMaster() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetCurrencyMaster', {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetCurrencySite() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetCurrencySite', {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetShareInfo() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetShareInfo', {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetCurrentDomain() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetCurrentDomain', {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetRegDomains(siteCategoryId) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetRegDomains/' + siteCategoryId, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
CoreSiteService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreSiteService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreSiteService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreSiteService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreSiteService, decorators: [{
            type: Injectable
        }] });

class CoreSiteCategoryService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreSiteCategory';
    }
}
CoreSiteCategoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreSiteCategoryService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreSiteCategoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreSiteCategoryService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreSiteCategoryService, decorators: [{
            type: Injectable
        }] });

class CoreSiteCategoryCmsModuleService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreSiteCategoryCmsModule';
    }
}
CoreSiteCategoryCmsModuleService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreSiteCategoryCmsModuleService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreSiteCategoryCmsModuleService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreSiteCategoryCmsModuleService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreSiteCategoryCmsModuleService, decorators: [{
            type: Injectable
        }] });

class CoreSiteDomainAliasService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreSiteDomainAlias';
    }
}
CoreSiteDomainAliasService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreSiteDomainAliasService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreSiteDomainAliasService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreSiteDomainAliasService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreSiteDomainAliasService, decorators: [{
            type: Injectable
        }] });

class CoreSiteUserService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreSiteUser';
    }
    ServiceGetAllSiteCurrentUser() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllSiteCurrentUser', {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
CoreSiteUserService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreSiteUserService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreSiteUserService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreSiteUserService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreSiteUserService, decorators: [{
            type: Injectable
        }] });

//@@tag-Version-2201011
class CoreUserModel extends BaseEntity {
}

class CoreUserService extends ApiCmsServerBase {
    constructor() {
        super(...arguments);
        this.CurrentUser = new BehaviorSubject(new CoreUserModel());
        this.CurrentUserObs = this.CurrentUser.asObservable();
    }
    getModuleControllerUrl() {
        return 'CoreUser';
    }
    ServiceGetRessellerChart(linkUserId) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetRessellerChart/' + linkUserId, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    SetCurrentUser(model) {
        if (model == null) {
            model = new CoreUserModel();
        }
        this.CurrentUser.next(model);
    }
    ServiceCurrectUser() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/CurrentUser', {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            this.SetCurrentUser(ret.item);
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetGlobalToken(model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetGlobalToken', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
CoreUserService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreUserService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreUserService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreUserService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreUserService, decorators: [{
            type: Injectable
        }] });

class CoreUserGroupService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreUserGroup';
    }
}
CoreUserGroupService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreUserGroupService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreUserGroupService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreUserGroupService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreUserGroupService, decorators: [{
            type: Injectable
        }] });

class CoreDeviceService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreDevice';
    }
}
CoreDeviceService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreDeviceService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreDeviceService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreDeviceService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreDeviceService, decorators: [{
            type: Injectable
        }] });

class CoreUserSupportAccessService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreUserSupportAccess';
    }
}
CoreUserSupportAccessService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreUserSupportAccessService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreUserSupportAccessService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreUserSupportAccessService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreUserSupportAccessService, decorators: [{
            type: Injectable
        }] });

class CoreModuleCheckSerialForSiteDtoModel {
}

class CoreModuleSaleSerialService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreModuleSaleSerial';
    }
    ServiceCheckUseSerialForSite(model) {
        if (!model) {
            model = new CoreModuleCheckSerialForSiteDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/CheckUseSerialForSite', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceRegisterUseSerialForSite(model) {
        if (!model) {
            model = new CoreModuleCheckSerialForSiteDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/RegisterUseSerialForSite', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
CoreModuleSaleSerialService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleSaleSerialService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreModuleSaleSerialService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleSaleSerialService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleSaleSerialService, decorators: [{
            type: Injectable
        }] });

class CoreModuleSaleItemService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreModuleSaleItem';
    }
}
CoreModuleSaleItemService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleSaleItemService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreModuleSaleItemService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleSaleItemService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleSaleItemService, decorators: [{
            type: Injectable
        }] });

class CoreModuleSaleInvoiceDetailService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreModuleSaleInvoiceDetail';
    }
}
CoreModuleSaleInvoiceDetailService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleSaleInvoiceDetailService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreModuleSaleInvoiceDetailService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleSaleInvoiceDetailService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleSaleInvoiceDetailService, decorators: [{
            type: Injectable
        }] });

class CoreModuleSaleInvoiceService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreModuleSaleInvoice';
    }
}
CoreModuleSaleInvoiceService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleSaleInvoiceService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreModuleSaleInvoiceService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleSaleInvoiceService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleSaleInvoiceService, decorators: [{
            type: Injectable
        }] });

class CoreModuleSaleHeaderGroupService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreModuleSaleHeaderGroup';
    }
}
CoreModuleSaleHeaderGroupService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleSaleHeaderGroupService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreModuleSaleHeaderGroupService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleSaleHeaderGroupService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleSaleHeaderGroupService, decorators: [{
            type: Injectable
        }] });

class CoreModuleSaleHeaderCalculateDtoModel {
}

class CoreModuleSaleHeaderPaymentDtoModel {
}

class CoreModuleSaleHeaderService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreModuleSaleHeader';
    }
    ServiceGetAllSale(model) {
        if (!model) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllSale', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceCheckUseHeaderForSite(id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/CheckUseHeaderForSite/' + id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceOrderCalculate(model) {
        if (!model) {
            model = new CoreModuleSaleHeaderCalculateDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/OrderCalculate', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceOrderPayment(model) {
        if (!model) {
            model = new CoreModuleSaleHeaderPaymentDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/OrderPayment', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
CoreModuleSaleHeaderService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleSaleHeaderService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreModuleSaleHeaderService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleSaleHeaderService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleSaleHeaderService, decorators: [{
            type: Injectable
        }] });

class CoreUserClaimCheckDtoModel {
}

class CoreUserClaimContentService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreUserClaimContent';
    }
    ServiceClaimCheck(model) {
        if (model == null) {
            model = new CoreUserClaimCheckDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/ClaimCheck', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceClaimCheckCurrent() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/ClaimCheck', {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
CoreUserClaimContentService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreUserClaimContentService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreUserClaimContentService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreUserClaimContentService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreUserClaimContentService, decorators: [{
            type: Injectable
        }] });

class CoreUserClaimGroupService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreUserClaimGroup';
    }
}
CoreUserClaimGroupService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreUserClaimGroupService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreUserClaimGroupService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreUserClaimGroupService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreUserClaimGroupService, decorators: [{
            type: Injectable
        }] });

class CoreUserClaimGroupDetailService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreUserClaimGroupDetail';
    }
}
CoreUserClaimGroupDetailService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreUserClaimGroupDetailService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreUserClaimGroupDetailService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreUserClaimGroupDetailService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreUserClaimGroupDetailService, decorators: [{
            type: Injectable
        }] });

class CoreUserClaimTypeService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreUserClaimType';
    }
}
CoreUserClaimTypeService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreUserClaimTypeService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreUserClaimTypeService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreUserClaimTypeService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreUserClaimTypeService, decorators: [{
            type: Injectable
        }] });

/** */

class CoreLogAvoidDuplicateDataEntryService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreLogAvoidDuplicateDataEntry';
    }
}
CoreLogAvoidDuplicateDataEntryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreLogAvoidDuplicateDataEntryService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreLogAvoidDuplicateDataEntryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreLogAvoidDuplicateDataEntryService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreLogAvoidDuplicateDataEntryService, decorators: [{
            type: Injectable
        }] });

class CoreLogErrorService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreLogError';
    }
}
CoreLogErrorService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreLogErrorService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreLogErrorService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreLogErrorService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreLogErrorService, decorators: [{
            type: Injectable
        }] });

class CoreLogSmsService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreLogSms';
    }
}
CoreLogSmsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreLogSmsService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreLogSmsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreLogSmsService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreLogSmsService, decorators: [{
            type: Injectable
        }] });

class CoreLogCurrencyService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreLogCurrency';
    }
}
CoreLogCurrencyService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreLogCurrencyService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreLogCurrencyService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreLogCurrencyService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreLogCurrencyService, decorators: [{
            type: Injectable
        }] });

class CoreLogMemberService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreLogMember';
    }
}
CoreLogMemberService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreLogMemberService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreLogMemberService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreLogMemberService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreLogMemberService, decorators: [{
            type: Injectable
        }] });

class CoreLogReportDataService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreLogReportData';
    }
}
CoreLogReportDataService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreLogReportDataService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreLogReportDataService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreLogReportDataService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreLogReportDataService, decorators: [{
            type: Injectable
        }] });

class AuthEmailConfirmDtoModel {
}

class AuthMobileConfirmDtoModel {
}

class AuthRenewTokenModel {
}

class AuthUserSignOutModel {
    constructor() {
        this.tokens = new Array();
        this.allToken = false;
    }
}

class CoreAuthService extends ApiServerBase {
    getModuleControllerUrl() {
        return 'auth';
    }
    SetCurrentTokenInfo(model) {
        if (model == null) {
            this.removeToken();
            this.cmsApiStore.setState({ type: SET_TOKEN_INFO, payload: new TokenInfoModel() });
            return;
        }
        if (model.token && model.deviceToken && model.refreshToken) {
            this.setToken(model.token, model.deviceToken, model.refreshToken);
        }
        else if (model.token && model.deviceToken) {
            this.setToken(model.token, model.deviceToken, '');
        }
        else if (model.token) {
            this.setToken(model.token, '', '');
        }
        else if (model.deviceToken) {
            this.setToken('', model.deviceToken, '');
        }
        this.cmsApiStore.setState({ type: SET_TOKEN_INFO, payload: model });
    }
    CurrentTokenInfoRenew() {
        this.ServiceCurrentToken().subscribe((next) => {
            this.SetCurrentTokenInfo(next.item);
        }, (error) => {
        });
    }
    ServiceCurrentToken() {
        return this.http.get(this.getBaseUrl() + this.getModuleControllerUrl() + '/CurrentToken', { headers: this.getHeaders() }).pipe(
        // catchError(this.handleError)
        map((ret) => {
            return ret;
        }));
    }
    ServiceCaptcha() {
        return this.http.get(this.getBaseUrl() + this.getModuleControllerUrl() + '/captcha').pipe(
        // catchError(this.handleError)
        map((ret) => {
            return ret;
        }));
    }
    ServiceGetTokenDevice(model) {
        return this.http.post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetTokenDevice/', model).pipe(
        // catchError(this.handleError)
        map((ret) => {
            if (ret.isSuccess) {
                this.setToken('', ret.deviceToken, '');
            }
            return ret;
        }));
    }
    ServiceSignupUser(model) {
        return this.http.post(this.getBaseUrl() + this.getModuleControllerUrl() + '/signup', model).pipe(
        // catchError(this.handleError)
        map((ret) => {
            return ret;
        }));
    }
    ServiceSigninUser(model) {
        return this.http.post(this.getBaseUrl() + this.getModuleControllerUrl() + '/signin', model).pipe(
        // catchError(this.handleError)
        map((ret) => {
            if (ret.isSuccess) {
                this.SetCurrentTokenInfo(ret.item);
            }
            return ret;
        }));
    }
    ServiceSigninUserBySMS(model) {
        return this.http.post(this.getBaseUrl() + this.getModuleControllerUrl() + '/signInBySms', model).pipe(
        // catchError(this.handleError)
        map((ret) => {
            if (ret.isSuccess) {
                this.SetCurrentTokenInfo(ret.item);
            }
            return ret;
        }));
    }
    ServiceRenewToken(model) {
        if (model == null) {
            model = new AuthRenewTokenModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/renewToken', model, {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            if (ret.isSuccess) {
                this.SetCurrentTokenInfo(ret.item);
            }
            return ret;
        }));
    }
    ServiceChangePassword(model) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/changePassword', model, {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return ret;
        }));
    }
    ServiceForgetPassword(model) {
        return this.http.post(this.getBaseUrl() + this.getModuleControllerUrl() + '/forgetPassword', model).pipe(
        // catchError(this.handleError)
        map((ret) => {
            return ret;
        }));
    }
    ServiceForgetPasswordEntryPinCode(model) {
        return this.http.post(this.getBaseUrl() + this.getModuleControllerUrl() + '/ForgetPasswordEntryPinCode', model).pipe(
        // catchError(this.handleError)
        map((ret) => {
            return ret;
        }));
    }
    ServiceLogout(model = new AuthUserSignOutModel()) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/signOut', model, {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            this.SetCurrentTokenInfo(null);
            return ret;
        }));
    }
    ServiceExistToken(model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/existToken', model, {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return ret;
        }));
    }
    ServiceMobileConfirm(model) {
        if (model == null) {
            model = new AuthMobileConfirmDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/mobileConfirm', model, {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return ret;
        }));
    }
    ServiceEmailConfirm(model) {
        if (model == null) {
            model = new AuthEmailConfirmDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/emailConfirm', model, {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return ret;
        }));
    }
}
CoreAuthService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreAuthService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreAuthService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreAuthService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreAuthService, decorators: [{
            type: Injectable
        }] });

class CoreTokenActivationService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreTokenActivation';
    }
}
CoreTokenActivationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreTokenActivationService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreTokenActivationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreTokenActivationService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreTokenActivationService, decorators: [{
            type: Injectable
        }] });

class CoreTokenUserService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreTokenUser';
    }
}
CoreTokenUserService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreTokenUserService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreTokenUserService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreTokenUserService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreTokenUserService, decorators: [{
            type: Injectable
        }] });

class CoreTokenUserLogService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreTokenUserLog';
    }
}
CoreTokenUserLogService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreTokenUserLogService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreTokenUserLogService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreTokenUserLogService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreTokenUserLogService, decorators: [{
            type: Injectable
        }] });

class CoreTokenUserBadLoginService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreTokenUserBadLogin';
    }
}
CoreTokenUserBadLoginService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreTokenUserBadLoginService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreTokenUserBadLoginService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreTokenUserBadLoginService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreTokenUserBadLoginService, decorators: [{
            type: Injectable
        }] });

class CoreTokenMicroServiceService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreTokenMicroService';
    }
}
CoreTokenMicroServiceService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreTokenMicroServiceService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreTokenMicroServiceService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreTokenMicroServiceService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreTokenMicroServiceService, decorators: [{
            type: Injectable
        }] });

class CoreTokenMicroServiceLogService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreTokenMicroServiceLog';
    }
}
CoreTokenMicroServiceLogService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreTokenMicroServiceLogService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreTokenMicroServiceLogService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreTokenMicroServiceLogService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreTokenMicroServiceLogService, decorators: [{
            type: Injectable
        }] });

class CmsNotificationModel {
}

class CmsNotificationSendDtoModel extends CmsNotificationModel {
}

class CoreTokenNotificationService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreTokenNotification';
    }
    ServiceSendNotification(model) {
        if (!model) {
            model = new CmsNotificationSendDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/SendNotification', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
CoreTokenNotificationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreTokenNotificationService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreTokenNotificationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreTokenNotificationService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreTokenNotificationService, decorators: [{
            type: Injectable
        }] });

class CoreTokenNotificationLogService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreTokenNotificationLog';
    }
}
CoreTokenNotificationLogService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreTokenNotificationLogService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreTokenNotificationLogService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreTokenNotificationLogService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreTokenNotificationLogService, decorators: [{
            type: Injectable
        }] });

//@@tag-Version-2201011
class BaseModuleConfigAdminMainValuesModel {
}

//@@tag-Version-2201011
class BaseModuleConfigSiteAccessValuesModel {
}

//@@tag-Version-2201011
class BaseModuleConfigSiteValuesModel {
}

//@@tag-Version-2201011
class BaseModuleSiteStorageValuesModel {
}

class CoreModuleConfigAdminMainValuesModel extends BaseModuleConfigAdminMainValuesModel {
}
class CoreModuleConfigSiteAccessValuesModel extends BaseModuleConfigSiteAccessValuesModel {
}
/// <summary>
/// با ثبت یک هایپر شاپ باید یک ردیف خام با مقادیر اولیه در بانک ثبت شود
/// این کار باید از سمت سرور انجام شود و کلاینت اجازه ویرایش یا حذف این ردیف را نداشته باشد
/// </summary>
class CoreModuleConfigSiteValuesModel extends BaseModuleConfigSiteValuesModel {
}
class CoreModuleSiteStorageValuesModel extends BaseModuleSiteStorageValuesModel {
}

//@@tag-Version-2201011
class CoreCpMainMenuCmsUserGroupModel extends BaseEntity {
}

//@@tag-Version-2201011
class CoreCpMainMenuModel extends BaseEntity {
}

//@@tag-Version-2201011
class CoreDeviceModel extends BaseEntity {
}

//@@tag-Version-2201011
class CoreGuideModel extends BaseEntity {
}

//@@tag-Version-2201011
class CoreLocationModel extends BaseEntity {
}

//@@tag-Version-2201011
class CoreModuleModel extends BaseEntity {
}

//@@tag-Version-2201011
class CoreModuleEntityModel extends BaseEntity {
}

//@@tag-Version-2201011
class CoreModuleProcessCustomizeModel extends BaseEntity {
}

//@@tag-Version-2201011
class CoreModuleProcessModel extends BaseEntity {
}

//@@tag-Version-2201011
class CoreModuleSiteModel extends BaseEntity {
}

//@@tag-Version-2201011
class CoreSiteCategoryCmsModuleModel extends BaseEntity {
}

//@@tag-Version-2201011
class CoreSiteCategoryModel extends BaseEntity {
}

//@@tag-Version-2201011
class CoreSiteDomainAliasModel extends BaseEntity {
}

//@@tag-Version-2201011
class CoreSiteModel extends BaseEntity {
}

//@@tag-Version-2201011
class CoreSiteUserModel extends BaseEntity {
}

//@@tag-Version-2201011
class CoreUserGroupModel extends BaseEntity {
}

//@@tag-Version-2201011
class CoreModuleSaleHeaderGroupModel extends BaseEntity {
}

//@@tag-Version-2201011
class CoreModuleSaleHeaderModel extends BaseEntity {
}

//@@tag-Version-2201011
class CoreModuleSaleItemModel extends BaseEntity {
}

//@@tag-Version-2201011
class CoreModuleSaleSerialModel extends BaseEntity {
}

//@@tag-Version-2201011
class CoreModuleSaleInvoiceModel extends BaseEntity {
}

//@@tag-Version-2201011
class CoreModuleSaleInvoiceDetailModel extends BaseEntity {
}

//@@tag-Version-2201011
class CoreUserClaimGroupDetailModel extends BaseEntity {
}

//@@tag-Version-2201011
class CoreUserClaimGroupModel extends BaseEntity {
}

//@@tag-Version-2201011
class CoreUserClaimContentModel extends BaseEntity {
}

//@@tag-Version-2201011
class CoreUserClaimTypeModel extends BaseEntity {
}

//@@tag-Version-2201011
class CoreCurrencyModel extends BaseEntity {
}

//@@tag-Version-2201011
class CoreUserSupportAccessModel extends BaseEntity {
    constructor() {
        super(...arguments);
        this.accessDeleteRow = false;
        this.accessWatchRow = false;
        this.accessCountRow = false;
        this.accessEditRow = false;
        this.accessAddRow = false;
        this.accessExportFile = false;
        this.accessWatchRowOtherSiteId = false;
        this.accessWatchRowOtherCreatedBy = false;
        this.accessCountRowOtherSiteId = false;
        this.accessCountRowOtherCreatedBy = false;
        this.accessEditRowOtherSiteId = false;
        this.accessEditRowOtherCreatedBy = false;
        this.accessDeleteRowOtherCreatedBy = false;
    }
}

//@@tag-Version-2201011
class CoreModuleEntityReportFileModel extends BaseEntity {
}

class File360ViewModel {
}

class File360TourHotSpotModel {
}

class File360TourModel {
}

class File360TourScenesModel {
}

class File360TourDefaultModel {
}

class CoreSiteSupportModel {
}

//@@tag-Version-2201011
class BaseModuleSiteCheckSiteModel {
}

//@@tag-Version-2201011
class BaseModuleSiteCheckUserModel {
}

//@@tag-Version-2201011
class CoreLogAvoidDuplicateDataEntryModel extends BaseEntity {
}

//@@tag-Version-2201011
class CoreLogErrorModel extends BaseEntity {
}

//@@tag-Version-2201011
class CoreLogSmsModel extends BaseEntity {
}

//@@tag-Version-2201011
class CoreLogCurrencyModel extends BaseEntity {
}

//@@tag-Version-2201011
class CoreLogMemberModel extends BaseEntity {
}

//@@tag-Version-2212111
class CoreLogReportDataModel extends BaseEntity {
}

//@@tag-Version-2201011
class CoreTokenActivationModel extends BaseEntity {
}

//@@tag-Version-2201011
class CoreTokenUserModel extends BaseEntity {
}

//@@tag-Version-2201011
class CoreTokenUserLogModel extends CoreTokenUserModel {
}

//@@tag-Version-2201011
class CoreTokenUserBadLoginModel extends BaseEntity {
}

//@@tag-Version-2201011
class CoreTokenMicroServiceModel extends BaseEntity {
}

//@@tag-Version-2201011
class CoreTokenMicroServiceLogModel extends CoreTokenMicroServiceModel {
}

//@@tag-Version-2201011
class CoreTokenNotificationModel extends BaseEntity {
}

//@@tag-Version-2201011
class CoreTokenNotificationLogModel extends CoreTokenNotificationModel {
}

//@@tag-Version-2201011
class TokenDeviceModel {
}

class IpModel {
}

class AuthUserSignInModel {
}

class AuthUserChangePasswordModel {
}

class AuthUserForgetPasswordModel {
}

class AuthUserForgetPasswordEntryPinCodeModel {
}

class AuthUserSignUpModel {
}

class CoreSiteAddFirstSiteDtoModel {
}

class TokenDeviceClientInfoDtoModel {
}

class CoreSiteSearchModel {
}

class DomainModel {
}

class ScoreClickDtoModel {
}

class AuthUserSignInBySmsDtoModel {
}

class UniversalActionModel {
}

class CoreUserClaimCheckModel {
    constructor() {
        this.recordStatus = RecordStatusEnum.Available;
    }
}

class ShareInfoModel {
}

class RessellerChartModel {
}

class ProcessModuleSiteDataInfoOutputModel {
}

class ProcessModuleSiteDataRemoveOutputModel {
}

class ProcessModuleSiteDataOptimazeOutputModel {
}

var CmsModuleSaleItemTypeEnum;
(function (CmsModuleSaleItemTypeEnum) {
    CmsModuleSaleItemTypeEnum[CmsModuleSaleItemTypeEnum["SaleOrRenew"] = 0] = "SaleOrRenew";
    CmsModuleSaleItemTypeEnum[CmsModuleSaleItemTypeEnum["OnlyFirstSale"] = 1] = "OnlyFirstSale";
    CmsModuleSaleItemTypeEnum[CmsModuleSaleItemTypeEnum["OnlyReNew"] = 2] = "OnlyReNew";
})(CmsModuleSaleItemTypeEnum || (CmsModuleSaleItemTypeEnum = {}));

var UserClaimKindsEnum;
(function (UserClaimKindsEnum) {
    /// <summary>
    /// کد ملی
    /// </summary>
    UserClaimKindsEnum[UserClaimKindsEnum["NationalId"] = 0] = "NationalId";
    /// <summary>
    /// قرارداد فروش
    /// </summary>
    UserClaimKindsEnum[UserClaimKindsEnum["SaleContract"] = 1] = "SaleContract";
    /// <summary>
    /// شماره موبایل
    /// </summary>
    UserClaimKindsEnum[UserClaimKindsEnum["MobileNumber"] = 2] = "MobileNumber";
    /// <summary>
    /// آدرس ایمیل
    /// </summary>
    UserClaimKindsEnum[UserClaimKindsEnum["EmailAddress"] = 3] = "EmailAddress";
    /// <summary>
    /// شماره حساب
    /// </summary>
    UserClaimKindsEnum[UserClaimKindsEnum["BankAccountNumber"] = 4] = "BankAccountNumber";
    /// <summary>
    /// آدرس یکتای کلاینت
    /// </summary>
    UserClaimKindsEnum[UserClaimKindsEnum["DeviceId"] = 5] = "DeviceId";
    /// <summary>
    /// شماره یکتایی که از نرم افزار حسابداری دریافت می شود
    /// اگر شماره یکتا تغییر کرد بایستی برنامه فروش آنلاین را متوقف کند
    /// </summary>
    UserClaimKindsEnum[UserClaimKindsEnum["AccountingGuidKey"] = 6] = "AccountingGuidKey";
    /// <summary>
    /// شماره حساب بانکی
    /// </summary>
    UserClaimKindsEnum[UserClaimKindsEnum["BankAccountCardNumber"] = 7] = "BankAccountCardNumber";
    /// <summary>
    /// نام شخص
    /// اگر نام شخص با نام شخص در شماره حساب بانکی همخوانی نداشت باید ادعا غیرفعال شود
    /// </summary>
    UserClaimKindsEnum[UserClaimKindsEnum["Name"] = 8] = "Name";
    /// <summary>
    /// نام خانوادگی شخص
    /// مثل نام شخص
    /// </summary>
    UserClaimKindsEnum[UserClaimKindsEnum["Family"] = 9] = "Family";
    /// <summary>
    /// شماره شبا
    /// </summary>
    UserClaimKindsEnum[UserClaimKindsEnum["ISBNCardNumber"] = 10] = "ISBNCardNumber";
    /// <summary>
    /// تصویر چهره کاربر - ممکن است استفاده نشود
    /// </summary>
    UserClaimKindsEnum[UserClaimKindsEnum["UserFaceImage"] = 11] = "UserFaceImage";
    /// <summary>
    /// نام فروشگاه تغییر کند
    /// </summary>
    UserClaimKindsEnum[UserClaimKindsEnum["SiteTitle"] = 12] = "SiteTitle";
    /// <summary>
    /// پروانه کسب و موارد دیگر
    /// </summary>
    UserClaimKindsEnum[UserClaimKindsEnum["UserDocument"] = 13] = "UserDocument";
})(UserClaimKindsEnum || (UserClaimKindsEnum = {}));

var UserClaimGroupActionTypeEnum;
(function (UserClaimGroupActionTypeEnum) {
    UserClaimGroupActionTypeEnum[UserClaimGroupActionTypeEnum["ApproveSharingBankPayment"] = 0] = "ApproveSharingBankPayment";
    UserClaimGroupActionTypeEnum[UserClaimGroupActionTypeEnum["ApproveUserBankPayment"] = 1] = "ApproveUserBankPayment";
})(UserClaimGroupActionTypeEnum || (UserClaimGroupActionTypeEnum = {}));

var PaymentMethodEnum;
(function (PaymentMethodEnum) {
    PaymentMethodEnum[PaymentMethodEnum["Free"] = 1] = "Free";
    PaymentMethodEnum[PaymentMethodEnum["MoneyPay"] = 2] = "MoneyPay";
})(PaymentMethodEnum || (PaymentMethodEnum = {}));

var InputDataTypeEnum;
(function (InputDataTypeEnum) {
    InputDataTypeEnum[InputDataTypeEnum["String"] = 0] = "String";
    InputDataTypeEnum[InputDataTypeEnum["Int"] = 1] = "Int";
    InputDataTypeEnum[InputDataTypeEnum["Boolean"] = 2] = "Boolean";
    InputDataTypeEnum[InputDataTypeEnum["Float"] = 3] = "Float";
    InputDataTypeEnum[InputDataTypeEnum["Date"] = 4] = "Date";
    InputDataTypeEnum[InputDataTypeEnum["TextArea"] = 5] = "TextArea";
})(InputDataTypeEnum || (InputDataTypeEnum = {}));

var DateTypeEnum;
(function (DateTypeEnum) {
    DateTypeEnum[DateTypeEnum["Shamsi"] = 0] = "Shamsi";
    DateTypeEnum[DateTypeEnum["Miladi"] = 1] = "Miladi";
    DateTypeEnum[DateTypeEnum["Ghamari"] = 3] = "Ghamari";
})(DateTypeEnum || (DateTypeEnum = {}));

var ReportFileTypeEnum;
(function (ReportFileTypeEnum) {
    ReportFileTypeEnum[ReportFileTypeEnum["Item"] = 0] = "Item";
    ReportFileTypeEnum[ReportFileTypeEnum["List"] = 1] = "List";
    ReportFileTypeEnum[ReportFileTypeEnum["Chart"] = 3] = "Chart";
})(ReportFileTypeEnum || (ReportFileTypeEnum = {}));

class CoreModuleTagService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreModuleTag';
    }
}
CoreModuleTagService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleTagService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreModuleTagService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleTagService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleTagService, decorators: [{
            type: Injectable
        }] });

class CoreModuleTagCategoryService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreModuleTagCategory';
    }
    ServiceGetAllTree(model) {
        if (model == null) {
            model = new FilterModel();
        }
        model.rowPerPage = 200;
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllTree', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
CoreModuleTagCategoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleTagCategoryService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreModuleTagCategoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleTagCategoryService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleTagCategoryService, decorators: [{
            type: Injectable
        }] });

class CoreModuleSiteCreditCalculateDtoModel {
}

class CoreModuleSiteCreditPaymentDtoModel {
}

class CoreModuleSiteCreditChargeDirectDtoModel {
}

class CoreModuleSiteCreditService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreModuleSiteCredit';
    }
    ServiceGetCredit(LinkModuleId) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetCredit/' + LinkModuleId, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllCredit() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllCredit/', {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceChargeDirect(model) {
        if (!model) {
            model = new CoreModuleSiteCreditChargeDirectDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/ChargeDirect', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceOrderCalculate(model) {
        if (!model) {
            model = new CoreModuleSiteCreditCalculateDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/OrderCalculate', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceOrderPayment(model) {
        if (!model) {
            model = new CoreModuleSiteCreditPaymentDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/OrderPayment', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
CoreModuleSiteCreditService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleSiteCreditService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreModuleSiteCreditService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleSiteCreditService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleSiteCreditService, decorators: [{
            type: Injectable
        }] });

class CoreModuleSiteUserCreditCalculateDtoModel {
}

class CoreModuleSiteUserCreditPaymentDtoModel {
}

class CoreModuleSiteUserCreditChargeDirectDtoModel {
}

class CoreModuleSiteUserCreditService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreModuleSiteUserCredit';
    }
    ServiceGetCredit(LinkModuleId) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetCredit/' + LinkModuleId, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllCredit() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllCredit/', {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceChargeDirect(model) {
        if (!model) {
            model = new CoreModuleSiteUserCreditChargeDirectDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/ChargeDirect', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceOrderCalculate(model) {
        if (!model) {
            model = new CoreModuleSiteUserCreditCalculateDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/OrderCalculate', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceOrderPayment(model) {
        if (!model) {
            model = new CoreModuleSiteUserCreditPaymentDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/OrderPayment', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
CoreModuleSiteUserCreditService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleSiteUserCreditService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreModuleSiteUserCreditService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleSiteUserCreditService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleSiteUserCreditService, decorators: [{
            type: Injectable
        }] });

class CoreModuleSiteAccountingDocumentDetailTypeService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreModuleSiteAccountingDocumentDetailType';
    }
}
CoreModuleSiteAccountingDocumentDetailTypeService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleSiteAccountingDocumentDetailTypeService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreModuleSiteAccountingDocumentDetailTypeService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleSiteAccountingDocumentDetailTypeService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleSiteAccountingDocumentDetailTypeService, decorators: [{
            type: Injectable
        }] });

class CoreModuleSiteAccountingDocumentDetailService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreModuleSiteAccountingDocumentDetail';
    }
}
CoreModuleSiteAccountingDocumentDetailService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleSiteAccountingDocumentDetailService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreModuleSiteAccountingDocumentDetailService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleSiteAccountingDocumentDetailService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleSiteAccountingDocumentDetailService, decorators: [{
            type: Injectable
        }] });

class CoreModuleSiteAccountingDocumentService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreModuleSiteAccountingDocument';
    }
}
CoreModuleSiteAccountingDocumentService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleSiteAccountingDocumentService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreModuleSiteAccountingDocumentService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleSiteAccountingDocumentService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleSiteAccountingDocumentService, decorators: [{
            type: Injectable
        }] });

class CoreModuleRelationshipContentService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreModuleRelationshipContent';
    }
}
CoreModuleRelationshipContentService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleRelationshipContentService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreModuleRelationshipContentService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleRelationshipContentService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleRelationshipContentService, decorators: [{
            type: Injectable
        }] });

class CoreModuleLogScoreService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreModuleLogScore';
    }
}
CoreModuleLogScoreService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleLogScoreService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreModuleLogScoreService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleLogScoreService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleLogScoreService, decorators: [{
            type: Injectable
        }] });

class CoreModuleLogLikeService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreModuleLogLike';
    }
}
CoreModuleLogLikeService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleLogLikeService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreModuleLogLikeService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleLogLikeService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleLogLikeService, decorators: [{
            type: Injectable
        }] });

class CoreModuleFavoriteDtoModel {
}

class CoreModuleLogFavoriteService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreModuleLogFavorite';
    }
    ServiceAddFavorite(model) {
        if (model == null) {
            model = new CoreModuleFavoriteDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/AddFavorite', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceRemoveFavorite(model) {
        if (model == null) {
            model = new CoreModuleFavoriteDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/RemoveFavorite', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
CoreModuleLogFavoriteService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleLogFavoriteService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreModuleLogFavoriteService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleLogFavoriteService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleLogFavoriteService, decorators: [{
            type: Injectable
        }] });

class CoreModuleReportAbuseDtoModel {
}

class CoreModuleLogReportAbuseService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreModuleLogReportAbuse';
    }
    ServiceAddReportAbuse(model) {
        if (model == null) {
            model = new CoreModuleReportAbuseDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/AddReportAbuse', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
CoreModuleLogReportAbuseService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleLogReportAbuseService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreModuleLogReportAbuseService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleLogReportAbuseService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleLogReportAbuseService, decorators: [{
            type: Injectable
        }] });

class CoreModuleShowKeyDtoModel {
}

class CoreModuleLogShowKeyService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreModuleLogShowKey';
    }
    ServiceAddShowKey(model) {
        if (model == null) {
            model = new CoreModuleShowKeyDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/AddShowKey', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
CoreModuleLogShowKeyService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleLogShowKeyService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreModuleLogShowKeyService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleLogShowKeyService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleLogShowKeyService, decorators: [{
            type: Injectable
        }] });

class CoreModuleLogContentCountService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreModuleLogContentCount';
    }
}
CoreModuleLogContentCountService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleLogContentCountService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreModuleLogContentCountService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleLogContentCountService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleLogContentCountService, decorators: [{
            type: Injectable
        }] });

class CoreModuleLogSiteCreditBlockedService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreModuleLogSiteCreditBlocked';
    }
}
CoreModuleLogSiteCreditBlockedService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleLogSiteCreditBlockedService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreModuleLogSiteCreditBlockedService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleLogSiteCreditBlockedService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleLogSiteCreditBlockedService, decorators: [{
            type: Injectable
        }] });

class CoreModuleLogSiteUserCreditBlockedService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreModuleLogSiteUserCreditBlocked';
    }
}
CoreModuleLogSiteUserCreditBlockedService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleLogSiteUserCreditBlockedService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreModuleLogSiteUserCreditBlockedService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleLogSiteUserCreditBlockedService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleLogSiteUserCreditBlockedService, decorators: [{
            type: Injectable
        }] });

class CoreModuleLogSiteCreditService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreModuleLogSiteCredit';
    }
}
CoreModuleLogSiteCreditService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleLogSiteCreditService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreModuleLogSiteCreditService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleLogSiteCreditService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleLogSiteCreditService, decorators: [{
            type: Injectable
        }] });

class CoreModuleLogSiteUserCreditService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreModuleLogSiteUserCredit';
    }
}
CoreModuleLogSiteUserCreditService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleLogSiteUserCreditService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreModuleLogSiteUserCreditService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleLogSiteUserCreditService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleLogSiteUserCreditService, decorators: [{
            type: Injectable
        }] });

class CoreModuleMemoDtoModel {
}

class CoreModuleDataCommentService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreModuleDataComment';
    }
    ServiceAddMemo(model) {
        if (model == null) {
            model = new CoreModuleMemoDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/AddMemo', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
CoreModuleDataCommentService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleDataCommentService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreModuleDataCommentService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleDataCommentService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleDataCommentService, decorators: [{
            type: Injectable
        }] });

class CoreModuleDataMemoService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CoreModuleDataMemo';
    }
    ServiceAddMemo(model) {
        if (model == null) {
            model = new CoreModuleMemoDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/AddMemo', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
CoreModuleDataMemoService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleDataMemoService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CoreModuleDataMemoService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleDataMemoService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CoreModuleDataMemoService, decorators: [{
            type: Injectable
        }] });

//@@tag-Version-2201011
class CoreModuleTagCategoryModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class CoreModuleTagModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class CoreModuleSiteUserCreditModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class CoreModuleSiteCreditModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class CoreModuleSiteAccountingDocumentDetailTypeModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class CoreModuleSiteAccountingDocumentDetailModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class CoreModuleSiteAccountingDocumentModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class CoreModuleRelationshipContentModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class CoreModuleLogFavoriteModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class CoreModuleLogLikeModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class CoreModuleLogScoreModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class CoreModuleLogReportAbuseModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class CoreModuleLogShowKeyModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class CoreModuleLogContentCountModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class CoreModuleLogSiteCreditBlockedModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class CoreModuleLogSiteUserCreditBlockedModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class CoreModuleLogSiteCreditModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class CoreModuleLogSiteUserCreditModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class CoreModuleDataCommentModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class CoreModuleDataMemoModel extends BaseModuleEntity {
}

class CoreModuleCommentDtoModel {
}

class FileConfigurationService extends ApiServerConfigSiteBase {
    getModuleControllerUrl() {
        return 'file';
    }
}
FileConfigurationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FileConfigurationService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
FileConfigurationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FileConfigurationService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FileConfigurationService, decorators: [{
            type: Injectable
        }] });

class FileCategoryService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'FileCategory';
    }
    ServiceGetAllInCategoryById(ParentId) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllInCategoryById/' + ParentId, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceCreateCompressDownload(model) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/CreateCompressDownload/', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceMove(OldId, NewId) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/Move', { Old: OldId, New: NewId }, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceOptimaze() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/Optimaze', {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
FileCategoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FileCategoryService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
FileCategoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FileCategoryService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FileCategoryService, decorators: [{
            type: Injectable
        }] });

//@@tag-Version-2201011
class FileContentModel extends BaseModuleEntity {
}

class FileDownloadDtoModel {
}

class FileContentService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'FileContent';
    }
    ServiceUploadByUrl(model) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/UploadByUrl/', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceCopyCutFile(model) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/CopyCutFile/', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceCopyCutFileRootToRootFolder() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/CopyCutFileRootToRootFolder/', {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceCopy(model) {
        if (model == null) {
            model = new FileContentModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/Copy/', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllInCategoryById(categoryId) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllInCategoryById/' + categoryId, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceSearchFilesInCategory(model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/SearchFilesInCategory', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceDownloadFile(model) {
        if (model == null) {
            model = new FileDownloadDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/DownloadFile', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceUpdateFileSizes(fileId) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/UpdateFileSizes/' + fileId, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceUpdateSumSizeUpload(fileId) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/UpdateSumSizeUpload/' + fileId, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceImageFileEdit(model) {
        if (model == null) {
            model = new FileDownloadDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/ImageFileEdit', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceReplace(model) {
        if (model == null) {
            model = new FileContentModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/replace/', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
FileContentService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FileContentService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
FileContentService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FileContentService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: FileContentService, decorators: [{
            type: Injectable
        }] });

class ModuleConfigAdminMainValuesModel extends BaseModuleConfigAdminMainValuesModel {
}
class ModuleConfigSiteAccessValuesModel extends BaseModuleConfigSiteAccessValuesModel {
}
/// <summary>
/// با ثبت یک هایپر شاپ باید یک ردیف خام با مقادیر اولیه در بانک ثبت شود
/// این کار باید از سمت سرور انجام شود و کلاینت اجازه ویرایش یا حذف این ردیف را نداشته باشد
/// </summary>
class ModuleConfigSiteValuesModel extends BaseModuleConfigSiteValuesModel {
}
class ModuleSiteStorageValuesModel extends BaseModuleSiteStorageValuesModel {
}

//@@tag-Version-2201011
class FileCategoryModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class FileUploadModel {
}

class FileCompressDtoModel {
}

class FileUploadByUrlDtoModel {
}

class FileCopyCutDtoModel {
}

class FileUploadedModel {
}

class LinkManagementConfigurationService extends ApiServerConfigSiteBase {
    getModuleControllerUrl() {
        return 'linkManagement';
    }
}
LinkManagementConfigurationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: LinkManagementConfigurationService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
LinkManagementConfigurationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: LinkManagementConfigurationService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: LinkManagementConfigurationService, decorators: [{
            type: Injectable
        }] });

class LinkManagementEnumService extends ApiServerBase {
    getModuleControllerUrl() {
        return 'LinkManagementEnum';
    }
    ServiceSharingPriceTypeEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/SharingPriceTypeEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceManagementContentSettingTypeEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/ManagementContentSettingTypeEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceSharingAccountingTypeEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/SharingAccountingTypeEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
LinkManagementEnumService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: LinkManagementEnumService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
LinkManagementEnumService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: LinkManagementEnumService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: LinkManagementEnumService, decorators: [{
            type: Injectable
        }] });

class LinkManagementAccountingService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'LinkManagementAccounting';
    }
}
LinkManagementAccountingService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: LinkManagementAccountingService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
LinkManagementAccountingService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: LinkManagementAccountingService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: LinkManagementAccountingService, decorators: [{
            type: Injectable
        }] });

class LinkManagementAccountingDetailService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'LinkManagementAccountingDetail';
    }
}
LinkManagementAccountingDetailService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: LinkManagementAccountingDetailService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
LinkManagementAccountingDetailService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: LinkManagementAccountingDetailService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: LinkManagementAccountingDetailService, decorators: [{
            type: Injectable
        }] });

class LinkManagementBillboardService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'LinkManagementBillboard';
    }
    ServiceGetOneByKey(key) {
        if (!key || key.length === 0) {
            key = '---';
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetOneByKey/', key, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
LinkManagementBillboardService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: LinkManagementBillboardService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
LinkManagementBillboardService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: LinkManagementBillboardService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: LinkManagementBillboardService, decorators: [{
            type: Injectable
        }] });

class LinkManagementBillboardPatternService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'LinkManagementBillboardPattern';
    }
}
LinkManagementBillboardPatternService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: LinkManagementBillboardPatternService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
LinkManagementBillboardPatternService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: LinkManagementBillboardPatternService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: LinkManagementBillboardPatternService, decorators: [{
            type: Injectable
        }] });

class LinkManagementBillboardTargetCategoryService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'LinkManagementBillboardTargetCategory';
    }
}
LinkManagementBillboardTargetCategoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: LinkManagementBillboardTargetCategoryService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
LinkManagementBillboardTargetCategoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: LinkManagementBillboardTargetCategoryService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: LinkManagementBillboardTargetCategoryService, decorators: [{
            type: Injectable
        }] });

class LinkManagementMemberService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'LinkManagementMember';
    }
}
LinkManagementMemberService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: LinkManagementMemberService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
LinkManagementMemberService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: LinkManagementMemberService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: LinkManagementMemberService, decorators: [{
            type: Injectable
        }] });

class LinkManagementTargetShortLinkGetDtoModel {
}

class LinkManagementTargetShortLinkSetDtoModel {
}

class LinkManagementTargetService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'LinkManagementTarget';
    }
    ServiceGetOneByKey(key) {
        if (!key || key.length === 0) {
            key = '---';
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetOneByKey/', key, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceShortLinkSet(model) {
        if (model == null) {
            model = new LinkManagementTargetShortLinkSetDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/ShortLinkSet/', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceShortLinkGet(model) {
        if (model == null) {
            model = new LinkManagementTargetShortLinkGetDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/ShortLinkGet/', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
LinkManagementTargetService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: LinkManagementTargetService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
LinkManagementTargetService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: LinkManagementTargetService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: LinkManagementTargetService, decorators: [{
            type: Injectable
        }] });

class LinkManagementTargetBillboardLogService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'LinkManagementTargetBillboardLog';
    }
    ServiceGetAllByKey(key, model) {
        // this.loadingStatus=true;
        if (model == null) {
            model = new FilterModel();
        }
        if (!key || key.length === 0) {
            key = '---';
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/getAll/' + key, model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
LinkManagementTargetBillboardLogService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: LinkManagementTargetBillboardLogService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
LinkManagementTargetBillboardLogService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: LinkManagementTargetBillboardLogService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: LinkManagementTargetBillboardLogService, decorators: [{
            type: Injectable
        }] });

class LinkManagementTargetCategoryService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'LinkManagementTargetCategory';
    }
}
LinkManagementTargetCategoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: LinkManagementTargetCategoryService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
LinkManagementTargetCategoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: LinkManagementTargetCategoryService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: LinkManagementTargetCategoryService, decorators: [{
            type: Injectable
        }] });

class LinkManagementModuleConfigAdminMainValuesModel extends BaseModuleConfigAdminMainValuesModel {
}
class LinkManagementModuleConfigSiteAccessValuesModel extends BaseModuleConfigSiteAccessValuesModel {
}
/// <summary>
/// با ثبت یک هایپر شاپ باید یک ردیف خام با مقادیر اولیه در بانک ثبت شود
/// این کار باید از سمت سرور انجام شود و کلاینت اجازه ویرایش یا حذف این ردیف را نداشته باشد
/// </summary>
class LinkManagementModuleConfigSiteValuesModel extends BaseModuleConfigSiteValuesModel {
}
class LinkManagementModuleSiteStorageValuesModel extends BaseModuleSiteStorageValuesModel {
}

//@@tag-Version-2201011
class LinkManagementAccountingDetailModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class LinkManagementAccountingModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class LinkManagementBillboardModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class LinkManagementBillboardPatternModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class LinkManagementBillboardTargetCategoryModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class LinkManagementMemberModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class LinkManagementTargetBillboardLogModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class LinkManagementTargetCategoryModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class LinkManagementTargetModel extends BaseModuleEntity {
}

class LinkManagementTargetShortLinkGetResponceModel {
}

class LinkManagementTargetShortLinkSetResponceModel {
}

var ManagementContentSettingTypeEnum;
(function (ManagementContentSettingTypeEnum) {
    ManagementContentSettingTypeEnum[ManagementContentSettingTypeEnum["Rss"] = 0] = "Rss";
    ManagementContentSettingTypeEnum[ManagementContentSettingTypeEnum["Html"] = 1] = "Html";
    ManagementContentSettingTypeEnum[ManagementContentSettingTypeEnum["Banner"] = 2] = "Banner";
    ManagementContentSettingTypeEnum[ManagementContentSettingTypeEnum["VideoBanner"] = 3] = "VideoBanner";
    ManagementContentSettingTypeEnum[ManagementContentSettingTypeEnum["Aparat"] = 4] = "Aparat";
    ManagementContentSettingTypeEnum[ManagementContentSettingTypeEnum["MobileHtml"] = 5] = "MobileHtml";
    ManagementContentSettingTypeEnum[ManagementContentSettingTypeEnum["MobileBanner"] = 6] = "MobileBanner";
    ManagementContentSettingTypeEnum[ManagementContentSettingTypeEnum["MobileVideo"] = 7] = "MobileVideo";
})(ManagementContentSettingTypeEnum || (ManagementContentSettingTypeEnum = {}));

var SharingAccountingTypeEnum;
(function (SharingAccountingTypeEnum) {
    SharingAccountingTypeEnum[SharingAccountingTypeEnum["PaymentDebtor"] = 0] = "PaymentDebtor";
    SharingAccountingTypeEnum[SharingAccountingTypeEnum["PaymentCreditor"] = 1] = "PaymentCreditor";
    SharingAccountingTypeEnum[SharingAccountingTypeEnum["ClickDebtor"] = 2] = "ClickDebtor";
    SharingAccountingTypeEnum[SharingAccountingTypeEnum["ClickCreditor"] = 3] = "ClickCreditor";
    SharingAccountingTypeEnum[SharingAccountingTypeEnum["DiscountDebtor"] = 4] = "DiscountDebtor";
    SharingAccountingTypeEnum[SharingAccountingTypeEnum["DiscountCreditor"] = 5] = "DiscountCreditor";
    SharingAccountingTypeEnum[SharingAccountingTypeEnum["DisplayDebtor"] = 6] = "DisplayDebtor";
    SharingAccountingTypeEnum[SharingAccountingTypeEnum["DisplayCreditor"] = 7] = "DisplayCreditor";
})(SharingAccountingTypeEnum || (SharingAccountingTypeEnum = {}));

var SharingPriceTypeEnum;
(function (SharingPriceTypeEnum) {
    SharingPriceTypeEnum[SharingPriceTypeEnum["PerClickCountAndView"] = 0] = "PerClickCountAndView";
    SharingPriceTypeEnum[SharingPriceTypeEnum["PerClickCount"] = 1] = "PerClickCount";
    SharingPriceTypeEnum[SharingPriceTypeEnum["PerView"] = 2] = "PerView";
})(SharingPriceTypeEnum || (SharingPriceTypeEnum = {}));

class ApiTelegramConfigurationService extends ApiServerConfigSiteBase {
    getModuleControllerUrl() {
        return 'ApiTelegram';
    }
}
ApiTelegramConfigurationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApiTelegramConfigurationService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ApiTelegramConfigurationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApiTelegramConfigurationService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApiTelegramConfigurationService, decorators: [{
            type: Injectable
        }] });

class ApiTelegramBotConfigService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'ApiTelegramBotConfig';
    }
    ServiceSendMessage(model) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/SendMessage', model, { headers: this.getHeaders(), })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceGetUpdatesAsync(id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetUpdatesAsync/' + id, { headers: this.getHeaders(), })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetUpdatesAsyncLast(id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetUpdatesAsyncLast/' + id, { headers: this.getHeaders(), })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetMeAsync(id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetMeAsync/' + id, { headers: this.getHeaders(), })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceSetWebhookAsync(id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/SetWebhookAsync/' + id, { headers: this.getHeaders(), })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceSetWebhookAsyncEmpty(id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/SetWebhookAsyncEmpty/' + id, { headers: this.getHeaders(), })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceSetAllWebhookUpdate() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/SetAllWebhookUpdate/', { headers: this.getHeaders(), })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
ApiTelegramBotConfigService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApiTelegramBotConfigService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ApiTelegramBotConfigService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApiTelegramBotConfigService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApiTelegramBotConfigService, decorators: [{
            type: Injectable
        }] });

class ApiTelegramEnumService extends ApiServerBase {
    getModuleControllerUrl() {
        return 'ApiTelegramEnum';
    }
    ServiceNotificationTypeEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/NotificationTypeEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceOSTypeEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/OSTypeEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
ApiTelegramEnumService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApiTelegramEnumService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ApiTelegramEnumService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApiTelegramEnumService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApiTelegramEnumService, decorators: [{
            type: Injectable
        }] });

class ApiTelegramUploadedFileService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'ApiTelegramUploadedFile';
    }
}
ApiTelegramUploadedFileService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApiTelegramUploadedFileService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ApiTelegramUploadedFileService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApiTelegramUploadedFileService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApiTelegramUploadedFileService, decorators: [{
            type: Injectable
        }] });

class ApiTelegramReceivedFileService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'ApiTelegramReceivedFile';
    }
}
ApiTelegramReceivedFileService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApiTelegramReceivedFileService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ApiTelegramReceivedFileService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApiTelegramReceivedFileService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApiTelegramReceivedFileService, decorators: [{
            type: Injectable
        }] });

class ApiTelegramLogInputService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'ApiTelegramLogInput';
    }
}
ApiTelegramLogInputService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApiTelegramLogInputService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ApiTelegramLogInputService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApiTelegramLogInputService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApiTelegramLogInputService, decorators: [{
            type: Injectable
        }] });

class ApiTelegramLogOutputService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'ApiTelegramLogOutput';
    }
}
ApiTelegramLogOutputService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApiTelegramLogOutputService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ApiTelegramLogOutputService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApiTelegramLogOutputService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApiTelegramLogOutputService, decorators: [{
            type: Injectable
        }] });

class ApiTelegramMemberInfoService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'ApiTelegramMemberInfo';
    }
}
ApiTelegramMemberInfoService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApiTelegramMemberInfoService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ApiTelegramMemberInfoService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApiTelegramMemberInfoService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApiTelegramMemberInfoService, decorators: [{
            type: Injectable
        }] });

class ApiTelegramModuleConfigAdminMainValuesModel extends BaseModuleConfigAdminMainValuesModel {
}
class ApiTelegramModuleConfigSiteAccessValuesModel extends BaseModuleConfigSiteAccessValuesModel {
}
/// <summary>
/// با ثبت یک هایپر شاپ باید یک ردیف خام با مقادیر اولیه در بانک ثبت شود
/// این کار باید از سمت سرور انجام شود و کلاینت اجازه ویرایش یا حذف این ردیف را نداشته باشد
/// </summary>
class ApiTelegramModuleConfigSiteValuesModel extends BaseModuleConfigSiteValuesModel {
}
class ApiTelegramModuleSiteStorageValuesModel extends BaseModuleSiteStorageValuesModel {
}

//@@tag-Version-2201011
class ApiTelegramBotConfigModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class ApiTelegramLogInputModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class ApiTelegramLogOutputModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class ApiTelegramMemberInfoModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class ApiTelegramReceivedFileModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class ApiTelegramUploadedFileModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class ApiTelegramSessionModel extends BaseModuleEntity {
}

class ApiTelegramSendMessageTodoModel {
}

class ApiTelegramRenderInfoModel {
}

var MessageTypeEnum;
(function (MessageTypeEnum) {
    //
    // Summary:
    //     The Telegram.Bot.Types.Message is unknown
    MessageTypeEnum[MessageTypeEnum["unknown"] = 0] = "unknown";
    //
    // Summary:
    //     The Telegram.Bot.Types.Message contains text
    MessageTypeEnum[MessageTypeEnum["text"] = 1] = "text";
    //
    // Summary:
    //     The Telegram.Bot.Types.Message contains a Telegram.Bot.Types.PhotoSize
    MessageTypeEnum[MessageTypeEnum["photo"] = 2] = "photo";
    //
    // Summary:
    //     The Telegram.Bot.Types.Message contains an Telegram.Bot.Types.Audio
    MessageTypeEnum[MessageTypeEnum["audio"] = 3] = "audio";
    //
    // Summary:
    //     The Telegram.Bot.Types.Message contains a Telegram.Bot.Types.Video
    MessageTypeEnum[MessageTypeEnum["video"] = 4] = "video";
    //
    // Summary:
    //     The Telegram.Bot.Types.Message contains a Telegram.Bot.Types.Voice
    MessageTypeEnum[MessageTypeEnum["voice"] = 5] = "voice";
    //
    // Summary:
    //     The Telegram.Bot.Types.Message contains a Telegram.Bot.Types.Document
    MessageTypeEnum[MessageTypeEnum["document"] = 6] = "document";
    //
    // Summary:
    //     The Telegram.Bot.Types.Message contains a Telegram.Bot.Types.Sticker
    MessageTypeEnum[MessageTypeEnum["sticker"] = 7] = "sticker";
    //
    // Summary:
    //     The Telegram.Bot.Types.Message contains a Telegram.Bot.Types.Location
    MessageTypeEnum[MessageTypeEnum["location"] = 8] = "location";
    //
    // Summary:
    //     The Telegram.Bot.Types.Message contains a Telegram.Bot.Types.Contact
    MessageTypeEnum[MessageTypeEnum["contact"] = 9] = "contact";
    //
    // Summary:
    //     The Telegram.Bot.Types.Message contains a Telegram.Bot.Types.Venue
    MessageTypeEnum[MessageTypeEnum["venue"] = 10] = "venue";
    //
    // Summary:
    //     The Telegram.Bot.Types.Message contains a Telegram.Bot.Types.Game
    MessageTypeEnum[MessageTypeEnum["game"] = 11] = "game";
    //
    // Summary:
    //     The Telegram.Bot.Types.Message contains a Telegram.Bot.Types.VideoNote
    MessageTypeEnum[MessageTypeEnum["videoNote"] = 12] = "videoNote";
    //
    // Summary:
    //     The Telegram.Bot.Types.Message contains a Telegram.Bot.Types.Payments.Invoice
    MessageTypeEnum[MessageTypeEnum["invoice"] = 13] = "invoice";
    //
    // Summary:
    //     The Telegram.Bot.Types.Message contains a Telegram.Bot.Types.Payments.SuccessfulPayment
    MessageTypeEnum[MessageTypeEnum["successfulPayment"] = 14] = "successfulPayment";
    //
    // Summary:
    //     The Telegram.Bot.Types.Message contains a Telegram.Bot.Types.Message.ConnectedWebsite
    MessageTypeEnum[MessageTypeEnum["websiteConnected"] = 15] = "websiteConnected";
    //
    // Summary:
    //     The Telegram.Bot.Types.Message contains a Telegram.Bot.Types.Message.NewChatMembers
    MessageTypeEnum[MessageTypeEnum["chatMembersAdded"] = 16] = "chatMembersAdded";
    //
    // Summary:
    //     The Telegram.Bot.Types.Message contains a Telegram.Bot.Types.Message.LeftChatMember
    MessageTypeEnum[MessageTypeEnum["chatMemberLeft"] = 17] = "chatMemberLeft";
    //
    // Summary:
    //     The Telegram.Bot.Types.Message contains a Telegram.Bot.Types.Message.NewChatTitle
    MessageTypeEnum[MessageTypeEnum["chatTitleChanged"] = 18] = "chatTitleChanged";
    //
    // Summary:
    //     The Telegram.Bot.Types.Message contains a Telegram.Bot.Types.Message.NewChatPhoto
    MessageTypeEnum[MessageTypeEnum["chatPhotoChanged"] = 19] = "chatPhotoChanged";
    //
    // Summary:
    //     The Telegram.Bot.Types.Message contains a Telegram.Bot.Types.Message.PinnedMessage
    MessageTypeEnum[MessageTypeEnum["messagePinned"] = 20] = "messagePinned";
    //
    // Summary:
    //     The Telegram.Bot.Types.Message contains a Telegram.Bot.Types.Message.DeleteChatPhoto
    MessageTypeEnum[MessageTypeEnum["chatPhotoDeleted"] = 21] = "chatPhotoDeleted";
    //
    // Summary:
    //     The Telegram.Bot.Types.Message contains a Telegram.Bot.Types.Message.GroupChatCreated
    MessageTypeEnum[MessageTypeEnum["groupCreated"] = 22] = "groupCreated";
    //
    // Summary:
    //     The Telegram.Bot.Types.Message contains a Telegram.Bot.Types.Message.SupergroupChatCreated
    MessageTypeEnum[MessageTypeEnum["supergroupCreated"] = 23] = "supergroupCreated";
    //
    // Summary:
    //     The Telegram.Bot.Types.Message contains a Telegram.Bot.Types.Message.ChannelChatCreated
    MessageTypeEnum[MessageTypeEnum["channelCreated"] = 24] = "channelCreated";
    //
    // Summary:
    //     The Telegram.Bot.Types.Message contains non-default Telegram.Bot.Types.Message.MigrateFromChatId
    MessageTypeEnum[MessageTypeEnum["migratedToSupergroup"] = 25] = "migratedToSupergroup";
    //
    // Summary:
    //     The Telegram.Bot.Types.Message contains non-default Telegram.Bot.Types.Message.MigrateToChatId
    MessageTypeEnum[MessageTypeEnum["migratedFromGroup"] = 26] = "migratedFromGroup";
    //
    // Summary:
    //     The Telegram.Bot.Types.Message contains Telegram.Bot.Types.Message.Poll
    MessageTypeEnum[MessageTypeEnum["poll"] = 27] = "poll";
    //
    // Summary:
    //     The Telegram.Bot.Types.Message contains Telegram.Bot.Types.Message.Dice
    MessageTypeEnum[MessageTypeEnum["dice"] = 28] = "dice";
    //
    // Summary:
    //     The Telegram.Bot.Types.Message contains Telegram.Bot.Types.Message.MessageAutoDeleteTimerChanged
    MessageTypeEnum[MessageTypeEnum["messageAutoDeleteTimerChanged"] = 29] = "messageAutoDeleteTimerChanged";
    //
    // Summary:
    //     The Telegram.Bot.Types.Message contains Telegram.Bot.Types.Message.ProximityAlertTriggered
    MessageTypeEnum[MessageTypeEnum["proximityAlertTriggered"] = 30] = "proximityAlertTriggered";
    //
    // Summary:
    //     The Telegram.Bot.Types.Message contains Telegram.Bot.Types.Message.VoiceChatScheduled
    MessageTypeEnum[MessageTypeEnum["voiceChatScheduled"] = 31] = "voiceChatScheduled";
    //
    // Summary:
    //     The Telegram.Bot.Types.Message contains Telegram.Bot.Types.Message.VoiceChatStarted
    MessageTypeEnum[MessageTypeEnum["voiceChatStarted"] = 32] = "voiceChatStarted";
    //
    // Summary:
    //     The Telegram.Bot.Types.Message contains Telegram.Bot.Types.Message.VoiceChatEnded
    MessageTypeEnum[MessageTypeEnum["voiceChatEnded"] = 33] = "voiceChatEnded";
    //
    // Summary:
    //     The Telegram.Bot.Types.Message contains Telegram.Bot.Types.Message.VoiceChatParticipantsInvited
    MessageTypeEnum[MessageTypeEnum["voiceChatParticipantsInvited"] = 34] = "voiceChatParticipantsInvited";
})(MessageTypeEnum || (MessageTypeEnum = {}));

var UpdateTypeEnum;
(function (UpdateTypeEnum) {
    //
    // Summary:
    //     Update Type is unknown
    UpdateTypeEnum[UpdateTypeEnum["unknown"] = 0] = "unknown";
    //
    // Summary:
    //     The Telegram.Bot.Types.Update contains a Telegram.Bot.Types.Message.
    UpdateTypeEnum[UpdateTypeEnum["message"] = 1] = "message";
    //
    // Summary:
    //     The Telegram.Bot.Types.Update contains an Telegram.Bot.Types.InlineQuery.
    UpdateTypeEnum[UpdateTypeEnum["inlineQuery"] = 2] = "inlineQuery";
    //
    // Summary:
    //     The Telegram.Bot.Types.Update contains a Telegram.Bot.Types.ChosenInlineResult.
    UpdateTypeEnum[UpdateTypeEnum["chosenInlineResult"] = 3] = "chosenInlineResult";
    //
    // Summary:
    //     The Telegram.Bot.Types.Update contains a Telegram.Bot.Types.CallbackQuery
    UpdateTypeEnum[UpdateTypeEnum["callbackQuery"] = 4] = "callbackQuery";
    //
    // Summary:
    //     The Telegram.Bot.Types.Update contains an edited Telegram.Bot.Types.Message
    UpdateTypeEnum[UpdateTypeEnum["editedMessage"] = 5] = "editedMessage";
    //
    // Summary:
    //     The Telegram.Bot.Types.Update contains a channel post Telegram.Bot.Types.Message
    UpdateTypeEnum[UpdateTypeEnum["channelPost"] = 6] = "channelPost";
    //
    // Summary:
    //     The Telegram.Bot.Types.Update contains an edited channel post Telegram.Bot.Types.Message
    UpdateTypeEnum[UpdateTypeEnum["editedChannelPost"] = 7] = "editedChannelPost";
    //
    // Summary:
    //     The Telegram.Bot.Types.Update contains an Telegram.Bot.Types.Enums.UpdateType.ShippingQuery
    UpdateTypeEnum[UpdateTypeEnum["shippingQuery"] = 8] = "shippingQuery";
    //
    // Summary:
    //     The Telegram.Bot.Types.Update contains an Telegram.Bot.Types.Enums.UpdateType.PreCheckoutQuery
    UpdateTypeEnum[UpdateTypeEnum["preCheckoutQuery"] = 9] = "preCheckoutQuery";
    //
    // Summary:
    //     The Telegram.Bot.Types.Update contains an Telegram.Bot.Types.Enums.UpdateType.Poll
    UpdateTypeEnum[UpdateTypeEnum["poll"] = 10] = "poll";
    //
    // Summary:
    //     The Telegram.Bot.Types.Update contains an Telegram.Bot.Types.Enums.UpdateType.PollAnswer
    UpdateTypeEnum[UpdateTypeEnum["pollAnswer"] = 11] = "pollAnswer";
    //
    // Summary:
    //     The Telegram.Bot.Types.Update contains an Telegram.Bot.Types.Enums.UpdateType.MyChatMember
    UpdateTypeEnum[UpdateTypeEnum["myChatMember"] = 12] = "myChatMember";
    //
    // Summary:
    //     The Telegram.Bot.Types.Update contains an Telegram.Bot.Types.Enums.UpdateType.ChatMember
    UpdateTypeEnum[UpdateTypeEnum["chatMember"] = 13] = "chatMember";
    //
    // Summary:
    //     The Telegram.Bot.Types.Update contains an Telegram.Bot.Types.Enums.UpdateType.ChatJoinRequest
    UpdateTypeEnum[UpdateTypeEnum["chatJoinRequest"] = 14] = "chatJoinRequest";
})(UpdateTypeEnum || (UpdateTypeEnum = {}));

var FileTypeEnum;
(function (FileTypeEnum) {
    FileTypeEnum[FileTypeEnum["photo"] = 1] = "photo";
    FileTypeEnum[FileTypeEnum["video"] = 2] = "video";
    FileTypeEnum[FileTypeEnum["document"] = 3] = "document";
    FileTypeEnum[FileTypeEnum["audio"] = 4] = "audio";
    FileTypeEnum[FileTypeEnum["voice"] = 5] = "voice";
})(FileTypeEnum || (FileTypeEnum = {}));

var BulkMessageTypeEnum;
(function (BulkMessageTypeEnum) {
    BulkMessageTypeEnum[BulkMessageTypeEnum["sentToSelectedBotMembers"] = 1] = "sentToSelectedBotMembers";
    BulkMessageTypeEnum[BulkMessageTypeEnum["sentToAllBotMembers"] = 2] = "sentToAllBotMembers";
    BulkMessageTypeEnum[BulkMessageTypeEnum["sentToAllGroupsMembers"] = 3] = "sentToAllGroupsMembers";
})(BulkMessageTypeEnum || (BulkMessageTypeEnum = {}));

// export * from './articleContentTagModel';
// export * from './articleContentCategoryModel';

class UniversalMenuConfigurationService extends ApiServerConfigSiteBase {
    getModuleControllerUrl() {
        return 'UniversalMenu';
    }
}
UniversalMenuConfigurationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: UniversalMenuConfigurationService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
UniversalMenuConfigurationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: UniversalMenuConfigurationService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: UniversalMenuConfigurationService, decorators: [{
            type: Injectable
        }] });

class UniversalMenuEnumService extends ApiServerBase {
    getModuleControllerUrl() {
        return 'UniversalMenuEnum';
    }
    ServiceUniversalMenuPlatformTypeEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/UniversalMenuPlatformTypeEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceUniversalMenuRenderTypeEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/UniversalMenuRenderTypeEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
UniversalMenuEnumService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: UniversalMenuEnumService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
UniversalMenuEnumService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: UniversalMenuEnumService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: UniversalMenuEnumService, decorators: [{
            type: Injectable
        }] });

class UniversalMenuProcessService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'UniversalMenuProcess';
    }
}
UniversalMenuProcessService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: UniversalMenuProcessService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
UniversalMenuProcessService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: UniversalMenuProcessService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: UniversalMenuProcessService, decorators: [{
            type: Injectable
        }] });

class UniversalMenuSessionService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'UniversalMenuSession';
    }
}
UniversalMenuSessionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: UniversalMenuSessionService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
UniversalMenuSessionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: UniversalMenuSessionService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: UniversalMenuSessionService, decorators: [{
            type: Injectable
        }] });

class UniversalMenuPlatformService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'UniversalMenuPlatform';
    }
}
UniversalMenuPlatformService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: UniversalMenuPlatformService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
UniversalMenuPlatformService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: UniversalMenuPlatformService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: UniversalMenuPlatformService, decorators: [{
            type: Injectable
        }] });

class UniversalMenuMenuItemProcessService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'UniversalMenuMenuItemProcess';
    }
}
UniversalMenuMenuItemProcessService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: UniversalMenuMenuItemProcessService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
UniversalMenuMenuItemProcessService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: UniversalMenuMenuItemProcessService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: UniversalMenuMenuItemProcessService, decorators: [{
            type: Injectable
        }] });

class UniversalMenuMenuItemService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'UniversalMenuMenuItem';
    }
    ServiceGetAllMenu(model) {
        if (model == null) {
            model = new FilterModel();
        }
        model.rowPerPage = 200;
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllMenu', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            // if (ret.item != null) {
            //   this.coreCpMainMenu.next(ret.listItems);
            // }
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceEditStep(model) {
        if (!model) {
            model = new EditStepDtoModel();
        }
        return this.http
            .put(this.getBaseUrl() + this.getModuleControllerUrl() + '/EditStep', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
}
UniversalMenuMenuItemService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: UniversalMenuMenuItemService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
UniversalMenuMenuItemService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: UniversalMenuMenuItemService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: UniversalMenuMenuItemService, decorators: [{
            type: Injectable
        }] });

class UniversalMenuModuleConfigAdminMainValuesModel extends BaseModuleConfigAdminMainValuesModel {
}
class UniversalMenuModuleConfigSiteAccessValuesModel extends BaseModuleConfigSiteAccessValuesModel {
}
/// <summary>
/// با ثبت یک هایپر شاپ باید یک ردیف خام با مقادیر اولیه در بانک ثبت شود
/// این کار باید از سمت سرور انجام شود و کلاینت اجازه ویرایش یا حذف این ردیف را نداشته باشد
/// </summary>
class UniversalMenuModuleConfigSiteValuesModel extends BaseModuleConfigSiteValuesModel {
}
class UniversalMenuModuleSiteStorageValuesModel extends BaseModuleSiteStorageValuesModel {
}

//@@tag-Version-2201011
class UniversalMenuMenuItemModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class UniversalMenuMenuItemProcessModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class UniversalMenuPlatformModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class UniversalMenuProcessModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class UniversalMenuSessionModel extends BaseModuleEntity {
}

var UniversalMenuPlatformTypeEnum;
(function (UniversalMenuPlatformTypeEnum) {
    UniversalMenuPlatformTypeEnum[UniversalMenuPlatformTypeEnum["TelegramBot"] = 1] = "TelegramBot";
    UniversalMenuPlatformTypeEnum[UniversalMenuPlatformTypeEnum["USSD"] = 2] = "USSD";
})(UniversalMenuPlatformTypeEnum || (UniversalMenuPlatformTypeEnum = {}));

var UniversalMenuRenderTypeEnum;
(function (UniversalMenuRenderTypeEnum) {
    UniversalMenuRenderTypeEnum[UniversalMenuRenderTypeEnum["none"] = 0] = "none";
    UniversalMenuRenderTypeEnum[UniversalMenuRenderTypeEnum["BySection"] = 1] = "BySection";
    UniversalMenuRenderTypeEnum[UniversalMenuRenderTypeEnum["ByLastInputLog"] = 2] = "ByLastInputLog";
    UniversalMenuRenderTypeEnum[UniversalMenuRenderTypeEnum["ByGetInputValue"] = 3] = "ByGetInputValue";
    UniversalMenuRenderTypeEnum[UniversalMenuRenderTypeEnum["ByStartMenu"] = 4] = "ByStartMenu";
    UniversalMenuRenderTypeEnum[UniversalMenuRenderTypeEnum["BySpecialMenuId"] = 5] = "BySpecialMenuId";
    UniversalMenuRenderTypeEnum[UniversalMenuRenderTypeEnum["BySpecialKeyboardMenuId"] = 6] = "BySpecialKeyboardMenuId";
})(UniversalMenuRenderTypeEnum || (UniversalMenuRenderTypeEnum = {}));

class NewsConfigurationService extends ApiServerConfigSiteBase {
    getModuleControllerUrl() {
        return 'news';
    }
}
NewsConfigurationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NewsConfigurationService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
NewsConfigurationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NewsConfigurationService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NewsConfigurationService, decorators: [{
            type: Injectable
        }] });

class NewsCategoryService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'NewsCategory';
    }
    ServiceMove(OldId, NewId) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/Move', { Old: OldId, New: NewId }, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
NewsCategoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NewsCategoryService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
NewsCategoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NewsCategoryService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NewsCategoryService, decorators: [{
            type: Injectable
        }] });

class NewsCommentService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'NewsComment';
    }
    ServiceLikeClick(Id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/LikeClick/' + Id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceDisLikeClick(Id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/DisLikeClick/' + Id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
}
NewsCommentService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NewsCommentService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
NewsCommentService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NewsCommentService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NewsCommentService, decorators: [{
            type: Injectable
        }] });

class NewsContentService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'NewsContent';
    }
    ServiceGetAllWithHierarchyCategoryId(Id, model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithHierarchyCategoryId/' + Id, model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllWithSimilarsId(Id, model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithSimilarsId/' + Id, model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllWithTagId(Id, model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithTagId/' + Id, model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllWithCategoryUseInContentId(Id, model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithCategoryUseInContentId/' + Id, model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceScoreClick(model) {
        if (model == null) {
            model = new ScoreClickDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/ScoreClick', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceFavoriteAdd(Id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/FavoriteAdd/' + Id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceFavoriteRemove(Id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/FavoriteRemove/' + Id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceFavoriteList(model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/FavoriteList', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceReportAbuseAdd(model) {
        if (model == null) {
            model = new CoreModuleReportAbuseDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/ReportAbuseAdd', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceReportAbuseList(model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/ReportAbuseList', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
NewsContentService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NewsContentService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
NewsContentService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NewsContentService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NewsContentService, decorators: [{
            type: Injectable
        }] });

class NewsContentAndParameterValueService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'NewsContentAndParameterValue';
    }
}
NewsContentAndParameterValueService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NewsContentAndParameterValueService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
NewsContentAndParameterValueService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NewsContentAndParameterValueService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NewsContentAndParameterValueService, decorators: [{
            type: Injectable
        }] });

class NewsContentOtherInfoService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'NewsContentOtherInfo';
    }
    ServiceAddBatch(model) {
        if (model == null) {
            model = [];
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/AddBatch', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceEditBatch(model) {
        if (model == null) {
            model = [];
        }
        return this.http
            .put(this.getBaseUrl() + this.getModuleControllerUrl() + '/EditBatch', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
NewsContentOtherInfoService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NewsContentOtherInfoService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
NewsContentOtherInfoService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NewsContentOtherInfoService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NewsContentOtherInfoService, decorators: [{
            type: Injectable
        }] });

class NewsContentParameterService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'NewsContentParameter';
    }
}
NewsContentParameterService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NewsContentParameterService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
NewsContentParameterService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NewsContentParameterService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NewsContentParameterService, decorators: [{
            type: Injectable
        }] });

class NewsContentParameterTypeService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'NewsContentParameterType';
    }
}
NewsContentParameterTypeService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NewsContentParameterTypeService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
NewsContentParameterTypeService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NewsContentParameterTypeService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NewsContentParameterTypeService, decorators: [{
            type: Injectable
        }] });

class NewsContentSimilarService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'NewsContentSimilar';
    }
    ServiceAddBatch(model) {
        if (model == null) {
            model = [];
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/AddBatch', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceDeleteBatch(model) {
        if (model == null) {
            model = [];
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/DeleteBatch', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
NewsContentSimilarService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NewsContentSimilarService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
NewsContentSimilarService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NewsContentSimilarService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NewsContentSimilarService, decorators: [{
            type: Injectable
        }] });

class NewsContentTagService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'NewsContentTag';
    }
    ServiceAddBatch(model) {
        if (model == null) {
            model = [];
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/AddBatch', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceDeleteBatch(model) {
        if (model == null) {
            model = [];
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/DeleteBatch', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
NewsContentTagService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NewsContentTagService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
NewsContentTagService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NewsContentTagService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NewsContentTagService, decorators: [{
            type: Injectable
        }] });

class NewsShareMainAdminSettingService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'NewsShareMainAdminSetting';
    }
}
NewsShareMainAdminSettingService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NewsShareMainAdminSettingService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
NewsShareMainAdminSettingService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NewsShareMainAdminSettingService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NewsShareMainAdminSettingService, decorators: [{
            type: Injectable
        }] });

class NewsShareReceiverCategoryService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'NewsShareReceiverCategory';
    }
}
NewsShareReceiverCategoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NewsShareReceiverCategoryService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
NewsShareReceiverCategoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NewsShareReceiverCategoryService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NewsShareReceiverCategoryService, decorators: [{
            type: Injectable
        }] });

class NewsShareServerCategoryService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'NewsShareServerCategory';
    }
    ServiceGetAllOtherSite(model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllOtherSite/', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
NewsShareServerCategoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NewsShareServerCategoryService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
NewsShareServerCategoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NewsShareServerCategoryService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NewsShareServerCategoryService, decorators: [{
            type: Injectable
        }] });

class NewsContentCategoryService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'NewsContentCategory';
    }
}
NewsContentCategoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NewsContentCategoryService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
NewsContentCategoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NewsContentCategoryService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: NewsContentCategoryService, decorators: [{
            type: Injectable
        }] });

class NewsModuleConfigAdminMainValuesModel extends BaseModuleConfigAdminMainValuesModel {
}
class NewsModuleConfigSiteAccessValuesModel extends BaseModuleConfigSiteAccessValuesModel {
}
/// <summary>
/// با ثبت یک هایپر شاپ باید یک ردیف خام با مقادیر اولیه در بانک ثبت شود
/// این کار باید از سمت سرور انجام شود و کلاینت اجازه ویرایش یا حذف این ردیف را نداشته باشد
/// </summary>
class NewsModuleConfigSiteValuesModel extends BaseModuleConfigSiteValuesModel {
}
class NewsModuleSiteStorageValuesModel extends BaseModuleSiteStorageValuesModel {
}

//@@tag-Version-2201011
class NewsCategoryModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class NewsCommentModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class NewsContentModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class NewsContentOtherInfoModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class NewsContentSimilarModel {
}

//@@tag-Version-2201011
class NewsContentTagModel {
}

//@@tag-Version-2201011
class NewsContentCategoryModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class NewsShareMainAdminSettingModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class NewsShareReceiverCategoryModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class NewsShareServerCategoryModel extends BaseModuleEntity {
}

class ChartConfigurationService extends ApiServerConfigSiteBase {
    getModuleControllerUrl() {
        return 'chart';
    }
}
ChartConfigurationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChartConfigurationService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ChartConfigurationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChartConfigurationService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChartConfigurationService, decorators: [{
            type: Injectable
        }] });

class ChartCategoryService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'ChartCategory';
    }
    ServiceMove(OldId, NewId) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/Move', { Old: OldId, New: NewId }, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
ChartCategoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChartCategoryService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ChartCategoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChartCategoryService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChartCategoryService, decorators: [{
            type: Injectable
        }] });

class ChartCommentService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'ChartComment';
    }
    ServiceLikeClick(Id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/LikeClick/' + Id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceDisLikeClick(Id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/DisLikeClick/' + Id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
}
ChartCommentService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChartCommentService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ChartCommentService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChartCommentService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChartCommentService, decorators: [{
            type: Injectable
        }] });

class ChartContentService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'ChartContent';
    }
    ServiceGetAllWithHierarchyCategoryId(Id, model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithHierarchyCategoryId/' + Id, model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllWithSimilarsId(Id, model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithSimilarsId/' + Id, model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllWithTagId(Id, model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithTagId/' + Id, model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllWithCategoryUseInContentId(Id, model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithCategoryUseInContentId/' + Id, model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceScoreClick(model) {
        if (model == null) {
            model = new ScoreClickDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/ScoreClick', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceFavoriteAdd(Id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/FavoriteAdd/' + Id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceFavoriteRemove(Id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/FavoriteRemove/' + Id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceFavoriteList(model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/FavoriteList', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceReportAbuseAdd(model) {
        if (model == null) {
            model = new CoreModuleReportAbuseDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/ReportAbuseAdd', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceReportAbuseList(model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/ReportAbuseList', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
ChartContentService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChartContentService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ChartContentService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChartContentService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChartContentService, decorators: [{
            type: Injectable
        }] });

class ChartContentAndParameterValueService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'chartContentAndParameterValue';
    }
}
ChartContentAndParameterValueService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChartContentAndParameterValueService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ChartContentAndParameterValueService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChartContentAndParameterValueService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChartContentAndParameterValueService, decorators: [{
            type: Injectable
        }] });

class ChartContentOtherInfoService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'ChartContentOtherInfo';
    }
    ServiceAddBatch(model) {
        if (model == null) {
            model = [];
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/AddBatch', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceEditBatch(model) {
        if (model == null) {
            model = [];
        }
        return this.http
            .put(this.getBaseUrl() + this.getModuleControllerUrl() + '/EditBatch', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
ChartContentOtherInfoService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChartContentOtherInfoService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ChartContentOtherInfoService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChartContentOtherInfoService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChartContentOtherInfoService, decorators: [{
            type: Injectable
        }] });

class ChartContentParameterService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'ChartContentParameter';
    }
}
ChartContentParameterService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChartContentParameterService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ChartContentParameterService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChartContentParameterService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChartContentParameterService, decorators: [{
            type: Injectable
        }] });

class ChartContentParameterTypeService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'ChartContentParameterType';
    }
}
ChartContentParameterTypeService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChartContentParameterTypeService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ChartContentParameterTypeService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChartContentParameterTypeService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChartContentParameterTypeService, decorators: [{
            type: Injectable
        }] });

class ChartContentSimilarService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'ChartContentSimilar';
    }
    ServiceAddBatch(model) {
        if (model == null) {
            model = [];
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/AddBatch', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceDeleteBatch(model) {
        if (model == null) {
            model = [];
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/DeleteBatch', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
ChartContentSimilarService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChartContentSimilarService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ChartContentSimilarService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChartContentSimilarService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChartContentSimilarService, decorators: [{
            type: Injectable
        }] });

class ChartContentTagService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'ChartContentTag';
    }
    ServiceAddBatch(model) {
        if (model == null) {
            model = [];
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/AddBatch', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceDeleteBatch(model) {
        if (model == null) {
            model = [];
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/DeleteBatch', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
ChartContentTagService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChartContentTagService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ChartContentTagService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChartContentTagService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChartContentTagService, decorators: [{
            type: Injectable
        }] });

class ChartShareMainAdminSettingService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'ChartShareMainAdminSetting';
    }
}
ChartShareMainAdminSettingService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChartShareMainAdminSettingService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ChartShareMainAdminSettingService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChartShareMainAdminSettingService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChartShareMainAdminSettingService, decorators: [{
            type: Injectable
        }] });

class ChartShareReceiverCategoryService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'ChartShareReceiverCategory';
    }
}
ChartShareReceiverCategoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChartShareReceiverCategoryService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ChartShareReceiverCategoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChartShareReceiverCategoryService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChartShareReceiverCategoryService, decorators: [{
            type: Injectable
        }] });

class ChartShareServerCategoryService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'ChartShareServerCategory';
    }
    ServiceGetAllOtherSite(model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllOtherSite/', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
ChartShareServerCategoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChartShareServerCategoryService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ChartShareServerCategoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChartShareServerCategoryService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChartShareServerCategoryService, decorators: [{
            type: Injectable
        }] });

class ChartContentCategoryService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'ChartContentCategory';
    }
}
ChartContentCategoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChartContentCategoryService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ChartContentCategoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChartContentCategoryService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ChartContentCategoryService, decorators: [{
            type: Injectable
        }] });

class ChartModuleConfigAdminMainValuesModel extends BaseModuleConfigAdminMainValuesModel {
}
class ChartModuleConfigSiteAccessValuesModel extends BaseModuleConfigSiteAccessValuesModel {
}
/// <summary>
/// با ثبت یک هایپر شاپ باید یک ردیف خام با مقادیر اولیه در بانک ثبت شود
/// این کار باید از سمت سرور انجام شود و کلاینت اجازه ویرایش یا حذف این ردیف را نداشته باشد
/// </summary>
class ChartModuleConfigSiteValuesModel extends BaseModuleConfigSiteValuesModel {
}
class ChartModuleSiteStorageValuesModel extends BaseModuleSiteStorageValuesModel {
}

//@@tag-Version-2201011
class ChartCategoryModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class ChartCommentModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class ChartContentModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class ChartContentOtherInfoModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class ChartContentSimilarModel {
}

//@@tag-Version-2201011
class ChartContentTagModel {
}

//@@tag-Version-2201011
class ChartContentCategoryModel extends BaseModuleEntity {
}

class BlogConfigurationService extends ApiServerConfigSiteBase {
    getModuleControllerUrl() {
        return 'Blog';
    }
}
BlogConfigurationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BlogConfigurationService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
BlogConfigurationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BlogConfigurationService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BlogConfigurationService, decorators: [{
            type: Injectable
        }] });

class BlogCategoryService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'BlogCategory';
    }
    ServiceMove(OldId, NewId) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/Move', { Old: OldId, New: NewId }, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
BlogCategoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BlogCategoryService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
BlogCategoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BlogCategoryService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BlogCategoryService, decorators: [{
            type: Injectable
        }] });

class BlogCommentService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'BlogComment';
    }
    ServiceLikeClick(Id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/LikeClick/' + Id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceDisLikeClick(Id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/DisLikeClick/' + Id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
}
BlogCommentService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BlogCommentService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
BlogCommentService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BlogCommentService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BlogCommentService, decorators: [{
            type: Injectable
        }] });

class BlogContentService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'BlogContent';
    }
    ServiceGetAllWithHierarchyCategoryId(Id, model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithHierarchyCategoryId/' + Id, model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllWithSimilarsId(Id, model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithSimilarsId/' + Id, model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllWithTagId(Id, model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithTagId/' + Id, model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllWithCategoryUseInContentId(Id, model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithCategoryUseInContentId/' + Id, model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceScoreClick(model) {
        if (model == null) {
            model = new ScoreClickDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/ScoreClick', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceFavoriteAdd(Id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/FavoriteAdd/' + Id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceFavoriteRemove(Id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/FavoriteRemove/' + Id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceFavoriteList(model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/FavoriteList', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceReportAbuseAdd(model) {
        if (model == null) {
            model = new CoreModuleReportAbuseDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/ReportAbuseAdd', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceReportAbuseList(model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/ReportAbuseList', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
BlogContentService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BlogContentService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
BlogContentService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BlogContentService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BlogContentService, decorators: [{
            type: Injectable
        }] });

class BlogContentAndParameterValueService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'BlogContentAndParameterValue';
    }
}
BlogContentAndParameterValueService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BlogContentAndParameterValueService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
BlogContentAndParameterValueService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BlogContentAndParameterValueService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BlogContentAndParameterValueService, decorators: [{
            type: Injectable
        }] });

class BlogContentOtherInfoService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'BlogContentOtherInfo';
    }
    ServiceAddBatch(model) {
        if (model == null) {
            model = [];
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/AddBatch', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceEditBatch(model) {
        if (model == null) {
            model = [];
        }
        return this.http
            .put(this.getBaseUrl() + this.getModuleControllerUrl() + '/EditBatch', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
BlogContentOtherInfoService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BlogContentOtherInfoService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
BlogContentOtherInfoService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BlogContentOtherInfoService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BlogContentOtherInfoService, decorators: [{
            type: Injectable
        }] });

class BlogContentParameterService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'BlogContentParameter';
    }
}
BlogContentParameterService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BlogContentParameterService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
BlogContentParameterService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BlogContentParameterService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BlogContentParameterService, decorators: [{
            type: Injectable
        }] });

class BlogContentParameterTypeService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'BlogContentParameterType';
    }
}
BlogContentParameterTypeService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BlogContentParameterTypeService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
BlogContentParameterTypeService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BlogContentParameterTypeService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BlogContentParameterTypeService, decorators: [{
            type: Injectable
        }] });

class BlogContentSimilarService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'BlogContentSimilar';
    }
    ServiceAddBatch(model) {
        if (model == null) {
            model = [];
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/AddBatch', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceDeleteBatch(model) {
        if (model == null) {
            model = [];
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/DeleteBatch', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
BlogContentSimilarService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BlogContentSimilarService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
BlogContentSimilarService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BlogContentSimilarService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BlogContentSimilarService, decorators: [{
            type: Injectable
        }] });

class BlogContentTagService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'BlogContentTag';
    }
    ServiceAddBatch(model) {
        if (model == null) {
            model = [];
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/AddBatch', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceDeleteBatch(model) {
        if (model == null) {
            model = [];
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/DeleteBatch', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
BlogContentTagService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BlogContentTagService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
BlogContentTagService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BlogContentTagService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BlogContentTagService, decorators: [{
            type: Injectable
        }] });

class BlogShareMainAdminSettingService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'BlogShareMainAdminSetting';
    }
}
BlogShareMainAdminSettingService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BlogShareMainAdminSettingService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
BlogShareMainAdminSettingService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BlogShareMainAdminSettingService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BlogShareMainAdminSettingService, decorators: [{
            type: Injectable
        }] });

class BlogShareReceiverCategoryService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'BlogShareReceiverCategory';
    }
}
BlogShareReceiverCategoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BlogShareReceiverCategoryService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
BlogShareReceiverCategoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BlogShareReceiverCategoryService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BlogShareReceiverCategoryService, decorators: [{
            type: Injectable
        }] });

class BlogShareServerCategoryService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'BlogShareServerCategory';
    }
    ServiceGetAllOtherSite(model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllOtherSite/', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
BlogShareServerCategoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BlogShareServerCategoryService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
BlogShareServerCategoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BlogShareServerCategoryService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BlogShareServerCategoryService, decorators: [{
            type: Injectable
        }] });

class BlogContentCategoryService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'BlogContentCategory';
    }
}
BlogContentCategoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BlogContentCategoryService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
BlogContentCategoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BlogContentCategoryService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BlogContentCategoryService, decorators: [{
            type: Injectable
        }] });

class BlogModuleConfigAdminMainValuesModel extends BaseModuleConfigAdminMainValuesModel {
}
class BlogModuleConfigSiteAccessValuesModel extends BaseModuleConfigSiteAccessValuesModel {
}
/// <summary>
/// با ثبت یک هایپر شاپ باید یک ردیف خام با مقادیر اولیه در بانک ثبت شود
/// این کار باید از سمت سرور انجام شود و کلاینت اجازه ویرایش یا حذف این ردیف را نداشته باشد
/// </summary>
class BlogModuleConfigSiteValuesModel extends BaseModuleConfigSiteValuesModel {
}
class BlogModuleSiteStorageValuesModel extends BaseModuleSiteStorageValuesModel {
}

//@@tag-Version-2201011
class BlogCategoryModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class BlogCommentModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class BlogContentModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class BlogContentOtherInfoModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class BlogContentSimilarModel {
}

//@@tag-Version-2201011
class BlogContentTagModel {
}

//@@tag-Version-2201011
class BlogContentCategoryModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class BlogShareMainAdminSettingModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class BlogShareReceiverCategoryModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class BlogShareServerCategoryModel extends BaseModuleEntity {
}

class CatalogConfigurationService extends ApiServerConfigSiteBase {
    getModuleControllerUrl() {
        return 'Catalog';
    }
}
CatalogConfigurationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CatalogConfigurationService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CatalogConfigurationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CatalogConfigurationService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CatalogConfigurationService, decorators: [{
            type: Injectable
        }] });

class CatalogCategoryService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CatalogCategory';
    }
    ServiceMove(OldId, NewId) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/Move', { Old: OldId, New: NewId }, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
CatalogCategoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CatalogCategoryService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CatalogCategoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CatalogCategoryService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CatalogCategoryService, decorators: [{
            type: Injectable
        }] });

class CatalogContentService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'CatalogContent';
    }
    ServiceScoreClick(model) {
        if (model == null) {
            model = new ScoreClickDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/ScoreClick', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceFavoriteAdd(Id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/FavoriteAdd/' + Id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceFavoriteRemove(Id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/FavoriteRemove/' + Id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceFavoriteList(model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/FavoriteList', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceReportAbuseAdd(model) {
        if (model == null) {
            model = new CoreModuleReportAbuseDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/ReportAbuseAdd', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceReportAbuseList(model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/ReportAbuseList', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
CatalogContentService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CatalogContentService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
CatalogContentService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CatalogContentService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: CatalogContentService, decorators: [{
            type: Injectable
        }] });

class CatalogModuleConfigAdminMainValuesModel extends BaseModuleConfigAdminMainValuesModel {
}
class CatalogModuleConfigSiteAccessValuesModel extends BaseModuleConfigSiteAccessValuesModel {
}
/// <summary>
/// با ثبت یک هایپر شاپ باید یک ردیف خام با مقادیر اولیه در بانک ثبت شود
/// این کار باید از سمت سرور انجام شود و کلاینت اجازه ویرایش یا حذف این ردیف را نداشته باشد
/// </summary>
class CatalogModuleConfigSiteValuesModel extends BaseModuleConfigSiteValuesModel {
}
class CatalogModuleSiteStorageValuesModel extends BaseModuleSiteStorageValuesModel {
}

//@@tag-Version-2201011
class CatalogCategoryModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class CatalogContentModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class CatalogContentOtherInfoModel {
}

//@@tag-Version-2201011
class CatalogContentPageModel {
}

class BankPaymentConfigurationService extends ApiServerConfigSiteBase {
    getModuleControllerUrl() {
        return 'BankPayment';
    }
}
BankPaymentConfigurationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BankPaymentConfigurationService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
BankPaymentConfigurationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BankPaymentConfigurationService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BankPaymentConfigurationService, decorators: [{
            type: Injectable
        }] });

class BankPaymentInjectOnlineTransactionDtoModel {
}

class BankPaymentPrivateSiteConfigService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'BankPaymentPrivateSiteConfig';
    }
    ServiceGetOneWithJsonFormatter(id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetOneWithJsonFormatter/' + id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceTestPay(model) {
        if (model == null) {
            model = new BankPaymentInjectOnlineTransactionDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/TestPay', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGoToBankPaymentWebSite(model) {
        if (model == null) {
            model = new BankPaymentInjectOnlineTransactionDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GoToBankPaymentWebSite', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServicePaymentGatewayList() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/PaymentGatewayList', {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServicePaymentGatewayCoreList() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/PaymentGatewayCoreList', {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
BankPaymentPrivateSiteConfigService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BankPaymentPrivateSiteConfigService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
BankPaymentPrivateSiteConfigService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BankPaymentPrivateSiteConfigService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BankPaymentPrivateSiteConfigService, decorators: [{
            type: Injectable
        }] });

class BankPaymentPublicConfigService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'BankPaymentPublicConfig';
    }
    ServiceGetOneWithJsonFormatter(id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetOneWithJsonFormatter/' + id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceAutoAdd() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/AutoAdd/', {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
BankPaymentPublicConfigService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BankPaymentPublicConfigService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
BankPaymentPublicConfigService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BankPaymentPublicConfigService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BankPaymentPublicConfigService, decorators: [{
            type: Injectable
        }] });

class BankPaymentTransactionService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'BankPaymentTransaction';
    }
    ServiceTransactionCheck(id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/TransactionCheck/' + id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
BankPaymentTransactionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BankPaymentTransactionService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
BankPaymentTransactionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BankPaymentTransactionService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BankPaymentTransactionService, decorators: [{
            type: Injectable
        }] });

class BankPaymentTransactionLogService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'BankPaymentTransactionLog';
    }
}
BankPaymentTransactionLogService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BankPaymentTransactionLogService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
BankPaymentTransactionLogService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BankPaymentTransactionLogService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BankPaymentTransactionLogService, decorators: [{
            type: Injectable
        }] });

class BankPaymentEnumService extends ApiServerBase {
    getModuleControllerUrl() {
        return 'BankPaymentEnum';
    }
    ServiceTransactionRecordStatusEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/TransactionRecordStatusEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceTransactionBankStatusEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/TransactionBankStatusEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
BankPaymentEnumService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BankPaymentEnumService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
BankPaymentEnumService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BankPaymentEnumService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BankPaymentEnumService, decorators: [{
            type: Injectable
        }] });

class BankPaymentModuleConfigAdminMainValuesModel extends BaseModuleConfigAdminMainValuesModel {
}
class BankPaymentModuleConfigSiteAccessValuesModel extends BaseModuleConfigSiteAccessValuesModel {
}
/// <summary>
/// با ثبت یک هایپر شاپ باید یک ردیف خام با مقادیر اولیه در بانک ثبت شود
/// این کار باید از سمت سرور انجام شود و کلاینت اجازه ویرایش یا حذف این ردیف را نداشته باشد
/// </summary>
class BankPaymentModuleConfigSiteValuesModel extends BaseModuleConfigSiteValuesModel {
}
class BankPaymentModuleSiteStorageValuesModel extends BaseModuleSiteStorageValuesModel {
}

//@@tag-Version-2201011
class BankPaymentPublicConfigModel extends BaseEntity {
}

//@@tag-Version-2201011
class BankPaymentPublicConfigAliasJsonModel extends BankPaymentPublicConfigModel {
}

//@@tag-Version-2201011
class BankPaymentPrivateSiteConfigModel extends BaseEntity {
}

//@@tag-Version-2201011
class BankPaymentPrivateSiteConfigAliasJsonModel extends BankPaymentPrivateSiteConfigModel {
}

//@@tag-Version-2201011
class BankPaymentTransactionLogModel extends BaseEntity {
}

//@@tag-Version-2305051
class BankPaymentTransactionModel extends BaseEntity {
}

class BankPaymentInjectPaymentGotoBankStep2LandingSitePageModel {
}

class BankPaymentInjectPaymentGotoBankStep1CalculateModel {
}

class SmsModuleConfigAdminMainValuesModel extends BaseModuleConfigAdminMainValuesModel {
}
class SmsModuleConfigSiteAccessValuesModel extends BaseModuleConfigSiteAccessValuesModel {
}
class SmsModuleConfigSiteValuesModel extends BaseModuleConfigSiteValuesModel {
}
class SmsModuleSiteStorageValuesModel extends BaseModuleSiteStorageValuesModel {
}

//@@tag-Version-2201011
class SmsLogInBoxModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class SmsLogOutBoxDetailBulkModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class SmsLogOutBoxDetailModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class SmsLogOutBoxModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class SmsLogApiPathModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class SmsMainApiPathCompanyModel extends BaseModuleEntity {
}

//@@tag-Version-2305111
class SmsMainApiPathModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class SmsMainApiPathAliasJsonModel extends SmsMainApiPathModel {
}

//@@tag-Version-2201011
class SmsMainApiPathPermissionModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class SmsMainApiPathPriceServiceModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class SmsMainApiPathProcessFlowLogModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class SmsMainApiPathProcessFlowModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class SmsMainApiPathPublicConfigModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class SmsMainApiPathPublicConfigAliasJsonModel extends SmsMainApiPathPublicConfigModel {
}

//@@tag-Version-2201011
class SmsMainApiPathSuperSederModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class SmsMainApiPathAndApiNumberModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class SmsMainApiNumberModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class SmsMainApiNumberPermissionModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class SmsMainCustomerCreditModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class SmsMainMessageCategoryModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class SmsMainMessageContentModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class SmsLogOutBoxQueueModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class SmsLogOutBoxTaskSchedulerModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class SmsLogOutBoxScheduleRunInfoModel {
}

class SmsConfigurationService extends ApiServerConfigSiteBase {
    getModuleControllerUrl() {
        return 'sms';
    }
}
SmsConfigurationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsConfigurationService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
SmsConfigurationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsConfigurationService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsConfigurationService, decorators: [{
            type: Injectable
        }] });

class SmsEnumService extends ApiServerBase {
    getModuleControllerUrl() {
        return 'SmsEnum';
    }
    ServiceSmsApiNumberPermissionAccessStatusEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/SmsApiNumberPermissionAccessStatusEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceSmsApiNumberPermissionActionEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/SmsApiNumberPermissionActionEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceSmsApiPathPermissionAccessStatusEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/SmsApiPathPermissionAccessStatusEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceSmsApiPathPermissionActionEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/SmsApiPathPermissionActionEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceSmsMessageTypeEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/SmsMessageTypeEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceSmsOutBoxTypeEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/SmsOutBoxTypeEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceSmsProcessFlowRecordStatusEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/SmsProcessFlowRecordStatusEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceSmsProcessFlowSmsStatusEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/SmsProcessFlowSmsStatusEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceSmsRecordStatusOutBoxEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/SmsRecordStatusOutBoxEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
SmsEnumService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsEnumService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
SmsEnumService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsEnumService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsEnumService, decorators: [{
            type: Injectable
        }] });

class SmsLogInBoxService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'SmsLogInBox';
    }
}
SmsLogInBoxService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsLogInBoxService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
SmsLogInBoxService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsLogInBoxService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsLogInBoxService, decorators: [{
            type: Injectable
        }] });

class SmsLogOutBoxService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'SmsLogOutBox';
    }
}
SmsLogOutBoxService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsLogOutBoxService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
SmsLogOutBoxService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsLogOutBoxService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsLogOutBoxService, decorators: [{
            type: Injectable
        }] });

class SmsLogOutBoxDetailService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'SmsLogOutBoxDetail';
    }
}
SmsLogOutBoxDetailService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsLogOutBoxDetailService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
SmsLogOutBoxDetailService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsLogOutBoxDetailService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsLogOutBoxDetailService, decorators: [{
            type: Injectable
        }] });

class SmsLogOutBoxDetailBulkService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'SmsLogOutBoxDetailBulk';
    }
}
SmsLogOutBoxDetailBulkService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsLogOutBoxDetailBulkService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
SmsLogOutBoxDetailBulkService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsLogOutBoxDetailBulkService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsLogOutBoxDetailBulkService, decorators: [{
            type: Injectable
        }] });

class SmsApiSendMessageDtoModel {
}

//@@tag-Version-2305111
class SmsApiSendMessageTestDtoModel {
}

class SmsMainApiPathService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'SmsMainApiPath';
    }
    ServiceGetOneWithJsonFormatter(id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetOneWithJsonFormatter/' + id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceSendMessageTest(model) {
        if (model == null) {
            model = new SmsApiSendMessageTestDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/SendMessageTest', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceSendMessage(model) {
        if (model == null) {
            model = new SmsApiSendMessageDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/SendMessage', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
SmsMainApiPathService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsMainApiPathService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
SmsMainApiPathService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsMainApiPathService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsMainApiPathService, decorators: [{
            type: Injectable
        }] });

class SmsMainApiPathCompanyService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'SmsMainApiPathCompany';
    }
}
SmsMainApiPathCompanyService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsMainApiPathCompanyService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
SmsMainApiPathCompanyService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsMainApiPathCompanyService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsMainApiPathCompanyService, decorators: [{
            type: Injectable
        }] });

class SmsMainApiPathPermissionService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'SmsMainApiPathPermission';
    }
}
SmsMainApiPathPermissionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsMainApiPathPermissionService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
SmsMainApiPathPermissionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsMainApiPathPermissionService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsMainApiPathPermissionService, decorators: [{
            type: Injectable
        }] });

class SmsMainApiPathPriceServiceService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'SmsMainApiPathPriceService';
    }
}
SmsMainApiPathPriceServiceService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsMainApiPathPriceServiceService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
SmsMainApiPathPriceServiceService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsMainApiPathPriceServiceService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsMainApiPathPriceServiceService, decorators: [{
            type: Injectable
        }] });

class SmsMainApiPathAndApiNumberService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'SmsMainApiPathAndApiNumber';
    }
}
SmsMainApiPathAndApiNumberService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsMainApiPathAndApiNumberService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
SmsMainApiPathAndApiNumberService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsMainApiPathAndApiNumberService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsMainApiPathAndApiNumberService, decorators: [{
            type: Injectable
        }] });

class SmsMainApiPathProcessFlowService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'SmsMainApiPathProcessFlow';
    }
}
SmsMainApiPathProcessFlowService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsMainApiPathProcessFlowService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
SmsMainApiPathProcessFlowService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsMainApiPathProcessFlowService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsMainApiPathProcessFlowService, decorators: [{
            type: Injectable
        }] });

class SmsMainApiPathProcessFlowLogService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'SmsMainApiPathProcessFlowLog';
    }
}
SmsMainApiPathProcessFlowLogService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsMainApiPathProcessFlowLogService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
SmsMainApiPathProcessFlowLogService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsMainApiPathProcessFlowLogService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsMainApiPathProcessFlowLogService, decorators: [{
            type: Injectable
        }] });

class SmsMainApiPathPublicConfigService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'SmsMainApiPathPublicConfig';
    }
    ServiceGetOneWithJsonFormatter(id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetOneWithJsonFormatter/' + id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceAutoAdd() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/AutoAdd/', {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
SmsMainApiPathPublicConfigService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsMainApiPathPublicConfigService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
SmsMainApiPathPublicConfigService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsMainApiPathPublicConfigService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsMainApiPathPublicConfigService, decorators: [{
            type: Injectable
        }] });

class SmsMainApiPathSuperSederService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'SmsMainApiPathSuperSeder';
    }
}
SmsMainApiPathSuperSederService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsMainApiPathSuperSederService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
SmsMainApiPathSuperSederService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsMainApiPathSuperSederService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsMainApiPathSuperSederService, decorators: [{
            type: Injectable
        }] });

class SmsMainApiNumberService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'SmsMainApiNumber';
    }
}
SmsMainApiNumberService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsMainApiNumberService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
SmsMainApiNumberService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsMainApiNumberService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsMainApiNumberService, decorators: [{
            type: Injectable
        }] });

class SmsMainApiNumberPermissionService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'SmsMainApiNumberPermission';
    }
}
SmsMainApiNumberPermissionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsMainApiNumberPermissionService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
SmsMainApiNumberPermissionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsMainApiNumberPermissionService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsMainApiNumberPermissionService, decorators: [{
            type: Injectable
        }] });

class SmsMainCustomerCreditService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'SmsMainCustomerCredit';
    }
}
SmsMainCustomerCreditService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsMainCustomerCreditService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
SmsMainCustomerCreditService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsMainCustomerCreditService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsMainCustomerCreditService, decorators: [{
            type: Injectable
        }] });

class SmsMainMessageContentService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'SmsMainMessageContent';
    }
}
SmsMainMessageContentService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsMainMessageContentService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
SmsMainMessageContentService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsMainMessageContentService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsMainMessageContentService, decorators: [{
            type: Injectable
        }] });

class SmsMainMessageCategoryService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'SmsMainMessageCategory';
    }
    ServiceMove(OldId, NewId) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/Move', { Old: OldId, New: NewId }, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
SmsMainMessageCategoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsMainMessageCategoryService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
SmsMainMessageCategoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsMainMessageCategoryService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsMainMessageCategoryService, decorators: [{
            type: Injectable
        }] });

class SmsLogOutBoxQueueService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'SmsLogOutBoxQueue';
    }
    ServiceGetAllReadyToSend(model) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllReadyToSend/', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllSending(model) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllSending/', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
SmsLogOutBoxQueueService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsLogOutBoxQueueService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
SmsLogOutBoxQueueService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsLogOutBoxQueueService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsLogOutBoxQueueService, decorators: [{
            type: Injectable
        }] });

class SmsLogApiPathService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'SmsLogApiPath';
    }
}
SmsLogApiPathService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsLogApiPathService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
SmsLogApiPathService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsLogApiPathService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsLogApiPathService, decorators: [{
            type: Injectable
        }] });

class SmsLogOutBoxTaskSchedulerService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'SmsLogOutBoxTaskScheduler';
    }
    ServiceGetAllReadyToSend(model) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllReadyToSend/', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllSending(model) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllSending/', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
SmsLogOutBoxTaskSchedulerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsLogOutBoxTaskSchedulerService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
SmsLogOutBoxTaskSchedulerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsLogOutBoxTaskSchedulerService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: SmsLogOutBoxTaskSchedulerService, decorators: [{
            type: Injectable
        }] });

class SmsApiSendResultModel {
}

var SmsApiNumberPermissionAccessStatusEnum;
(function (SmsApiNumberPermissionAccessStatusEnum) {
    SmsApiNumberPermissionAccessStatusEnum[SmsApiNumberPermissionAccessStatusEnum["deny"] = 0] = "deny";
    SmsApiNumberPermissionAccessStatusEnum[SmsApiNumberPermissionAccessStatusEnum["allow"] = 1] = "allow";
})(SmsApiNumberPermissionAccessStatusEnum || (SmsApiNumberPermissionAccessStatusEnum = {}));

var SmsApiNumberPermissionActionEnum;
(function (SmsApiNumberPermissionActionEnum) {
    SmsApiNumberPermissionActionEnum[SmsApiNumberPermissionActionEnum["send"] = 0] = "send";
    SmsApiNumberPermissionActionEnum[SmsApiNumberPermissionActionEnum["receive"] = 1] = "receive";
    SmsApiNumberPermissionActionEnum[SmsApiNumberPermissionActionEnum["both"] = 2] = "both";
})(SmsApiNumberPermissionActionEnum || (SmsApiNumberPermissionActionEnum = {}));

var SmsApiPathPermissionAccessStatusEnum;
(function (SmsApiPathPermissionAccessStatusEnum) {
    SmsApiPathPermissionAccessStatusEnum[SmsApiPathPermissionAccessStatusEnum["deny"] = 0] = "deny";
    SmsApiPathPermissionAccessStatusEnum[SmsApiPathPermissionAccessStatusEnum["allow"] = 1] = "allow";
})(SmsApiPathPermissionAccessStatusEnum || (SmsApiPathPermissionAccessStatusEnum = {}));

var SmsApiPathPermissionActionEnum;
(function (SmsApiPathPermissionActionEnum) {
    SmsApiPathPermissionActionEnum[SmsApiPathPermissionActionEnum["api"] = 0] = "api";
    SmsApiPathPermissionActionEnum[SmsApiPathPermissionActionEnum["creditBackApi"] = 1] = "creditBackApi";
})(SmsApiPathPermissionActionEnum || (SmsApiPathPermissionActionEnum = {}));

var SmsMessageTypeEnum;
(function (SmsMessageTypeEnum) {
    SmsMessageTypeEnum[SmsMessageTypeEnum["TextNormal"] = 1] = "TextNormal";
    SmsMessageTypeEnum[SmsMessageTypeEnum["TextUnicode"] = 2] = "TextUnicode";
    SmsMessageTypeEnum[SmsMessageTypeEnum["Voice"] = 3] = "Voice";
})(SmsMessageTypeEnum || (SmsMessageTypeEnum = {}));

var SmsOutBoxTypeEnum;
(function (SmsOutBoxTypeEnum) {
    SmsOutBoxTypeEnum[SmsOutBoxTypeEnum["none"] = 0] = "none";
    SmsOutBoxTypeEnum[SmsOutBoxTypeEnum["One"] = 1] = "One";
    SmsOutBoxTypeEnum[SmsOutBoxTypeEnum["List"] = 2] = "List";
    SmsOutBoxTypeEnum[SmsOutBoxTypeEnum["UserList"] = 3] = "UserList";
    SmsOutBoxTypeEnum[SmsOutBoxTypeEnum["From_N_To_M"] = 4] = "From_N_To_M";
    SmsOutBoxTypeEnum[SmsOutBoxTypeEnum["VCALENDAR"] = 5] = "VCALENDAR";
    SmsOutBoxTypeEnum[SmsOutBoxTypeEnum["WAPPUSH"] = 6] = "WAPPUSH";
    SmsOutBoxTypeEnum[SmsOutBoxTypeEnum["BINARY"] = 7] = "BINARY";
    SmsOutBoxTypeEnum[SmsOutBoxTypeEnum["PhoneBook"] = 8] = "PhoneBook";
    SmsOutBoxTypeEnum[SmsOutBoxTypeEnum["CityBook"] = 9] = "CityBook";
    SmsOutBoxTypeEnum[SmsOutBoxTypeEnum["CityPostCode"] = 10] = "CityPostCode";
    SmsOutBoxTypeEnum[SmsOutBoxTypeEnum["ImportFile"] = 11] = "ImportFile";
    SmsOutBoxTypeEnum[SmsOutBoxTypeEnum["WarinningCredit"] = 12] = "WarinningCredit";
    SmsOutBoxTypeEnum[SmsOutBoxTypeEnum["One_Fast"] = 13] = "One_Fast";
    SmsOutBoxTypeEnum[SmsOutBoxTypeEnum["Api"] = 14] = "Api";
    SmsOutBoxTypeEnum[SmsOutBoxTypeEnum["Resms"] = 15] = "Resms";
    SmsOutBoxTypeEnum[SmsOutBoxTypeEnum["SMSBulk_PhoneBook"] = 16] = "SMSBulk_PhoneBook";
    SmsOutBoxTypeEnum[SmsOutBoxTypeEnum["OneFast"] = 17] = "OneFast";
    SmsOutBoxTypeEnum[SmsOutBoxTypeEnum["Charge"] = 18] = "Charge";
    SmsOutBoxTypeEnum[SmsOutBoxTypeEnum["Login"] = 19] = "Login";
})(SmsOutBoxTypeEnum || (SmsOutBoxTypeEnum = {}));

var SmsProcessFlowRecordStatusEnum;
(function (SmsProcessFlowRecordStatusEnum) {
    SmsProcessFlowRecordStatusEnum[SmsProcessFlowRecordStatusEnum["None"] = 0] = "None";
    SmsProcessFlowRecordStatusEnum[SmsProcessFlowRecordStatusEnum["SendUserToEmail"] = 1] = "SendUserToEmail";
    SmsProcessFlowRecordStatusEnum[SmsProcessFlowRecordStatusEnum["BackUserFromEmail"] = 2] = "BackUserFromEmail";
    SmsProcessFlowRecordStatusEnum[SmsProcessFlowRecordStatusEnum["ProcessFlowCheck"] = 3] = "ProcessFlowCheck";
    SmsProcessFlowRecordStatusEnum[SmsProcessFlowRecordStatusEnum["ProcessFlowSuccessful"] = 4] = "ProcessFlowSuccessful";
    SmsProcessFlowRecordStatusEnum[SmsProcessFlowRecordStatusEnum["ProcessFlowFailed"] = 5] = "ProcessFlowFailed";
    SmsProcessFlowRecordStatusEnum[SmsProcessFlowRecordStatusEnum["GeneratStampValues"] = 6] = "GeneratStampValues";
    SmsProcessFlowRecordStatusEnum[SmsProcessFlowRecordStatusEnum["TimestampOk"] = 7] = "TimestampOk";
    SmsProcessFlowRecordStatusEnum[SmsProcessFlowRecordStatusEnum["TimestampError"] = 8] = "TimestampError";
    SmsProcessFlowRecordStatusEnum[SmsProcessFlowRecordStatusEnum["SendUserToEmailOk"] = 9] = "SendUserToEmailOk";
    SmsProcessFlowRecordStatusEnum[SmsProcessFlowRecordStatusEnum["SendUserToEmailError"] = 10] = "SendUserToEmailError";
    SmsProcessFlowRecordStatusEnum[SmsProcessFlowRecordStatusEnum["BackUserFromEmailOk"] = 11] = "BackUserFromEmailOk";
    SmsProcessFlowRecordStatusEnum[SmsProcessFlowRecordStatusEnum["BackUserFromEmailError"] = 12] = "BackUserFromEmailError";
    SmsProcessFlowRecordStatusEnum[SmsProcessFlowRecordStatusEnum["ProcessFlowShopInvoiceReleaseCheck"] = 13] = "ProcessFlowShopInvoiceReleaseCheck";
})(SmsProcessFlowRecordStatusEnum || (SmsProcessFlowRecordStatusEnum = {}));

var SmsProcessFlowSmsStatusEnum;
(function (SmsProcessFlowSmsStatusEnum) {
    SmsProcessFlowSmsStatusEnum[SmsProcessFlowSmsStatusEnum["None"] = 0] = "None";
    SmsProcessFlowSmsStatusEnum[SmsProcessFlowSmsStatusEnum["Error"] = 1] = "Error";
    SmsProcessFlowSmsStatusEnum[SmsProcessFlowSmsStatusEnum["Paid"] = 2] = "Paid";
    SmsProcessFlowSmsStatusEnum[SmsProcessFlowSmsStatusEnum["Pending"] = 3] = "Pending";
    SmsProcessFlowSmsStatusEnum[SmsProcessFlowSmsStatusEnum["Confirmed"] = 4] = "Confirmed";
    SmsProcessFlowSmsStatusEnum[SmsProcessFlowSmsStatusEnum["DeniedConfirmed"] = 5] = "DeniedConfirmed";
})(SmsProcessFlowSmsStatusEnum || (SmsProcessFlowSmsStatusEnum = {}));

var SmsRecordStatusOutBoxEnum;
(function (SmsRecordStatusOutBoxEnum) {
    SmsRecordStatusOutBoxEnum[SmsRecordStatusOutBoxEnum["Null"] = 0] = "Null";
    SmsRecordStatusOutBoxEnum[SmsRecordStatusOutBoxEnum["AllowToSend"] = 1] = "AllowToSend";
    SmsRecordStatusOutBoxEnum[SmsRecordStatusOutBoxEnum["NeedControl"] = 2] = "NeedControl";
    SmsRecordStatusOutBoxEnum[SmsRecordStatusOutBoxEnum["BlockFromControl"] = 3] = "BlockFromControl";
})(SmsRecordStatusOutBoxEnum || (SmsRecordStatusOutBoxEnum = {}));

class ApplicationConfigurationService extends ApiServerConfigSiteBase {
    getModuleControllerUrl() {
        return 'Application';
    }
}
ApplicationConfigurationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApplicationConfigurationService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ApplicationConfigurationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApplicationConfigurationService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApplicationConfigurationService, decorators: [{
            type: Injectable
        }] });

class ApplicationEnumService extends ApiServerBase {
    getModuleControllerUrl() {
        return 'ApplicationEnum';
    }
    ServiceNotificationTypeEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/NotificationTypeEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceOSTypeEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/OSTypeEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
ApplicationEnumService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApplicationEnumService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ApplicationEnumService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApplicationEnumService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApplicationEnumService, decorators: [{
            type: Injectable
        }] });

class ApplicationScoreDtoModel {
}

class BuilderInfoStatusDtoModel {
}

class UploadApplictionDtoModel {
}

class ApplicationAppService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'Application';
    }
    ServiceScoreClick(model) {
        if (model == null) {
            model = new ApplicationScoreDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/ScoreClick', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceScoreClickList(model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/ScoreClickList', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceCurrentApp() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/CurrentApp', {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceBuild(id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/build/' + id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceBuildInfo(id, key) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/build/' + id + '/' + key, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceBuildInfoSet(model) {
        if (model == null) {
            model = new BuilderInfoStatusDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/BuildInfo', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceUploadUpdate(model) {
        if (model == null) {
            model = new UploadApplictionDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/UploadUpdate', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceUpload(model) {
        if (model == null) {
            model = new UploadApplictionDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/Upload', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
ApplicationAppService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApplicationAppService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ApplicationAppService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApplicationAppService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApplicationAppService, decorators: [{
            type: Injectable
        }] });

class ApplicationIntroService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'ApplicationIntro';
    }
}
ApplicationIntroService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApplicationIntroService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ApplicationIntroService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApplicationIntroService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApplicationIntroService, decorators: [{
            type: Injectable
        }] });

class ApplicationLayoutService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'ApplicationLayout';
    }
    ServiceGetOneWithJsonFormat(model) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetOneWithJsonFormat', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllWithJsonFormat(model) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithJsonFormat', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
ApplicationLayoutService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApplicationLayoutService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ApplicationLayoutService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApplicationLayoutService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApplicationLayoutService, decorators: [{
            type: Injectable
        }] });

class ApplicationLayoutValueService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'ApplicationLayoutValue';
    }
}
ApplicationLayoutValueService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApplicationLayoutValueService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ApplicationLayoutValueService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApplicationLayoutValueService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApplicationLayoutValueService, decorators: [{
            type: Injectable
        }] });

class ApplicationLogNotificationService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'ApplicationLogNotification';
    }
    ServiceSendNotification(model) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/SendNotification', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
ApplicationLogNotificationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApplicationLogNotificationService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ApplicationLogNotificationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApplicationLogNotificationService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApplicationLogNotificationService, decorators: [{
            type: Injectable
        }] });

class ApplicationMemberInfoService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'ApplicationMemberInfo';
    }
}
ApplicationMemberInfoService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApplicationMemberInfoService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ApplicationMemberInfoService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApplicationMemberInfoService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApplicationMemberInfoService, decorators: [{
            type: Injectable
        }] });

class ApplicationSourceService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'ApplicationSource';
    }
    ServiceBuildApp(Id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/buildApp/' + Id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
ApplicationSourceService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApplicationSourceService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ApplicationSourceService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApplicationSourceService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApplicationSourceService, decorators: [{
            type: Injectable
        }] });

class ApplicationSourceSiteCategoryService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'ApplicationSourceSiteCategory';
    }
}
ApplicationSourceSiteCategoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApplicationSourceSiteCategoryService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ApplicationSourceSiteCategoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApplicationSourceSiteCategoryService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApplicationSourceSiteCategoryService, decorators: [{
            type: Injectable
        }] });

class ApplicationThemeConfigService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'ApplicationThemeConfig';
    }
    ServiceCurrentTheme() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/CurrentTheme', {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
ApplicationThemeConfigService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApplicationThemeConfigService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ApplicationThemeConfigService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApplicationThemeConfigService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ApplicationThemeConfigService, decorators: [{
            type: Injectable
        }] });

class ApplicationModuleConfigAdminMainValuesModel extends BaseModuleConfigAdminMainValuesModel {
}
class ApplicationModuleConfigSiteAccessValuesModel extends BaseModuleConfigSiteAccessValuesModel {
}
/// <summary>
/// با ثبت یک هایپر شاپ باید یک ردیف خام با مقادیر اولیه در بانک ثبت شود
/// این کار باید از سمت سرور انجام شود و کلاینت اجازه ویرایش یا حذف این ردیف را نداشته باشد
/// </summary>
class ApplicationModuleConfigSiteValuesModel extends BaseModuleConfigSiteValuesModel {
}
class ApplicationModuleSiteStorageValuesModel extends BaseModuleSiteStorageValuesModel {
}

//@@tag-Version-2201011
class ApplicationAppModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class ApplicationIntroModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class ApplicationLayoutModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class ApplicationLayoutValueModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class ApplicationLogNotificationModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class ApplicationMemberInfoModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class ApplicationSourceModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class ApplicationSourceSiteCategoryModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class ApplicationThemeConfigModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class AppMainLayoutMainRequestModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class ThemeConfigLayoutModel {
}

class AppMainDtoModel {
}

class AppMainHederDtoModel {
}

class RenderModelApplicationSendNotificationInput {
}

class SendNotificationModel extends RenderModelApplicationSendNotificationInput {
}

class ScoreClickInfoModel {
}

class PollingConfigurationService extends ApiServerConfigSiteBase {
    getModuleControllerUrl() {
        return 'polling';
    }
}
PollingConfigurationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PollingConfigurationService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
PollingConfigurationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PollingConfigurationService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PollingConfigurationService, decorators: [{
            type: Injectable
        }] });

class PollingCategoryService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'PollingCategory';
    }
    ServiceMove(OldId, NewId) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/Move', { Old: OldId, New: NewId }, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
PollingCategoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PollingCategoryService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
PollingCategoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PollingCategoryService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PollingCategoryService, decorators: [{
            type: Injectable
        }] });

class PollingContentService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'PollingContent';
    }
}
PollingContentService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PollingContentService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
PollingContentService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PollingContentService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PollingContentService, decorators: [{
            type: Injectable
        }] });

class PollingOptionService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'PollingOption';
    }
}
PollingOptionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PollingOptionService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
PollingOptionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PollingOptionService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PollingOptionService, decorators: [{
            type: Injectable
        }] });

class PollingVoteService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'PollingVote';
    }
    ServiceAddBatch(model) {
        if (model == null) {
            model = [];
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/AddBatch', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
PollingVoteService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PollingVoteService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
PollingVoteService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PollingVoteService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PollingVoteService, decorators: [{
            type: Injectable
        }] });

class PollingModuleConfigAdminMainValuesModel extends BaseModuleConfigAdminMainValuesModel {
}
class PollingModuleConfigSiteAccessValuesModel extends BaseModuleConfigSiteAccessValuesModel {
}
/// <summary>
/// با ثبت یک هایپر شاپ باید یک ردیف خام با مقادیر اولیه در بانک ثبت شود
/// این کار باید از سمت سرور انجام شود و کلاینت اجازه ویرایش یا حذف این ردیف را نداشته باشد
/// </summary>
class PollingModuleConfigSiteValuesModel extends BaseModuleConfigSiteValuesModel {
}
class PollingModuleSiteStorageValuesModel extends BaseModuleSiteStorageValuesModel {
}

//@@tag-Version-2201011
class PollingCategoryModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class PollingContentModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class PollingOptionModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class PollingVoteModel extends BaseModuleEntity {
}

class ContactConfigurationService extends ApiServerConfigSiteBase {
    getModuleControllerUrl() {
        return 'contact';
    }
}
ContactConfigurationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ContactConfigurationService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ContactConfigurationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ContactConfigurationService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ContactConfigurationService, decorators: [{
            type: Injectable
        }] });

class ContactCategoryService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'ContactCategory';
    }
    ServiceMove(OldId, NewId) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/Move', { Old: OldId, New: NewId }, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
ContactCategoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ContactCategoryService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ContactCategoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ContactCategoryService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ContactCategoryService, decorators: [{
            type: Injectable
        }] });

class ContactContentService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'ContactContent';
    }
}
ContactContentService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ContactContentService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ContactContentService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ContactContentService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ContactContentService, decorators: [{
            type: Injectable
        }] });

class ContactModuleConfigAdminMainValuesModel extends BaseModuleConfigAdminMainValuesModel {
}
class ContactModuleConfigSiteAccessValuesModel extends BaseModuleConfigSiteAccessValuesModel {
}
/// <summary>
/// با ثبت یک هایپر شاپ باید یک ردیف خام با مقادیر اولیه در بانک ثبت شود
/// این کار باید از سمت سرور انجام شود و کلاینت اجازه ویرایش یا حذف این ردیف را نداشته باشد
/// </summary>
class ContactModuleConfigSiteValuesModel extends BaseModuleConfigSiteValuesModel {
}
class ContactModuleSiteStorageValuesModel extends BaseModuleSiteStorageValuesModel {
}

//@@tag-Version-2201011
class ContactCategoryModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class ContactContentModel extends BaseModuleEntity {
}

class TicketingConfigurationService extends ApiServerConfigSiteBase {
    getModuleControllerUrl() {
        return 'ticketing';
    }
}
TicketingConfigurationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TicketingConfigurationService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
TicketingConfigurationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TicketingConfigurationService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TicketingConfigurationService, decorators: [{
            type: Injectable
        }] });

class TicketingAnswerService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'TicketingAnswer';
    }
    ServiceAnswerReaded(id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/AnswerReaded/' + id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
TicketingAnswerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TicketingAnswerService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
TicketingAnswerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TicketingAnswerService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TicketingAnswerService, decorators: [{
            type: Injectable
        }] });

class TicketingDepartemenService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'TicketingDepartemen';
    }
    ServiceGetAllOrigin(model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllOrigin/', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
TicketingDepartemenService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TicketingDepartemenService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
TicketingDepartemenService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TicketingDepartemenService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TicketingDepartemenService, decorators: [{
            type: Injectable
        }] });

class TicketingDepartemenLogService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'TicketingDepartemenLog';
    }
}
TicketingDepartemenLogService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TicketingDepartemenLogService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
TicketingDepartemenLogService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TicketingDepartemenLogService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TicketingDepartemenLogService, decorators: [{
            type: Injectable
        }] });

class TicketingDepartemenOperatorService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'TicketingDepartemenOperator';
    }
    ServiceGetAllOperator(model) {
        // this.loadingStatus=true;
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllOperator', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
TicketingDepartemenOperatorService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TicketingDepartemenOperatorService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
TicketingDepartemenOperatorService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TicketingDepartemenOperatorService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TicketingDepartemenOperatorService, decorators: [{
            type: Injectable
        }] });

class TicketingFaqService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'TicketingFaq';
    }
    ServiceGetAllOrigin(model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllOrigin/', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
TicketingFaqService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TicketingFaqService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
TicketingFaqService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TicketingFaqService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TicketingFaqService, decorators: [{
            type: Injectable
        }] });

//@@tag-Version-2201011
class TicketingTaskModel extends BaseModuleEntity {
}

class TicketingTaskDtoModel extends TicketingTaskModel {
}

class TicketingTaskService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'TicketingTask';
    }
    ServiceContactUS(model) {
        if (model == null) {
            model = new TicketingTaskDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/ContactUS', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceTaskReaded(id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/TaskReaded/' + id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceisClosed(id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/isClosed/' + id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
TicketingTaskService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TicketingTaskService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
TicketingTaskService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TicketingTaskService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TicketingTaskService, decorators: [{
            type: Injectable
        }] });

class TicketingTemplateService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'TicketingTemplate';
    }
}
TicketingTemplateService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TicketingTemplateService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
TicketingTemplateService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TicketingTemplateService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TicketingTemplateService, decorators: [{
            type: Injectable
        }] });

class TicketingEnumService extends ApiServerBase {
    getModuleControllerUrl() {
        return 'ticketingEnum';
    }
    ServiceTicketingDepartemenPriorityEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/TicketingDepartemenPriorityEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceTicketStatusEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/TicketStatusEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceAnswerStatusEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/AnswerStatusEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
TicketingEnumService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TicketingEnumService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
TicketingEnumService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TicketingEnumService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: TicketingEnumService, decorators: [{
            type: Injectable
        }] });

class TicketingModuleConfigAdminMainValuesModel extends BaseModuleConfigAdminMainValuesModel {
}
class TicketingModuleConfigSiteAccessValuesModel extends BaseModuleConfigSiteAccessValuesModel {
}
/// <summary>
/// با ثبت یک هایپر شاپ باید یک ردیف خام با مقادیر اولیه در بانک ثبت شود
/// این کار باید از سمت سرور انجام شود و کلاینت اجازه ویرایش یا حذف این ردیف را نداشته باشد
/// </summary>
class TicketingModuleConfigSiteValuesModel extends BaseModuleConfigSiteValuesModel {
}
class TicketingModuleSiteStorageValuesModel extends BaseModuleSiteStorageValuesModel {
}

//@@tag-Version-2201011
class TicketingAnswerModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class TicketingDepartemenLogModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class TicketingDepartemenModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class TicketingDepartemenOperatorModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class TicketingFaqModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class TicketingTemplateModel extends BaseModuleEntity {
}

var TicketStatusEnum;
(function (TicketStatusEnum) {
    TicketStatusEnum[TicketStatusEnum["Unread"] = 0] = "Unread";
    TicketStatusEnum[TicketStatusEnum["Read"] = 1] = "Read";
    TicketStatusEnum[TicketStatusEnum["Answered"] = 2] = "Answered";
    TicketStatusEnum[TicketStatusEnum["Ended"] = 3] = "Ended";
})(TicketStatusEnum || (TicketStatusEnum = {}));

var TicketingDepartemenPriorityEnum;
(function (TicketingDepartemenPriorityEnum) {
    TicketingDepartemenPriorityEnum[TicketingDepartemenPriorityEnum["Low"] = 0] = "Low";
    TicketingDepartemenPriorityEnum[TicketingDepartemenPriorityEnum["Medium"] = 1] = "Medium";
    TicketingDepartemenPriorityEnum[TicketingDepartemenPriorityEnum["High"] = 2] = "High";
    TicketingDepartemenPriorityEnum[TicketingDepartemenPriorityEnum["VeryHigh"] = 3] = "VeryHigh";
})(TicketingDepartemenPriorityEnum || (TicketingDepartemenPriorityEnum = {}));

var TicketAccessStatusEnum;
(function (TicketAccessStatusEnum) {
    TicketAccessStatusEnum[TicketAccessStatusEnum["Deny"] = 0] = "Deny";
    TicketAccessStatusEnum[TicketAccessStatusEnum["Access"] = 1] = "Access";
    TicketAccessStatusEnum[TicketAccessStatusEnum["Inherit"] = 2] = "Inherit";
})(TicketAccessStatusEnum || (TicketAccessStatusEnum = {}));

var AnswerStatusEnum;
(function (AnswerStatusEnum) {
    AnswerStatusEnum[AnswerStatusEnum["Unread"] = 0] = "Unread";
    AnswerStatusEnum[AnswerStatusEnum["Read"] = 1] = "Read";
    AnswerStatusEnum[AnswerStatusEnum["Answered"] = 2] = "Answered";
    AnswerStatusEnum[AnswerStatusEnum["Ended"] = 3] = "Ended";
})(AnswerStatusEnum || (AnswerStatusEnum = {}));

class HyperShopConfigurationService extends ApiServerConfigSiteBase {
    getModuleControllerUrl() {
        return 'HyperShop';
    }
}
HyperShopConfigurationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: HyperShopConfigurationService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
HyperShopConfigurationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: HyperShopConfigurationService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: HyperShopConfigurationService, decorators: [{
            type: Injectable
        }] });

class HyperShopCategoryService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'HyperShopCategory';
    }
    ServiceGetAllMicroService(model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllMicroService/', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetOneMicroService(id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetOneMicroService/' + id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
HyperShopCategoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: HyperShopCategoryService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
HyperShopCategoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: HyperShopCategoryService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: HyperShopCategoryService, decorators: [{
            type: Injectable
        }] });

class HyperShopContentService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'HyperShopContent';
    }
    ServiceGetAllMicroService(model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllMicroService/', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetOneMicroService(id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetOneMicroService/' + id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceFavoriteAdd(Id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/FavoriteAdd/' + Id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceFavoriteRemove(Id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/FavoriteRemove/' + Id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceFavoriteList(model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/FavoriteList', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
HyperShopContentService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: HyperShopContentService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
HyperShopContentService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: HyperShopContentService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: HyperShopContentService, decorators: [{
            type: Injectable
        }] });

class HyperShopOrderService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'HyperShopOrder';
    }
    ServiceOrderAdd() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/LastOrder', {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceOrderCalculate(model) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/OrderCalculate', {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceOrderPayment(model) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/OrderPayment', {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
HyperShopOrderService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: HyperShopOrderService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
HyperShopOrderService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: HyperShopOrderService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: HyperShopOrderService, decorators: [{
            type: Injectable
        }] });

class HyperShopModuleConfigAdminMainValuesModel extends BaseModuleConfigAdminMainValuesModel {
}
class HyperShopModuleConfigSiteAccessValuesModel extends BaseModuleConfigSiteAccessValuesModel {
}
/// <summary>
/// با ثبت یک هایپر شاپ باید یک ردیف خام با مقادیر اولیه در بانک ثبت شود
/// این کار باید از سمت سرور انجام شود و کلاینت اجازه ویرایش یا حذف این ردیف را نداشته باشد
/// </summary>
class HyperShopModuleConfigSiteValuesModel extends BaseModuleConfigSiteValuesModel {
}
class HyperShopModuleSiteStorageValuesModel extends BaseModuleSiteStorageValuesModel {
}

//@@tag-Version-2201011
class HyperShopOrderModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class HyperShopOrderContentModel {
}

//@@tag-Version-2201011
class HyperShopCategoryModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class HyperShopContentModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class HyperShopPaymentModel extends BaseModuleEntity {
}

class HyperShopOrderDtoModel {
}

class HyperShopOrderContentDtoModel {
}

class HyperShopOrderPaymentDtoModel {
}

class CheckStatusActionModel {
}

class BiographyConfigurationService extends ApiServerConfigSiteBase {
    getModuleControllerUrl() {
        return 'biography';
    }
}
BiographyConfigurationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BiographyConfigurationService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
BiographyConfigurationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BiographyConfigurationService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BiographyConfigurationService, decorators: [{
            type: Injectable
        }] });

class BiographyCategoryService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'BiographyCategory';
    }
    ServiceMove(OldId, NewId) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/Move', { Old: OldId, New: NewId }, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
BiographyCategoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BiographyCategoryService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
BiographyCategoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BiographyCategoryService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BiographyCategoryService, decorators: [{
            type: Injectable
        }] });

class BiographyCommentService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'BiographyComment';
    }
    ServiceLikeClick(Id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/LikeClick/' + Id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceDisLikeClick(Id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/DisLikeClick/' + Id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
}
BiographyCommentService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BiographyCommentService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
BiographyCommentService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BiographyCommentService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BiographyCommentService, decorators: [{
            type: Injectable
        }] });

class BiographyContentWithSimilarLocationPeriodDtoModel {
}

class BiographyContentWithDatePeriodEndDtoModel {
}

class BiographyContentWithSimilarDatePeriodEndDtoModel {
}

class BiographyContentWithSimilarDatePeriodStartDayAndMonthOfYearDtoModel {
}

class BiographyContentWithSimilarDatePeriodStartDayOfYearDtoModel {
}

class BiographyContentWithSimilarDatePeriodStartDtoModel {
}

class BiographyContentWithSimilarDatePeriodStartMonthOfYearListDtoModel {
}

class BiographyContentService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'BiographyContent';
    }
    ServiceGetAllWithHierarchyCategoryId(Id, model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithHierarchyCategoryId/' + Id, model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllWithSimilarsId(Id, model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithSimilarsId/' + Id, model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllWithTagId(Id, model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithTagId/' + Id, model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllWithCategoryUseInContentId(Id, model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithCategoryUseInContentId/' + Id, model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceScoreClick(model) {
        if (model == null) {
            model = new ScoreClickDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/ScoreClick', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceFavoriteAdd(Id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/FavoriteAdd/' + Id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceFavoriteRemove(Id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/FavoriteRemove/' + Id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceFavoriteList(model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/FavoriteList', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllWithSimilarLocationPeriodStart(model) {
        if (model == null) {
            model = new BiographyContentWithSimilarLocationPeriodDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithSimilarLocationPeriodStart', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllWithSimilarLocationPeriodEnd(model) {
        if (model == null) {
            model = new BiographyContentWithSimilarLocationPeriodDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithSimilarLocationPeriodEnd', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllWithSimilarDatePeriodStartMonthOfYear(model) {
        if (model == null) {
            model = new BiographyContentWithSimilarDatePeriodStartMonthOfYearListDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithSimilarDatePeriodStartMonthOfYear', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllWithSimilarDatePeriodStart(model) {
        if (model == null) {
            model = new BiographyContentWithSimilarDatePeriodStartDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithSimilarDatePeriodStart', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllWithSimilarDatePeriodStartDayOfYear(model) {
        if (model == null) {
            model = new BiographyContentWithSimilarDatePeriodStartDayOfYearDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithSimilarDatePeriodStartDayOfYear', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllWithSimilarDatePeriodStartDayAndMonthOfYear(model) {
        if (model == null) {
            model = new BiographyContentWithSimilarDatePeriodStartDayAndMonthOfYearDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithSimilarDatePeriodStartDayAndMonthOfYear', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllGetAllWithSimilarDatePeriodEnd(model) {
        if (model == null) {
            model = new BiographyContentWithSimilarDatePeriodEndDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithSimilarDatePeriodEnd', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllGetAllWithDatePeriodEnd(model) {
        if (model == null) {
            model = new BiographyContentWithDatePeriodEndDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithDatePeriodEnd', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
BiographyContentService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BiographyContentService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
BiographyContentService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BiographyContentService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BiographyContentService, decorators: [{
            type: Injectable
        }] });

class BiographyContentAndParameterValueService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'BiographyContentAndParameterValue';
    }
}
BiographyContentAndParameterValueService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BiographyContentAndParameterValueService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
BiographyContentAndParameterValueService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BiographyContentAndParameterValueService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BiographyContentAndParameterValueService, decorators: [{
            type: Injectable
        }] });

class BiographyContentOtherInfoService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'BiographyContentOtherInfo';
    }
    ServiceAddBatch(model) {
        if (model == null) {
            model = [];
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/AddBatch', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceEditBatch(model) {
        if (model == null) {
            model = [];
        }
        return this.http
            .put(this.getBaseUrl() + this.getModuleControllerUrl() + '/EditBatch', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
BiographyContentOtherInfoService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BiographyContentOtherInfoService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
BiographyContentOtherInfoService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BiographyContentOtherInfoService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BiographyContentOtherInfoService, decorators: [{
            type: Injectable
        }] });

class BiographyContentParameterService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'BiographyContentParameter';
    }
}
BiographyContentParameterService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BiographyContentParameterService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
BiographyContentParameterService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BiographyContentParameterService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BiographyContentParameterService, decorators: [{
            type: Injectable
        }] });

class BiographyContentParameterTypeService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'BiographyContentParameterType';
    }
}
BiographyContentParameterTypeService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BiographyContentParameterTypeService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
BiographyContentParameterTypeService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BiographyContentParameterTypeService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BiographyContentParameterTypeService, decorators: [{
            type: Injectable
        }] });

class BiographyContentSimilarService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'BiographyContentSimilar';
    }
    ServiceAddBatch(model) {
        if (model == null) {
            model = [];
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/AddBatch', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceDeleteBatch(model) {
        if (model == null) {
            model = [];
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/DeleteBatch', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
BiographyContentSimilarService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BiographyContentSimilarService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
BiographyContentSimilarService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BiographyContentSimilarService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BiographyContentSimilarService, decorators: [{
            type: Injectable
        }] });

class BiographyContentTagService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'BiographyContentTag';
    }
    ServiceAddBatch(model) {
        if (model == null) {
            model = [];
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/AddBatch', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceDeleteBatch(model) {
        if (model == null) {
            model = [];
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/DeleteBatch', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
BiographyContentTagService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BiographyContentTagService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
BiographyContentTagService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BiographyContentTagService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BiographyContentTagService, decorators: [{
            type: Injectable
        }] });

class BiographyShareMainAdminSettingService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'BiographyShareMainAdminSetting';
    }
}
BiographyShareMainAdminSettingService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BiographyShareMainAdminSettingService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
BiographyShareMainAdminSettingService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BiographyShareMainAdminSettingService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BiographyShareMainAdminSettingService, decorators: [{
            type: Injectable
        }] });

class BiographyShareReceiverCategoryService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'BiographyShareReceiverCategory';
    }
}
BiographyShareReceiverCategoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BiographyShareReceiverCategoryService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
BiographyShareReceiverCategoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BiographyShareReceiverCategoryService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BiographyShareReceiverCategoryService, decorators: [{
            type: Injectable
        }] });

class BiographyShareServerCategoryService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'BiographyShareServerCategory';
    }
    ServiceGetAllOtherSite(model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllOtherSite/', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
BiographyShareServerCategoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BiographyShareServerCategoryService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
BiographyShareServerCategoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BiographyShareServerCategoryService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BiographyShareServerCategoryService, decorators: [{
            type: Injectable
        }] });

class BiographyContentCategoryService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'BiographyContentCategory';
    }
}
BiographyContentCategoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BiographyContentCategoryService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
BiographyContentCategoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BiographyContentCategoryService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: BiographyContentCategoryService, decorators: [{
            type: Injectable
        }] });

class BiographyModuleConfigAdminMainValuesModel extends BaseModuleConfigAdminMainValuesModel {
}
class BiographyModuleConfigSiteAccessValuesModel extends BaseModuleConfigSiteAccessValuesModel {
}
/// <summary>
/// با ثبت یک هایپر شاپ باید یک ردیف خام با مقادیر اولیه در بانک ثبت شود
/// این کار باید از سمت سرور انجام شود و کلاینت اجازه ویرایش یا حذف این ردیف را نداشته باشد
/// </summary>
class BiographyModuleConfigSiteValuesModel extends BaseModuleConfigSiteValuesModel {
}
class BiographyModuleSiteStorageValuesModel extends BaseModuleSiteStorageValuesModel {
}

//@@tag-Version-2201011
class BiographyCategoryModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class BiographyCommentModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class BiographyContentModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class BiographyContentOtherInfoModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class BiographyContentSimilarModel {
}

//@@tag-Version-2201011
class BiographyContentTagModel {
}

//@@tag-Version-2201011
class BiographyContentCategoryModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class BiographyShareMainAdminSettingModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class BiographyShareReceiverCategoryModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class BiographyShareServerCategoryModel extends BaseModuleEntity {
}

class EstateConfigurationService extends ApiServerConfigSiteBase {
    getModuleControllerUrl() {
        return 'Estate';
    }
}
EstateConfigurationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateConfigurationService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
EstateConfigurationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateConfigurationService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateConfigurationService, decorators: [{
            type: Injectable
        }] });

class EstateEnumService extends ApiServerBase {
    getModuleControllerUrl() {
        return 'EstateEnum';
    }
    ServiceEstateUserTypeEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/EstateUserTypeEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceEstatePropertyExpertPriceTypeEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/PropertyExpertPriceTypeEnumEstate', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceEstateActivityStatusEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/ActivityStatusEnumEstate', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
EstateEnumService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateEnumService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
EstateEnumService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateEnumService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateEnumService, decorators: [{
            type: Injectable
        }] });

class EstateAccountAgencyService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'EstateAccountAgency';
    }
}
EstateAccountAgencyService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateAccountAgencyService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
EstateAccountAgencyService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateAccountAgencyService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateAccountAgencyService, decorators: [{
            type: Injectable
        }] });

class EstateModuleSaleAccountAgencyAdsPaymentDtoModel {
}

class EstateModuleSaleAccountAgencyAdsCalculateDtoModel {
}

class EstateAccountAgencyAdsService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'EstateAccountAgencyAds';
    }
    ServiceOrderCalculate(model) {
        if (!model) {
            model = new EstateModuleSaleAccountAgencyAdsCalculateDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/OrderCalculate', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceOrderPayment(model) {
        if (!model) {
            model = new EstateModuleSaleAccountAgencyAdsPaymentDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/OrderPayment', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
EstateAccountAgencyAdsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateAccountAgencyAdsService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
EstateAccountAgencyAdsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateAccountAgencyAdsService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateAccountAgencyAdsService, decorators: [{
            type: Injectable
        }] });

class EstateAccountAgencyUserService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'EstateAccountAgencyUser';
    }
}
EstateAccountAgencyUserService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateAccountAgencyUserService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
EstateAccountAgencyUserService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateAccountAgencyUserService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateAccountAgencyUserService, decorators: [{
            type: Injectable
        }] });

class EstateAccountUserService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'EstateAccountUser';
    }
}
EstateAccountUserService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateAccountUserService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
EstateAccountUserService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateAccountUserService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateAccountUserService, decorators: [{
            type: Injectable
        }] });

class EstateContractService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'EstateContract';
    }
}
EstateContractService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateContractService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
EstateContractService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateContractService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateContractService, decorators: [{
            type: Injectable
        }] });

class EstateContractTypeService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'EstateContractType';
    }
}
EstateContractTypeService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateContractTypeService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
EstateContractTypeService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateContractTypeService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateContractTypeService, decorators: [{
            type: Injectable
        }] });

class EstatePropertyAccountTypeUserService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'EstatePropertyAccountTypeUser';
    }
}
EstatePropertyAccountTypeUserService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyAccountTypeUserService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
EstatePropertyAccountTypeUserService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyAccountTypeUserService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyAccountTypeUserService, decorators: [{
            type: Injectable
        }] });

class EstatePropertyDetailGroupService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'EstatePropertyDetailGroup';
    }
    ServiceGetAllFastSearch(model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllFastSearch/', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceEditStep(model) {
        if (!model) {
            model = new EditStepDtoModel();
        }
        return this.http
            .put(this.getBaseUrl() + this.getModuleControllerUrl() + '/EditStep', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
}
EstatePropertyDetailGroupService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyDetailGroupService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
EstatePropertyDetailGroupService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyDetailGroupService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyDetailGroupService, decorators: [{
            type: Injectable
        }] });

class EstatePropertyDetailService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'EstatePropertyDetail';
    }
    ServiceEditStep(model) {
        if (!model) {
            model = new EditStepDtoModel();
        }
        return this.http
            .put(this.getBaseUrl() + this.getModuleControllerUrl() + '/EditStep', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
}
EstatePropertyDetailService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyDetailService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
EstatePropertyDetailService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyDetailService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyDetailService, decorators: [{
            type: Injectable
        }] });

class EstatePropertyHistoryService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'EstatePropertyHistory';
    }
}
EstatePropertyHistoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyHistoryService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
EstatePropertyHistoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyHistoryService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyHistoryService, decorators: [{
            type: Injectable
        }] });

class EstateModuleSalePropertyAdsPaymentDtoModel {
}

class EstateModuleSalePropertyAdsCalculateDtoModel {
}

class EstatePropertyAdsService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'EstatePropertyAds';
    }
    ServiceOrderCalculate(model) {
        if (!model) {
            model = new EstateModuleSalePropertyAdsCalculateDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/OrderCalculate', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceOrderPayment(model) {
        if (!model) {
            model = new EstateModuleSalePropertyAdsPaymentDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/OrderPayment', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
EstatePropertyAdsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyAdsService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
EstatePropertyAdsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyAdsService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyAdsService, decorators: [{
            type: Injectable
        }] });

class EstateAdsTypeService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'EstateAdsType';
    }
    ServiceGetAllSale(model) {
        if (!model) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllSale', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceCheckUseAdsForProperty(AdsTypeId, id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/CheckUseAdsForProperty/' + AdsTypeId + '/' + id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceCheckUseAdsForAccountAgency(AdsTypeId, id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/CheckUseAdsForAccountAgency/' + AdsTypeId + '/' + id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
EstateAdsTypeService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateAdsTypeService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
EstateAdsTypeService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateAdsTypeService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateAdsTypeService, decorators: [{
            type: Injectable
        }] });

class EstateBillboardService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'EstateBillboard';
    }
}
EstateBillboardService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateBillboardService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
EstateBillboardService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateBillboardService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateBillboardService, decorators: [{
            type: Injectable
        }] });

class EstateCustomerOrderFilterModel extends FilterModel {
}

class EstateCustomerOrderService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'EstateCustomerOrder';
    }
    ServiceActionSendSms(model) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/ActionSendSms/', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    // ServiceGetAllWithFilter(model: EstateCustomerOrderFilterModel): Observable<ErrorExceptionResult<EstateCustomerOrderModel>> {
    //   if (model == null) {
    //     model = new EstateCustomerOrderFilterModel();
    //   }
    //   return this.http
    //     .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithFilter/', model, {
    //       headers: this.getHeaders(),
    //     })
    //     .pipe(
    //       retry(this.configApiRetry),
    //       // catchError(this.handleError)
    //       map((ret: any) => {
    //         return this.errorExceptionResultCheck(ret);
    //       }),
    //     );
    // }
    ServiceGetAllWithResponsibleUserId(userId, model) {
        if (model == null) {
            model = new EstateCustomerOrderFilterModel();
        }
        if (!userId || userId < 0) {
            userId = 0;
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithResponsibleUserId/' + userId, model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllWithCoverPropertyId(propertyId, model) {
        if (model == null) {
            model = new EstateCustomerOrderFilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithCoverPropertyId/' + propertyId, model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllWithCoverPropertyIdHaveHistory(propertyId, model) {
        if (model == null) {
            model = new EstateCustomerOrderFilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithCoverPropertyIdHaveHistory/' + propertyId, model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllWithResponsibleUserIdExportFile(userId, model) {
        // this.loadingStatus=true;
        if (model == null) {
            model = new EstateCustomerOrderFilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithResponsibleUserIdExportFile/' + userId, model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheckExportFile(ret);
        }));
    }
}
EstateCustomerOrderService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateCustomerOrderService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
EstateCustomerOrderService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateCustomerOrderService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateCustomerOrderService, decorators: [{
            type: Injectable
        }] });

class EstatePropertyFilterModel extends FilterModel {
}

class EstatePropertyService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'EstateProperty';
    }
    ServiceActionSendSmsToCustomerOrder(Id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/ActionSendSmsToCustomerOrder/' + Id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceActionSendSms(model) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/ActionSendSms/', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceFavoriteAdd(Id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/FavoriteAdd/' + Id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceFavoriteRemove(Id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/FavoriteRemove/' + Id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceFavoriteList(model) {
        if (model == null) {
            model = new EstatePropertyFilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/FavoriteList', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceReportAbuseAdd(model) {
        if (model == null) {
            model = new CoreModuleReportAbuseDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/ReportAbuseAdd', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceReportAbuseList(model) {
        if (model == null) {
            model = new EstatePropertyFilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/ReportAbuseList', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    // ServiceGetAllWithFilter(model: EstatePropertyFilterModel): Observable<ErrorExceptionResult<EstatePropertyModel>> {
    //   if (model == null) {
    //     model = new EstatePropertyFilterModel();
    //   }
    //   return this.http
    //     .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithFilter/', model, {
    //       headers: this.getHeaders(),
    //     })
    //     .pipe(
    //       retry(this.configApiRetry),
    //       // catchError(this.handleError)
    //       map((ret: any) => {
    //         return this.errorExceptionResultCheck(ret);
    //       }),
    //     );
    // }
    ServiceGetAllWithBillboardId(BillboardId, model) {
        if (model == null) {
            model = new EstatePropertyFilterModel();
        }
        if (!BillboardId || BillboardId.length === 0) {
            BillboardId = '00';
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithBillboardId/' + BillboardId, model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllWithCoverCustomerOrderId(CustomerOrderId, model) {
        if (model == null) {
            model = new EstatePropertyFilterModel();
        }
        if (!CustomerOrderId || CustomerOrderId.length === 0) {
            CustomerOrderId = '00';
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithCoverCustomerOrderId/' + CustomerOrderId, model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllWithCoverCustomerOrderIdHaveHistory(CustomerOrderId, model) {
        if (model == null) {
            model = new EstatePropertyFilterModel();
        }
        if (!CustomerOrderId || CustomerOrderId.length === 0) {
            CustomerOrderId = '00';
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithCoverCustomerOrderIdHaveHistory/' + CustomerOrderId, model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllWithCoverCustomerOrderIdExportFile(CustomerOrderId, model) {
        // this.loadingStatus=true;
        if (model == null) {
            model = new EstatePropertyFilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithCoverCustomerOrderIdExportFile/' + CustomerOrderId, model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheckExportFile(ret);
        }));
    }
    ServiceGetAllWithResponsibleUserId(userId, model) {
        if (model == null) {
            model = new EstatePropertyFilterModel();
        }
        if (!userId || userId < 0) {
            userId = 0;
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithResponsibleUserId/' + userId, model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllWithResponsibleUserIdExportFile(userId, model) {
        // this.loadingStatus=true;
        if (model == null) {
            model = new EstatePropertyFilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithResponsibleUserIdExportFile/' + userId, model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheckExportFile(ret);
        }));
    }
}
EstatePropertyService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
EstatePropertyService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyService, decorators: [{
            type: Injectable
        }] });

class EstatePropertyTypeService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'EstatePropertyType';
    }
}
EstatePropertyTypeService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyTypeService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
EstatePropertyTypeService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyTypeService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyTypeService, decorators: [{
            type: Injectable
        }] });

class EstatePropertyTypeLanduseService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'EstatePropertyTypeLanduse';
    }
}
EstatePropertyTypeLanduseService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyTypeLanduseService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
EstatePropertyTypeLanduseService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyTypeLanduseService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyTypeLanduseService, decorators: [{
            type: Injectable
        }] });

class EstatePropertyTypeUsageService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'EstatePropertyTypeUsage';
    }
}
EstatePropertyTypeUsageService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyTypeUsageService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
EstatePropertyTypeUsageService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyTypeUsageService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyTypeUsageService, decorators: [{
            type: Injectable
        }] });

class EstatePropertyShareAgencyService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'EstatePropertyShareAgency';
    }
    ServiceJoin(linkEstateAgencyId, shareKey) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/Join/' + linkEstateAgencyId + "/" + shareKey, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
EstatePropertyShareAgencyService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyShareAgencyService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
EstatePropertyShareAgencyService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyShareAgencyService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyShareAgencyService, decorators: [{
            type: Injectable
        }] });

class EstatePropertyShareAgentService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'EstatePropertyShareAgent';
    }
    ServiceJoin(linkEstateAgentId, shareKey) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/Join/' + linkEstateAgentId + "/" + shareKey, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
EstatePropertyShareAgentService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyShareAgentService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
EstatePropertyShareAgentService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyShareAgentService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyShareAgentService, decorators: [{
            type: Injectable
        }] });

class EstatePropertyShareSiteService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'EstatePropertyShareSite';
    }
    ServiceJoinBySiteId(linkSitId, shareKey) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/Join/' + linkSitId + "/" + shareKey, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceJoin(shareKey) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/Join/' + shareKey, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
EstatePropertyShareSiteService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyShareSiteService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
EstatePropertyShareSiteService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyShareSiteService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyShareSiteService, decorators: [{
            type: Injectable
        }] });

class EstatePropertyProjectService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'EstatePropertyProject';
    }
}
EstatePropertyProjectService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyProjectService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
EstatePropertyProjectService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyProjectService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyProjectService, decorators: [{
            type: Injectable
        }] });

class EstatePropertyCompanyService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'EstatePropertyCompany';
    }
}
EstatePropertyCompanyService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyCompanyService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
EstatePropertyCompanyService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyCompanyService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyCompanyService, decorators: [{
            type: Injectable
        }] });

class EstatePropertySupplierService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'EstatePropertySupplier';
    }
}
EstatePropertySupplierService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertySupplierService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
EstatePropertySupplierService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertySupplierService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertySupplierService, decorators: [{
            type: Injectable
        }] });

class EstateActivityTypeService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'EstateActivityType';
    }
}
EstateActivityTypeService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateActivityTypeService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
EstateActivityTypeService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateActivityTypeService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateActivityTypeService, decorators: [{
            type: Injectable
        }] });

class EstatePriceInquiryDtoModel {
}

class EstatePropertyExpertPriceService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'EstatePropertyExpertPrice';
    }
    ServicePriceInquiryList(model) {
        if (model == null) {
            model = new EstatePriceInquiryDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/PriceInquiryList', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServicePriceInquiryCalculate(model) {
        if (model == null) {
            model = new EstatePriceInquiryDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/PriceInquiryCalculate', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
}
EstatePropertyExpertPriceService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyExpertPriceService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
EstatePropertyExpertPriceService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyExpertPriceService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertyExpertPriceService, decorators: [{
            type: Injectable
        }] });

class EstateCustomerOrderResultService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'EstateCustomerOrderResult';
    }
}
EstateCustomerOrderResultService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateCustomerOrderResultService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
EstateCustomerOrderResultService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateCustomerOrderResultService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateCustomerOrderResultService, decorators: [{
            type: Injectable
        }] });

class EstateCustomerCategoryService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'EstateCustomerCategory';
    }
}
EstateCustomerCategoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateCustomerCategoryService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
EstateCustomerCategoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateCustomerCategoryService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateCustomerCategoryService, decorators: [{
            type: Injectable
        }] });

class EstatePropertySupplierCategoryService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'EstatePropertySupplierCategory';
    }
}
EstatePropertySupplierCategoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertySupplierCategoryService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
EstatePropertySupplierCategoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertySupplierCategoryService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstatePropertySupplierCategoryService, decorators: [{
            type: Injectable
        }] });

class EstateAccountUserWorkAreaService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'EstateAccountUserWorkArea';
    }
}
EstateAccountUserWorkAreaService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateAccountUserWorkAreaService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
EstateAccountUserWorkAreaService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateAccountUserWorkAreaService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateAccountUserWorkAreaService, decorators: [{
            type: Injectable
        }] });

class EstateAccountAgencyWorkAreaService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'EstateAccountAgencyWorkArea';
    }
}
EstateAccountAgencyWorkAreaService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateAccountAgencyWorkAreaService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
EstateAccountAgencyWorkAreaService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateAccountAgencyWorkAreaService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: EstateAccountAgencyWorkAreaService, decorators: [{
            type: Injectable
        }] });

class EstateModuleConfigAdminMainValuesModel extends BaseModuleConfigAdminMainValuesModel {
}
class EstateModuleConfigSiteAccessValuesModel extends BaseModuleConfigSiteAccessValuesModel {
}
/// <summary>
/// با ثبت یک هایپر شاپ باید یک ردیف خام با مقادیر اولیه در بانک ثبت شود
/// این کار باید از سمت سرور انجام شود و کلاینت اجازه ویرایش یا حذف این ردیف را نداشته باشد
/// </summary>
class EstateModuleConfigSiteValuesModel extends BaseModuleConfigSiteValuesModel {
}
class EstateModuleSiteStorageValuesModel extends BaseModuleSiteStorageValuesModel {
}

//@@tag-Version-2212171
class EstateAccountAgencyModel extends BaseModuleEntity {
    constructor() {
        super(...arguments);
        this.mainAdminRecordStatus = RecordStatusEnum.Pending;
    }
}

//@@tag-Version-2201011
class EstateAccountAgencyAdsModel extends BaseModuleEntity {
}

//@@tag-Version-2212191
class EstateAccountAgencyUserModel extends BaseModuleEntity {
}

//@@tag-Version-2212171
class EstateAccountUserModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class EstateContractModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class EstateContractTypeModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class EstatePropertyAccountTypeUserModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class EstatePropertyDetailGroupModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class EstatePropertyDetailModel {
}

//@@tag-Version-2212111
class EstatePropertyDetailValueModel {
}

//@@tag-Version-2201011
class EstatePropertyHistoryModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class EstatePropertyAdsModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class EstateAdsTypeModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class EstatePropertyModel extends BaseModuleEntity {
    constructor() {
        super(...arguments);
        this.mainAdminRecordStatus = RecordStatusEnum.Pending;
        /**Acton */
    }
}

//@@tag-Version-2201011
class EstateBillboardModel extends BaseModuleEntity {
}

//@@tag-Version-2211261
class EstateCustomerOrderModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class EstatePropertyTypeModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class EstatePropertyTypeUsageModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class EstatePropertyTypeLanduseModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class EstatePropertyShareAgencyModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class EstatePropertyShareAgentModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class EstatePropertyShareSiteModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class EstatePropertyProjectModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class EstatePropertyCompanyModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class EstateActivityTypeModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class EstatePropertyExpertPriceModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class EstateCustomerOrderResultModel extends BaseModuleEntity {
}

//@@tag-Version-2212011
class EstateCustomerCategoryModel extends BaseModuleEntity {
}

//@@tag-Version-2212011
class EstatePropertySupplierCategoryModel extends BaseModuleEntity {
}

//@@tag-Version-2304041
class EstatePropertySupplierModel extends BaseModuleEntity {
}

//@@tag-Version-2212191
class EstateAccountUserWorkAreaModel extends BaseModuleEntity {
}

//@@tag-Version-2212191
class EstateAccountAgencyWorkAreaModel extends BaseModuleEntity {
}

var ActivityStatusEnumEstate;
(function (ActivityStatusEnumEstate) {
    ActivityStatusEnumEstate[ActivityStatusEnumEstate["Planned"] = 0] = "Planned";
    ActivityStatusEnumEstate[ActivityStatusEnumEstate["Done"] = 1] = "Done";
    ActivityStatusEnumEstate[ActivityStatusEnumEstate["Canceled"] = 2] = "Canceled";
})(ActivityStatusEnumEstate || (ActivityStatusEnumEstate = {}));

var PropertyExpertPriceTypeEnumEstate;
(function (PropertyExpertPriceTypeEnumEstate) {
    PropertyExpertPriceTypeEnumEstate[PropertyExpertPriceTypeEnumEstate["AutoWeek"] = 11] = "AutoWeek";
    PropertyExpertPriceTypeEnumEstate[PropertyExpertPriceTypeEnumEstate["AutoMonth"] = 12] = "AutoMonth";
    PropertyExpertPriceTypeEnumEstate[PropertyExpertPriceTypeEnumEstate["AutoYear"] = 13] = "AutoYear";
    PropertyExpertPriceTypeEnumEstate[PropertyExpertPriceTypeEnumEstate["ExpertWeek"] = 21] = "ExpertWeek";
    PropertyExpertPriceTypeEnumEstate[PropertyExpertPriceTypeEnumEstate["ExpertMonth"] = 22] = "ExpertMonth";
    PropertyExpertPriceTypeEnumEstate[PropertyExpertPriceTypeEnumEstate["ExpertYear"] = 23] = "ExpertYear";
})(PropertyExpertPriceTypeEnumEstate || (PropertyExpertPriceTypeEnumEstate = {}));

var EstateUserTypeEnum;
(function (EstateUserTypeEnum) {
    EstateUserTypeEnum[EstateUserTypeEnum["Customer"] = 1] = "Customer";
    EstateUserTypeEnum[EstateUserTypeEnum["Agent"] = 2] = "Agent";
    EstateUserTypeEnum[EstateUserTypeEnum["Agency"] = 3] = "Agency";
})(EstateUserTypeEnum || (EstateUserTypeEnum = {}));

class EstatePropertyHistoryFilterModel extends FilterModel {
}

class EstatePropertyActionSendSmsDtoModel {
}

class EstateCustomerOrderActionSendSmsDtoModel {
}

class EstateAccountAgencyFilterModel extends FilterModel {
}

class EstateAccountUserFilterModel extends FilterModel {
}

class WebDesignerEnumService extends ApiServerBase {
    getModuleControllerUrl() {
        return 'WebDesignerEnum';
    }
    ServicePageAbilityTypeEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/PageAbilityTypeEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceCmsSiteMenuAreaTypeEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/CmsSiteMenuAreaTypeEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceCmsPageUtilityToolsDtoModelActionEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/CmsPageUtilityToolsDtoModelActionEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
WebDesignerEnumService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: WebDesignerEnumService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
WebDesignerEnumService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: WebDesignerEnumService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: WebDesignerEnumService, decorators: [{
            type: Injectable
        }] });

class WebDesignerConfigurationService extends ApiServerConfigSiteBase {
    getModuleControllerUrl() {
        return 'webDesigner';
    }
}
WebDesignerConfigurationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: WebDesignerConfigurationService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
WebDesignerConfigurationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: WebDesignerConfigurationService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: WebDesignerConfigurationService, decorators: [{
            type: Injectable
        }] });

class WebDesignerLogPageSafeService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'WebDesignerLogPageSafe';
    }
}
WebDesignerLogPageSafeService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: WebDesignerLogPageSafeService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
WebDesignerLogPageSafeService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: WebDesignerLogPageSafeService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: WebDesignerLogPageSafeService, decorators: [{
            type: Injectable
        }] });

class WebDesignerLogMemberInfoService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'WebDesignerLogMemberInfo';
    }
}
WebDesignerLogMemberInfoService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: WebDesignerLogMemberInfoService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
WebDesignerLogMemberInfoService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: WebDesignerLogMemberInfoService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: WebDesignerLogMemberInfoService, decorators: [{
            type: Injectable
        }] });

class WebDesignerMainIntroService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'WebDesignerMainIntro';
    }
}
WebDesignerMainIntroService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: WebDesignerMainIntroService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
WebDesignerMainIntroService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: WebDesignerMainIntroService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: WebDesignerMainIntroService, decorators: [{
            type: Injectable
        }] });

class WebDesignerMainMenuService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'WebDesignerMainMenu';
    }
    ServiceGetAllTree(model) {
        if (model == null) {
            model = new FilterModel();
        }
        model.rowPerPage = 200;
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllTree', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceEditStep(model) {
        if (!model) {
            model = new EditStepDtoModel();
        }
        return this.http
            .put(this.getBaseUrl() + this.getModuleControllerUrl() + '/EditStep', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
}
WebDesignerMainMenuService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: WebDesignerMainMenuService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
WebDesignerMainMenuService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: WebDesignerMainMenuService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: WebDesignerMainMenuService, decorators: [{
            type: Injectable
        }] });

class CmsPageUtilityToolsDtoModel {
}

class GetAllDefaultPagesBySiteCategoryDtoModel {
}

class WebDesignerMainPageService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'WebDesignerMainPage';
    }
    ServiceAutoAdd(model) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/AutoAdd/', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceWebScreenshot(id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/WebScreenshot/' + id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceWebRoute(id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/WebRoute/' + id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllDefaultPagesBySiteCategory(model) {
        if (model == null) {
            model = new GetAllDefaultPagesBySiteCategoryDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllDefaultPagesBySiteCategory', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceSetDefaultAdminValuePage(id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/SetDefaultAdminValuePage/' + id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceUtilityTools(model) {
        if (model == null) {
            model = new CmsPageUtilityToolsDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/UtilityTools', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
WebDesignerMainPageService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: WebDesignerMainPageService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
WebDesignerMainPageService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: WebDesignerMainPageService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: WebDesignerMainPageService, decorators: [{
            type: Injectable
        }] });

class WebDesignerMainPageDependencyService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'WebDesignerMainPageDependency';
    }
    ServiceAutoAdd() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/AutoAdd/', {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceWebRoute(id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/WebRoute/' + id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
WebDesignerMainPageDependencyService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: WebDesignerMainPageDependencyService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
WebDesignerMainPageDependencyService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: WebDesignerMainPageDependencyService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: WebDesignerMainPageDependencyService, decorators: [{
            type: Injectable
        }] });

class WebDesignerMainPageTemplateService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'WebDesignerMainPageTemplate';
    }
}
WebDesignerMainPageTemplateService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: WebDesignerMainPageTemplateService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
WebDesignerMainPageTemplateService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: WebDesignerMainPageTemplateService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: WebDesignerMainPageTemplateService, decorators: [{
            type: Injectable
        }] });

class WebDesignerMainPageTemplateSiteCategoryService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'WebDesignerMainPageTemplateSiteCategory';
    }
}
WebDesignerMainPageTemplateSiteCategoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: WebDesignerMainPageTemplateSiteCategoryService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
WebDesignerMainPageTemplateSiteCategoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: WebDesignerMainPageTemplateSiteCategoryService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: WebDesignerMainPageTemplateSiteCategoryService, decorators: [{
            type: Injectable
        }] });

class WebDesignerModuleConfigAdminMainValuesModel extends BaseModuleConfigAdminMainValuesModel {
}
class WebDesignerModuleConfigSiteAccessValuesModel extends BaseModuleConfigSiteAccessValuesModel {
}
/// <summary>
/// با ثبت یک هایپر شاپ باید یک ردیف خام با مقادیر اولیه در بانک ثبت شود
/// این کار باید از سمت سرور انجام شود و کلاینت اجازه ویرایش یا حذف این ردیف را نداشته باشد
/// </summary>
class WebDesignerModuleConfigSiteValuesModel extends BaseModuleConfigSiteValuesModel {
}
class WebDesignerModuleSiteStorageValuesModel extends BaseModuleSiteStorageValuesModel {
}

//@@tag-Version-2201011
class WebDesignerLogPageSafeModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class WebDesignerLogMemberInfoModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class WebDesignerMainIntroModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class WebDesignerMainMenuModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class WebDesignerMainPageModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class WebDesignerMainPageDependencyModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class WebDesignerMainPageTemplateModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class WebDesignerMainPageTemplateSiteCategoryModel extends BaseModuleEntity {
}

class WebDesignerPageAutoAddDtoModel {
}

class ArticleConfigurationService extends ApiServerConfigSiteBase {
    getModuleControllerUrl() {
        return 'Article';
    }
}
ArticleConfigurationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ArticleConfigurationService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ArticleConfigurationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ArticleConfigurationService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ArticleConfigurationService, decorators: [{
            type: Injectable
        }] });

class ArticleCategoryService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'ArticleCategory';
    }
    ServiceMove(OldId, NewId) {
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/Move', { Old: OldId, New: NewId }, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
ArticleCategoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ArticleCategoryService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ArticleCategoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ArticleCategoryService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ArticleCategoryService, decorators: [{
            type: Injectable
        }] });

class ArticleCommentService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'ArticleComment';
    }
    ServiceLikeClick(Id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/LikeClick/' + Id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceDisLikeClick(Id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/DisLikeClick/' + Id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
}
ArticleCommentService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ArticleCommentService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ArticleCommentService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ArticleCommentService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ArticleCommentService, decorators: [{
            type: Injectable
        }] });

class ArticleContentService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'ArticleContent';
    }
    ServiceGetAllWithHierarchyCategoryId(Id, model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithHierarchyCategoryId/' + Id, model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllWithSimilarsId(Id, model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithSimilarsId/' + Id, model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllWithTagId(Id, model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithTagId/' + Id, model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceGetAllWithCategoryUseInContentId(Id, model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllWithCategoryUseInContentId/' + Id, model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceScoreClick(model) {
        if (model == null) {
            model = new ScoreClickDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/ScoreClick', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceFavoriteAdd(Id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/FavoriteAdd/' + Id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceFavoriteRemove(Id) {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/FavoriteRemove/' + Id, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultBaseCheck(ret);
        }));
    }
    ServiceFavoriteList(model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/FavoriteList', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceReportAbuseAdd(model) {
        if (model == null) {
            model = new CoreModuleReportAbuseDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/ReportAbuseAdd', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceReportAbuseList(model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/ReportAbuseList', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
ArticleContentService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ArticleContentService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ArticleContentService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ArticleContentService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ArticleContentService, decorators: [{
            type: Injectable
        }] });

class ArticleContentAndParameterValueService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'ArticleContentAndParameterValue';
    }
}
ArticleContentAndParameterValueService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ArticleContentAndParameterValueService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ArticleContentAndParameterValueService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ArticleContentAndParameterValueService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ArticleContentAndParameterValueService, decorators: [{
            type: Injectable
        }] });

class ArticleContentOtherInfoService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'ArticleContentOtherInfo';
    }
    ServiceAddBatch(model) {
        if (model == null) {
            model = [];
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/AddBatch', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceEditBatch(model) {
        if (model == null) {
            model = [];
        }
        return this.http
            .put(this.getBaseUrl() + this.getModuleControllerUrl() + '/EditBatch', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
ArticleContentOtherInfoService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ArticleContentOtherInfoService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ArticleContentOtherInfoService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ArticleContentOtherInfoService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ArticleContentOtherInfoService, decorators: [{
            type: Injectable
        }] });

class ArticleContentParameterService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'ArticleContentParameter';
    }
}
ArticleContentParameterService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ArticleContentParameterService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ArticleContentParameterService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ArticleContentParameterService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ArticleContentParameterService, decorators: [{
            type: Injectable
        }] });

class ArticleContentParameterTypeService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'ArticleContentParameterType';
    }
}
ArticleContentParameterTypeService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ArticleContentParameterTypeService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ArticleContentParameterTypeService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ArticleContentParameterTypeService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ArticleContentParameterTypeService, decorators: [{
            type: Injectable
        }] });

class ArticleContentSimilarService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'ArticleContentSimilar';
    }
    ServiceAddBatch(model) {
        if (model == null) {
            model = [];
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/AddBatch', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceDeleteBatch(model) {
        if (model == null) {
            model = [];
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/DeleteBatch', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
ArticleContentSimilarService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ArticleContentSimilarService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ArticleContentSimilarService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ArticleContentSimilarService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ArticleContentSimilarService, decorators: [{
            type: Injectable
        }] });

class ArticleContentTagService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'ArticleContentTag';
    }
    ServiceAddBatch(model) {
        if (model == null) {
            model = [];
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/AddBatch', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceDeleteBatch(model) {
        if (model == null) {
            model = [];
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/DeleteBatch', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
ArticleContentTagService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ArticleContentTagService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ArticleContentTagService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ArticleContentTagService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ArticleContentTagService, decorators: [{
            type: Injectable
        }] });

class ArticleShareMainAdminSettingService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'ArticleShareMainAdminSetting';
    }
}
ArticleShareMainAdminSettingService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ArticleShareMainAdminSettingService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ArticleShareMainAdminSettingService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ArticleShareMainAdminSettingService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ArticleShareMainAdminSettingService, decorators: [{
            type: Injectable
        }] });

class ArticleShareReceiverCategoryService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'ArticleShareReceiverCategory';
    }
}
ArticleShareReceiverCategoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ArticleShareReceiverCategoryService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ArticleShareReceiverCategoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ArticleShareReceiverCategoryService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ArticleShareReceiverCategoryService, decorators: [{
            type: Injectable
        }] });

class ArticleShareServerCategoryService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'ArticleShareServerCategory';
    }
    ServiceGetAllOtherSite(model) {
        if (model == null) {
            model = new FilterModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/GetAllOtherSite/', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
ArticleShareServerCategoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ArticleShareServerCategoryService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ArticleShareServerCategoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ArticleShareServerCategoryService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ArticleShareServerCategoryService, decorators: [{
            type: Injectable
        }] });

class ArticleContentCategoryService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'ArticleContentCategory';
    }
}
ArticleContentCategoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ArticleContentCategoryService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
ArticleContentCategoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ArticleContentCategoryService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: ArticleContentCategoryService, decorators: [{
            type: Injectable
        }] });

class ArticleModuleConfigAdminMainValuesModel extends BaseModuleConfigAdminMainValuesModel {
}
class ArticleModuleConfigSiteAccessValuesModel extends BaseModuleConfigSiteAccessValuesModel {
}
/// <summary>
/// با ثبت یک هایپر شاپ باید یک ردیف خام با مقادیر اولیه در بانک ثبت شود
/// این کار باید از سمت سرور انجام شود و کلاینت اجازه ویرایش یا حذف این ردیف را نداشته باشد
/// </summary>
class ArticleModuleConfigSiteValuesModel extends BaseModuleConfigSiteValuesModel {
}
class ArticleModuleSiteStorageValuesModel extends BaseModuleSiteStorageValuesModel {
}

//@@tag-Version-2201011
class ArticleCategoryModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class ArticleCommentModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class ArticleContentModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class ArticleContentOtherInfoModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class ArticleContentSimilarModel {
}

//@@tag-Version-2201011
class ArticleContentTagModel {
}

//@@tag-Version-2201011
class ArticleContentCategoryModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class ArticleShareMainAdminSettingModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class ArticleShareReceiverCategoryModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class ArticleShareServerCategoryModel extends BaseModuleEntity {
}

class MemberConfigurationService extends ApiServerConfigSiteBase {
    getModuleControllerUrl() {
        return 'member';
    }
}
MemberConfigurationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberConfigurationService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
MemberConfigurationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberConfigurationService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberConfigurationService, decorators: [{
            type: Injectable
        }] });

class MemberUserService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'MemberUser';
    }
}
MemberUserService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberUserService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
MemberUserService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberUserService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberUserService, decorators: [{
            type: Injectable
        }] });

class MemberGroupService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'MemberGroup';
    }
}
MemberGroupService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberGroupService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
MemberGroupService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberGroupService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberGroupService, decorators: [{
            type: Injectable
        }] });

class MemberHistoryService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'MemberHistory';
    }
}
MemberHistoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberHistoryService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
MemberHistoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberHistoryService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberHistoryService, decorators: [{
            type: Injectable
        }] });

class MemberPropertyService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'MemberProperty';
    }
}
MemberPropertyService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberPropertyService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
MemberPropertyService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberPropertyService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberPropertyService, decorators: [{
            type: Injectable
        }] });

class MemberPropertyAliasService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'MemberPropertyAlias';
    }
}
MemberPropertyAliasService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberPropertyAliasService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
MemberPropertyAliasService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberPropertyAliasService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberPropertyAliasService, decorators: [{
            type: Injectable
        }] });

class MemberPropertyDetailService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'MemberPropertyDetail';
    }
}
MemberPropertyDetailService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberPropertyDetailService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
MemberPropertyDetailService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberPropertyDetailService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberPropertyDetailService, decorators: [{
            type: Injectable
        }] });

class MemberPropertyDetailGroupService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'MemberPropertyDetailGroup';
    }
}
MemberPropertyDetailGroupService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberPropertyDetailGroupService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
MemberPropertyDetailGroupService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberPropertyDetailGroupService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberPropertyDetailGroupService, decorators: [{
            type: Injectable
        }] });

class MemberPropertyDetailValueService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'MemberPropertyDetailValue';
    }
}
MemberPropertyDetailValueService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberPropertyDetailValueService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
MemberPropertyDetailValueService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberPropertyDetailValueService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberPropertyDetailValueService, decorators: [{
            type: Injectable
        }] });

class MemberPropertySiteService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'MemberPropertySite';
    }
}
MemberPropertySiteService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberPropertySiteService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
MemberPropertySiteService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberPropertySiteService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberPropertySiteService, decorators: [{
            type: Injectable
        }] });

class MemberPropertyTypeService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'MemberPropertyType';
    }
}
MemberPropertyTypeService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberPropertyTypeService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
MemberPropertyTypeService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberPropertyTypeService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberPropertyTypeService, decorators: [{
            type: Injectable
        }] });

class MemberPropertyTypeSiteService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'MemberPropertyTypeSite';
    }
}
MemberPropertyTypeSiteService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberPropertyTypeSiteService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
MemberPropertyTypeSiteService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberPropertyTypeSiteService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberPropertyTypeSiteService, decorators: [{
            type: Injectable
        }] });

class MemberUserGroupService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'MemberUserGroup';
    }
}
MemberUserGroupService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberUserGroupService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
MemberUserGroupService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberUserGroupService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberUserGroupService, decorators: [{
            type: Injectable
        }] });

class MemberUserSearchAliasService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'MemberUserSearchAlias';
    }
}
MemberUserSearchAliasService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberUserSearchAliasService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
MemberUserSearchAliasService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberUserSearchAliasService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberUserSearchAliasService, decorators: [{
            type: Injectable
        }] });

class MemberUserSiteService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'MemberUserSite';
    }
}
MemberUserSiteService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberUserSiteService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
MemberUserSiteService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberUserSiteService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MemberUserSiteService, decorators: [{
            type: Injectable
        }] });

class MemberModuleConfigAdminMainValuesModel extends BaseModuleConfigAdminMainValuesModel {
}
class MemberModuleConfigSiteAccessValuesModel extends BaseModuleConfigSiteAccessValuesModel {
}
/// <summary>
/// با ثبت یک هایپر شاپ باید یک ردیف خام با مقادیر اولیه در بانک ثبت شود
/// این کار باید از سمت سرور انجام شود و کلاینت اجازه ویرایش یا حذف این ردیف را نداشته باشد
/// </summary>
class MemberModuleConfigSiteValuesModel extends BaseModuleConfigSiteValuesModel {
}
class MemberModuleSiteStorageValuesModel extends BaseModuleSiteStorageValuesModel {
}

//@@tag-Version-2201011
class MemberUserModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class MemberGroupModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class MemberPropertySiteModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class MemberHistoryModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class MemberPropertyAliasModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class MemberPropertyDetailGroupModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class MemberPropertyDetailValueModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class MemberPropertyDetailModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class MemberPropertyTypeSiteModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class MemberPropertyTypeModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class MemberPropertyModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class MemberUserGroupModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class MemberUserSearchAliasModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class MemberUserSiteModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class MemberPropertyDetailDefaultValueModel extends BaseModuleEntity {
}

var UiPropertyDesignEnum;
(function (UiPropertyDesignEnum) {
    UiPropertyDesignEnum[UiPropertyDesignEnum["Normal"] = 0] = "Normal";
    UiPropertyDesignEnum[UiPropertyDesignEnum["Input"] = 1] = "Input";
})(UiPropertyDesignEnum || (UiPropertyDesignEnum = {}));

class DonateModuleConfigAdminMainValuesModel extends BaseModuleConfigAdminMainValuesModel {
}
class DonateModuleConfigSiteAccessValuesModel extends BaseModuleConfigSiteAccessValuesModel {
}
/// <summary>
/// با ثبت یک هایپر شاپ باید یک ردیف خام با مقادیر اولیه در بانک ثبت شود
/// این کار باید از سمت سرور انجام شود و کلاینت اجازه ویرایش یا حذف این ردیف را نداشته باشد
/// </summary>
class DonateModuleConfigSiteValuesModel extends BaseModuleConfigSiteValuesModel {
}
class DonateModuleSiteStorageValuesModel extends BaseModuleSiteStorageValuesModel {
}

//@@tag-Version-2201011
class DonateSponsorModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class DonateTargetModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class DonateTargetCategoryModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class DonateTargetPeriodModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class DonateTargetPeriodSponsorModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class DonateTransactionModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class DonateLogViewModel extends BaseModuleEntity {
}

class DonateModuleCalculateDtoModel {
}

class DonateModulePaymentDtoModel {
}

var TransactionLogPublicTypeEnum;
(function (TransactionLogPublicTypeEnum) {
    TransactionLogPublicTypeEnum[TransactionLogPublicTypeEnum["none"] = 0] = "none";
    TransactionLogPublicTypeEnum[TransactionLogPublicTypeEnum["All"] = 1] = "All";
    TransactionLogPublicTypeEnum[TransactionLogPublicTypeEnum["ByPayment"] = 2] = "ByPayment";
    TransactionLogPublicTypeEnum[TransactionLogPublicTypeEnum["BySponsor"] = 3] = "BySponsor";
})(TransactionLogPublicTypeEnum || (TransactionLogPublicTypeEnum = {}));

class DonateConfigurationService extends ApiServerConfigSiteBase {
    getModuleControllerUrl() {
        return 'Donate';
    }
}
DonateConfigurationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DonateConfigurationService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
DonateConfigurationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DonateConfigurationService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DonateConfigurationService, decorators: [{
            type: Injectable
        }] });

class DonateEnumService extends ApiServerBase {
    getModuleControllerUrl() {
        return 'DonateEnum';
    }
    ServiceTransactionLogPublicTypeEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/TransactionLogPublicTypeEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
DonateEnumService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DonateEnumService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
DonateEnumService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DonateEnumService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DonateEnumService, decorators: [{
            type: Injectable
        }] });

class DonateLogViewService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'DonateLogView';
    }
}
DonateLogViewService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DonateLogViewService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
DonateLogViewService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DonateLogViewService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DonateLogViewService, decorators: [{
            type: Injectable
        }] });

class DonateSponsorService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'DonateSponsor';
    }
}
DonateSponsorService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DonateSponsorService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
DonateSponsorService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DonateSponsorService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DonateSponsorService, decorators: [{
            type: Injectable
        }] });

class DonateTargetService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'DonateTarget';
    }
}
DonateTargetService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DonateTargetService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
DonateTargetService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DonateTargetService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DonateTargetService, decorators: [{
            type: Injectable
        }] });

class DonateTargetCategoryService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'DonateTargetCategory';
    }
}
DonateTargetCategoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DonateTargetCategoryService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
DonateTargetCategoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DonateTargetCategoryService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DonateTargetCategoryService, decorators: [{
            type: Injectable
        }] });

class DonateTargetPeriodService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'DonateTargetPeriod';
    }
}
DonateTargetPeriodService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DonateTargetPeriodService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
DonateTargetPeriodService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DonateTargetPeriodService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DonateTargetPeriodService, decorators: [{
            type: Injectable
        }] });

class DonateTargetPeriodSponsorService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'DonateTargetPeriodSponsor';
    }
}
DonateTargetPeriodSponsorService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DonateTargetPeriodSponsorService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
DonateTargetPeriodSponsorService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DonateTargetPeriodSponsorService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DonateTargetPeriodSponsorService, decorators: [{
            type: Injectable
        }] });

class DonateTransactionService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'DonateTransaction';
    }
    ServiceOrderCalculate(model) {
        if (!model) {
            model = new DonateModuleCalculateDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/OrderCalculate', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceOrderPayment(model) {
        if (!model) {
            model = new DonateModulePaymentDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/OrderPayment', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
DonateTransactionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DonateTransactionService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
DonateTransactionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DonateTransactionService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DonateTransactionService, decorators: [{
            type: Injectable
        }] });

class DataProviderModuleConfigAdminMainValuesModel extends BaseModuleConfigAdminMainValuesModel {
}
class DataProviderModuleConfigSiteAccessValuesModel extends BaseModuleConfigSiteAccessValuesModel {
}
class DataProviderModuleConfigSiteValuesModel extends BaseModuleConfigSiteValuesModel {
}
class DataProviderModuleSiteStorageValuesModel extends BaseModuleSiteStorageValuesModel {
}

//@@tag-Version-2201011
class DataProviderClientModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class DataProviderPlanClientModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class DataProviderPlanModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class DataProviderPlanPriceModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class DataProviderPlanSourceModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class DataProviderSourceModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class DataProviderPlanCategoryModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class DataProviderTransactionModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class DataProviderLogDataModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class DataProviderLogClientModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class DataProviderLogPlanModel extends BaseModuleEntity {
}

//@@tag-Version-2201011
class DataProviderLogSourceModel extends BaseModuleEntity {
}

class DataProviderModuleCalculateDtoModel {
}

class DataProviderModulePaymentDtoModel {
}

var DataProviderClientConnectionTypeEnum;
(function (DataProviderClientConnectionTypeEnum) {
    DataProviderClientConnectionTypeEnum[DataProviderClientConnectionTypeEnum["Offline"] = 0] = "Offline";
    DataProviderClientConnectionTypeEnum[DataProviderClientConnectionTypeEnum["Api"] = 1] = "Api";
    DataProviderClientConnectionTypeEnum[DataProviderClientConnectionTypeEnum["Rabbitmq"] = 2] = "Rabbitmq";
    DataProviderClientConnectionTypeEnum[DataProviderClientConnectionTypeEnum["Signalr"] = 3] = "Signalr";
})(DataProviderClientConnectionTypeEnum || (DataProviderClientConnectionTypeEnum = {}));

class DataProviderConfigurationService extends ApiServerConfigSiteBase {
    getModuleControllerUrl() {
        return 'DataProvider';
    }
}
DataProviderConfigurationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DataProviderConfigurationService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
DataProviderConfigurationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DataProviderConfigurationService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DataProviderConfigurationService, decorators: [{
            type: Injectable
        }] });

class DataProviderEnumService extends ApiServerBase {
    getModuleControllerUrl() {
        return 'DataProviderEnum';
    }
    ServiceDataProviderClientConnectionTypeEnum() {
        return this.http
            .get(this.getBaseUrl() + this.getModuleControllerUrl() + '/DataProviderClientConnectionTypeEnum', {
            headers: this.getHeaders(),
        })
            .pipe(
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
DataProviderEnumService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DataProviderEnumService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
DataProviderEnumService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DataProviderEnumService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DataProviderEnumService, decorators: [{
            type: Injectable
        }] });

class DataProviderLogClientService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'DataProviderLogClient';
    }
}
DataProviderLogClientService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DataProviderLogClientService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
DataProviderLogClientService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DataProviderLogClientService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DataProviderLogClientService, decorators: [{
            type: Injectable
        }] });

class DataProviderLogDataService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'DataProviderLogData';
    }
}
DataProviderLogDataService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DataProviderLogDataService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
DataProviderLogDataService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DataProviderLogDataService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DataProviderLogDataService, decorators: [{
            type: Injectable
        }] });

class DataProviderLogPlanService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'DataProviderLogPlan';
    }
}
DataProviderLogPlanService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DataProviderLogPlanService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
DataProviderLogPlanService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DataProviderLogPlanService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DataProviderLogPlanService, decorators: [{
            type: Injectable
        }] });

class DataProviderLogSourceService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'DataProviderLogSource';
    }
}
DataProviderLogSourceService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DataProviderLogSourceService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
DataProviderLogSourceService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DataProviderLogSourceService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DataProviderLogSourceService, decorators: [{
            type: Injectable
        }] });

class DataProviderClientService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'DataProviderClient';
    }
}
DataProviderClientService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DataProviderClientService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
DataProviderClientService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DataProviderClientService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DataProviderClientService, decorators: [{
            type: Injectable
        }] });

class DataProviderPlanCategoryService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'DataProviderPlanCategory';
    }
}
DataProviderPlanCategoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DataProviderPlanCategoryService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
DataProviderPlanCategoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DataProviderPlanCategoryService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DataProviderPlanCategoryService, decorators: [{
            type: Injectable
        }] });

class DataProviderPlanClientService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'DataProviderPlanClient';
    }
}
DataProviderPlanClientService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DataProviderPlanClientService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
DataProviderPlanClientService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DataProviderPlanClientService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DataProviderPlanClientService, decorators: [{
            type: Injectable
        }] });

class DataProviderPlanService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'DataProviderPlan';
    }
}
DataProviderPlanService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DataProviderPlanService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
DataProviderPlanService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DataProviderPlanService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DataProviderPlanService, decorators: [{
            type: Injectable
        }] });

class DataProviderPlanPriceService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'DataProviderPlanPrice';
    }
}
DataProviderPlanPriceService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DataProviderPlanPriceService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
DataProviderPlanPriceService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DataProviderPlanPriceService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DataProviderPlanPriceService, decorators: [{
            type: Injectable
        }] });

class DataProviderPlanSourceService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'DataProviderPlanSource';
    }
}
DataProviderPlanSourceService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DataProviderPlanSourceService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
DataProviderPlanSourceService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DataProviderPlanSourceService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DataProviderPlanSourceService, decorators: [{
            type: Injectable
        }] });

class DataProviderSourceService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'DataProviderSource';
    }
}
DataProviderSourceService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DataProviderSourceService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
DataProviderSourceService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DataProviderSourceService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DataProviderSourceService, decorators: [{
            type: Injectable
        }] });

class DataProviderTransactionService extends ApiCmsServerBase {
    getModuleControllerUrl() {
        return 'DataProviderTransaction';
    }
    ServiceOrderCalculate(model) {
        if (!model) {
            model = new DataProviderModuleCalculateDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/OrderCalculate', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
    ServiceOrderPayment(model) {
        if (!model) {
            model = new DataProviderModulePaymentDtoModel();
        }
        return this.http
            .post(this.getBaseUrl() + this.getModuleControllerUrl() + '/OrderPayment', model, {
            headers: this.getHeaders(),
        })
            .pipe(retry(this.configApiRetry), 
        // catchError(this.handleError)
        map((ret) => {
            return this.errorExceptionResultCheck(ret);
        }));
    }
}
DataProviderTransactionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DataProviderTransactionService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
DataProviderTransactionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DataProviderTransactionService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: DataProviderTransactionService, decorators: [{
            type: Injectable
        }] });

/*
 * Public API Surface of ntk-cms-api
 */
// data-provider

/**
 * Generated bundle index. Do not edit.
 */

export { AccessHelper, AccessModel, ActionGoStepEnum, ActivityStatusEnumEstate, AnswerStatusEnum, ApiReceiveMethodEnum, ApiServerBase, ApiTelegramBotConfigModel, ApiTelegramBotConfigService, ApiTelegramConfigurationService, ApiTelegramEnumService, ApiTelegramLogInputModel, ApiTelegramLogInputService, ApiTelegramLogOutputModel, ApiTelegramLogOutputService, ApiTelegramMemberInfoModel, ApiTelegramMemberInfoService, ApiTelegramModuleConfigAdminMainValuesModel, ApiTelegramModuleConfigSiteAccessValuesModel, ApiTelegramModuleConfigSiteValuesModel, ApiTelegramModuleSiteStorageValuesModel, ApiTelegramReceivedFileModel, ApiTelegramReceivedFileService, ApiTelegramRenderInfoModel, ApiTelegramSendMessageTodoModel, ApiTelegramSessionModel, ApiTelegramUploadedFileModel, ApiTelegramUploadedFileService, AppMainDtoModel, AppMainHederDtoModel, AppMainLayoutMainRequestModel, ApplicationAppModel, ApplicationAppService, ApplicationConfigurationService, ApplicationEnumService, ApplicationIntroModel, ApplicationIntroService, ApplicationLayoutModel, ApplicationLayoutService, ApplicationLayoutValueModel, ApplicationLayoutValueService, ApplicationLogNotificationModel, ApplicationLogNotificationService, ApplicationMemberInfoModel, ApplicationMemberInfoService, ApplicationModuleConfigAdminMainValuesModel, ApplicationModuleConfigSiteAccessValuesModel, ApplicationModuleConfigSiteValuesModel, ApplicationModuleSiteStorageValuesModel, ApplicationSourceModel, ApplicationSourceService, ApplicationSourceSiteCategoryModel, ApplicationSourceSiteCategoryService, ApplicationThemeConfigModel, ApplicationThemeConfigService, ArticleCategoryModel, ArticleCategoryService, ArticleCommentModel, ArticleCommentService, ArticleConfigurationService, ArticleContentAndParameterValueService, ArticleContentCategoryModel, ArticleContentCategoryService, ArticleContentModel, ArticleContentOtherInfoModel, ArticleContentOtherInfoService, ArticleContentParameterService, ArticleContentParameterTypeService, ArticleContentService, ArticleContentSimilarModel, ArticleContentSimilarService, ArticleContentTagModel, ArticleContentTagService, ArticleModuleConfigAdminMainValuesModel, ArticleModuleConfigSiteAccessValuesModel, ArticleModuleConfigSiteValuesModel, ArticleModuleSiteStorageValuesModel, ArticleShareMainAdminSettingModel, ArticleShareMainAdminSettingService, ArticleShareReceiverCategoryModel, ArticleShareReceiverCategoryService, ArticleShareServerCategoryModel, ArticleShareServerCategoryService, AuthEmailConfirmDtoModel, AuthMobileConfirmDtoModel, AuthRenewTokenModel, AuthUserChangePasswordModel, AuthUserForgetPasswordEntryPinCodeModel, AuthUserForgetPasswordModel, AuthUserSignInBySmsDtoModel, AuthUserSignInModel, AuthUserSignOutModel, AuthUserSignUpModel, BankPaymentConfigurationService, BankPaymentEnumService, BankPaymentInjectOnlineTransactionDtoModel, BankPaymentInjectPaymentGotoBankStep1CalculateModel, BankPaymentInjectPaymentGotoBankStep2LandingSitePageModel, BankPaymentModuleConfigAdminMainValuesModel, BankPaymentModuleConfigSiteAccessValuesModel, BankPaymentModuleConfigSiteValuesModel, BankPaymentModuleSiteStorageValuesModel, BankPaymentPrivateSiteConfigAliasJsonModel, BankPaymentPrivateSiteConfigModel, BankPaymentPrivateSiteConfigService, BankPaymentPublicConfigAliasJsonModel, BankPaymentPublicConfigModel, BankPaymentPublicConfigService, BankPaymentTransactionLogModel, BankPaymentTransactionLogService, BankPaymentTransactionModel, BankPaymentTransactionService, BaseEntity, BaseModuleConfigAdminMainValuesModel, BaseModuleConfigSiteAccessValuesModel, BaseModuleConfigSiteValuesModel, BaseModuleEntity, BaseModuleSiteCheckSiteModel, BaseModuleSiteCheckUserModel, BaseModuleSiteStorageValuesModel, BiographyCategoryModel, BiographyCategoryService, BiographyCommentModel, BiographyCommentService, BiographyConfigurationService, BiographyContentAndParameterValueService, BiographyContentCategoryModel, BiographyContentCategoryService, BiographyContentModel, BiographyContentOtherInfoModel, BiographyContentOtherInfoService, BiographyContentParameterService, BiographyContentParameterTypeService, BiographyContentService, BiographyContentSimilarModel, BiographyContentSimilarService, BiographyContentTagModel, BiographyContentTagService, BiographyContentWithDatePeriodEndDtoModel, BiographyContentWithSimilarDatePeriodEndDtoModel, BiographyContentWithSimilarDatePeriodStartDayAndMonthOfYearDtoModel, BiographyContentWithSimilarDatePeriodStartDayOfYearDtoModel, BiographyContentWithSimilarDatePeriodStartDtoModel, BiographyContentWithSimilarDatePeriodStartMonthOfYearListDtoModel, BiographyContentWithSimilarLocationPeriodDtoModel, BiographyModuleConfigAdminMainValuesModel, BiographyModuleConfigSiteAccessValuesModel, BiographyModuleConfigSiteValuesModel, BiographyModuleSiteStorageValuesModel, BiographyShareMainAdminSettingModel, BiographyShareMainAdminSettingService, BiographyShareReceiverCategoryModel, BiographyShareReceiverCategoryService, BiographyShareServerCategoryModel, BiographyShareServerCategoryService, BlogCategoryModel, BlogCategoryService, BlogCommentModel, BlogCommentService, BlogConfigurationService, BlogContentAndParameterValueService, BlogContentCategoryModel, BlogContentCategoryService, BlogContentModel, BlogContentOtherInfoModel, BlogContentOtherInfoService, BlogContentParameterService, BlogContentParameterTypeService, BlogContentService, BlogContentSimilarModel, BlogContentSimilarService, BlogContentTagModel, BlogContentTagService, BlogModuleConfigAdminMainValuesModel, BlogModuleConfigSiteAccessValuesModel, BlogModuleConfigSiteValuesModel, BlogModuleSiteStorageValuesModel, BlogShareMainAdminSettingModel, BlogShareMainAdminSettingService, BlogShareReceiverCategoryModel, BlogShareReceiverCategoryService, BlogShareServerCategoryModel, BlogShareServerCategoryService, BuildStatusTypeEnum, BuilderInfoStatusDtoModel, BulkMessageTypeEnum, CaptchaModel, CatalogCategoryModel, CatalogCategoryService, CatalogConfigurationService, CatalogContentModel, CatalogContentOtherInfoModel, CatalogContentPageModel, CatalogContentService, CatalogModuleConfigAdminMainValuesModel, CatalogModuleConfigSiteAccessValuesModel, CatalogModuleConfigSiteValuesModel, CatalogModuleSiteStorageValuesModel, ChartCategoryModel, ChartCategoryService, ChartCommentModel, ChartCommentService, ChartConfigurationService, ChartContentAndParameterValueService, ChartContentCategoryModel, ChartContentCategoryService, ChartContentModel, ChartContentOtherInfoModel, ChartContentOtherInfoService, ChartContentParameterService, ChartContentParameterTypeService, ChartContentService, ChartContentSimilarModel, ChartContentSimilarService, ChartContentTagModel, ChartContentTagService, ChartModuleConfigAdminMainValuesModel, ChartModuleConfigSiteAccessValuesModel, ChartModuleConfigSiteValuesModel, ChartModuleSiteStorageValuesModel, ChartShareMainAdminSettingService, ChartShareReceiverCategoryService, ChartShareServerCategoryService, CheckStatusActionModel, ClauseTypeEnum, CmsModuleSaleItemTypeEnum, CmsNotificationModel, CmsNotificationSendDtoModel, CmsPageUtilityToolsActionEnum, CmsPageUtilityToolsDtoModel, CmsSiteMenuAreaTypeEnum, CmsStore, ContactCategoryModel, ContactCategoryService, ContactConfigurationService, ContactContentModel, ContactContentService, ContactModuleConfigAdminMainValuesModel, ContactModuleConfigSiteAccessValuesModel, ContactModuleConfigSiteValuesModel, ContactModuleSiteStorageValuesModel, CoreAuthService, CoreConfigurationService, CoreCpMainMenuCmsUserGroupModel, CoreCpMainMenuCmsUserGroupService, CoreCpMainMenuModel, CoreCpMainMenuService, CoreCurrencyModel, CoreCurrencyService, CoreDeviceModel, CoreDeviceService, CoreEnumService, CoreGuideModel, CoreGuideService, CoreLocationModel, CoreLocationService, CoreLogAvoidDuplicateDataEntryModel, CoreLogAvoidDuplicateDataEntryService, CoreLogCurrencyModel, CoreLogCurrencyService, CoreLogErrorModel, CoreLogErrorService, CoreLogMemberModel, CoreLogMemberService, CoreLogReportDataModel, CoreLogReportDataService, CoreLogSmsModel, CoreLogSmsService, CoreModuleCheckSerialForSiteDtoModel, CoreModuleCommentDtoModel, CoreModuleConfigAdminMainValuesModel, CoreModuleConfigSiteAccessValuesModel, CoreModuleConfigSiteValuesModel, CoreModuleDataCommentModel, CoreModuleDataCommentService, CoreModuleDataMemoModel, CoreModuleDataMemoService, CoreModuleEntityModel, CoreModuleEntityReportFileModel, CoreModuleEntityReportFileService, CoreModuleEntityService, CoreModuleFavoriteDtoModel, CoreModuleLogContentCountModel, CoreModuleLogContentCountService, CoreModuleLogFavoriteModel, CoreModuleLogFavoriteService, CoreModuleLogLikeModel, CoreModuleLogLikeService, CoreModuleLogReportAbuseModel, CoreModuleLogReportAbuseService, CoreModuleLogScoreModel, CoreModuleLogScoreService, CoreModuleLogShowKeyModel, CoreModuleLogShowKeyService, CoreModuleLogSiteCreditBlockedModel, CoreModuleLogSiteCreditBlockedService, CoreModuleLogSiteCreditModel, CoreModuleLogSiteCreditService, CoreModuleLogSiteUserCreditBlockedModel, CoreModuleLogSiteUserCreditBlockedService, CoreModuleLogSiteUserCreditModel, CoreModuleLogSiteUserCreditService, CoreModuleMemoDtoModel, CoreModuleModel, CoreModuleProcessCustomizeModel, CoreModuleProcessCustomizeService, CoreModuleProcessModel, CoreModuleProcessService, CoreModuleRelationshipContentModel, CoreModuleRelationshipContentService, CoreModuleReportAbuseDtoModel, CoreModuleSaleHeaderCalculateDtoModel, CoreModuleSaleHeaderGroupModel, CoreModuleSaleHeaderGroupService, CoreModuleSaleHeaderModel, CoreModuleSaleHeaderPaymentDtoModel, CoreModuleSaleHeaderService, CoreModuleSaleInvoiceDetailModel, CoreModuleSaleInvoiceDetailService, CoreModuleSaleInvoiceModel, CoreModuleSaleInvoiceService, CoreModuleSaleItemModel, CoreModuleSaleItemService, CoreModuleSaleSerialModel, CoreModuleSaleSerialService, CoreModuleService, CoreModuleShowKeyDtoModel, CoreModuleSiteAccountingDocumentDetailModel, CoreModuleSiteAccountingDocumentDetailService, CoreModuleSiteAccountingDocumentDetailTypeModel, CoreModuleSiteAccountingDocumentDetailTypeService, CoreModuleSiteAccountingDocumentModel, CoreModuleSiteAccountingDocumentService, CoreModuleSiteCreditCalculateDtoModel, CoreModuleSiteCreditChargeDirectDtoModel, CoreModuleSiteCreditModel, CoreModuleSiteCreditPaymentDtoModel, CoreModuleSiteCreditService, CoreModuleSiteModel, CoreModuleSiteService, CoreModuleSiteStorageValuesModel, CoreModuleSiteUserCreditCalculateDtoModel, CoreModuleSiteUserCreditChargeDirectDtoModel, CoreModuleSiteUserCreditModel, CoreModuleSiteUserCreditPaymentDtoModel, CoreModuleSiteUserCreditService, CoreModuleTagCategoryModel, CoreModuleTagCategoryService, CoreModuleTagModel, CoreModuleTagService, CoreSiteAddFirstSiteDtoModel, CoreSiteCategoryCmsModuleModel, CoreSiteCategoryCmsModuleService, CoreSiteCategoryModel, CoreSiteCategoryService, CoreSiteDomainAliasModel, CoreSiteDomainAliasService, CoreSiteModel, CoreSiteSearchModel, CoreSiteService, CoreSiteSupportModel, CoreSiteUserModel, CoreSiteUserService, CoreTokenActivationModel, CoreTokenActivationService, CoreTokenMicroServiceLogModel, CoreTokenMicroServiceLogService, CoreTokenMicroServiceModel, CoreTokenMicroServiceService, CoreTokenNotificationLogModel, CoreTokenNotificationLogService, CoreTokenNotificationModel, CoreTokenNotificationService, CoreTokenUserBadLoginModel, CoreTokenUserBadLoginService, CoreTokenUserLogModel, CoreTokenUserLogService, CoreTokenUserModel, CoreTokenUserService, CoreUserClaimCheckDtoModel, CoreUserClaimCheckModel, CoreUserClaimContentModel, CoreUserClaimContentService, CoreUserClaimGroupDetailModel, CoreUserClaimGroupDetailService, CoreUserClaimGroupModel, CoreUserClaimGroupService, CoreUserClaimTypeModel, CoreUserClaimTypeService, CoreUserGroupModel, CoreUserGroupService, CoreUserModel, CoreUserService, CoreUserSupportAccessModel, CoreUserSupportAccessService, DataFieldInfoModel, DataProviderClientConnectionTypeEnum, DataProviderClientModel, DataProviderClientService, DataProviderConfigurationService, DataProviderEnumService, DataProviderLogClientModel, DataProviderLogClientService, DataProviderLogDataModel, DataProviderLogDataService, DataProviderLogPlanModel, DataProviderLogPlanService, DataProviderLogSourceModel, DataProviderLogSourceService, DataProviderModuleCalculateDtoModel, DataProviderModuleConfigAdminMainValuesModel, DataProviderModuleConfigSiteAccessValuesModel, DataProviderModuleConfigSiteValuesModel, DataProviderModulePaymentDtoModel, DataProviderModuleSiteStorageValuesModel, DataProviderPlanCategoryModel, DataProviderPlanCategoryService, DataProviderPlanClientModel, DataProviderPlanClientService, DataProviderPlanModel, DataProviderPlanPriceModel, DataProviderPlanPriceService, DataProviderPlanService, DataProviderPlanSourceModel, DataProviderPlanSourceService, DataProviderSourceModel, DataProviderSourceService, DataProviderTransactionModel, DataProviderTransactionService, DateTypeEnum, DayOfWeekEnum, DeviceStatusEnum, DeviceTypeEnum, DomainModel, DonateConfigurationService, DonateEnumService, DonateLogViewModel, DonateLogViewService, DonateModuleCalculateDtoModel, DonateModuleConfigAdminMainValuesModel, DonateModuleConfigSiteAccessValuesModel, DonateModuleConfigSiteValuesModel, DonateModulePaymentDtoModel, DonateModuleSiteStorageValuesModel, DonateSponsorModel, DonateSponsorService, DonateTargetCategoryModel, DonateTargetCategoryService, DonateTargetModel, DonateTargetPeriodModel, DonateTargetPeriodService, DonateTargetPeriodSponsorModel, DonateTargetPeriodSponsorService, DonateTargetService, DonateTransactionModel, DonateTransactionService, EditStepDtoModel, ErrorExceptionResult, ErrorExceptionResultBase, ErrorExceptionResultExportFile, ErrorTypeEnum, EstateAccountAgencyAdsModel, EstateAccountAgencyAdsService, EstateAccountAgencyFilterModel, EstateAccountAgencyModel, EstateAccountAgencyService, EstateAccountAgencyUserModel, EstateAccountAgencyUserService, EstateAccountAgencyWorkAreaModel, EstateAccountAgencyWorkAreaService, EstateAccountUserFilterModel, EstateAccountUserModel, EstateAccountUserService, EstateAccountUserWorkAreaModel, EstateAccountUserWorkAreaService, EstateActivityTypeModel, EstateActivityTypeService, EstateAdsTypeModel, EstateAdsTypeService, EstateBillboardModel, EstateBillboardService, EstateConfigurationService, EstateContractModel, EstateContractService, EstateContractTypeModel, EstateContractTypeService, EstateCustomerCategoryModel, EstateCustomerCategoryService, EstateCustomerOrderActionSendSmsDtoModel, EstateCustomerOrderFilterModel, EstateCustomerOrderModel, EstateCustomerOrderResultModel, EstateCustomerOrderResultService, EstateCustomerOrderService, EstateEnumService, EstateModuleConfigAdminMainValuesModel, EstateModuleConfigSiteAccessValuesModel, EstateModuleConfigSiteValuesModel, EstateModuleSaleAccountAgencyAdsCalculateDtoModel, EstateModuleSaleAccountAgencyAdsPaymentDtoModel, EstateModuleSalePropertyAdsCalculateDtoModel, EstateModuleSalePropertyAdsPaymentDtoModel, EstateModuleSiteStorageValuesModel, EstatePriceInquiryDtoModel, EstatePropertyAccountTypeUserModel, EstatePropertyAccountTypeUserService, EstatePropertyActionSendSmsDtoModel, EstatePropertyAdsModel, EstatePropertyAdsService, EstatePropertyCompanyModel, EstatePropertyCompanyService, EstatePropertyDetailGroupModel, EstatePropertyDetailGroupService, EstatePropertyDetailModel, EstatePropertyDetailService, EstatePropertyDetailValueModel, EstatePropertyExpertPriceModel, EstatePropertyExpertPriceService, EstatePropertyFilterModel, EstatePropertyHistoryFilterModel, EstatePropertyHistoryModel, EstatePropertyHistoryService, EstatePropertyModel, EstatePropertyProjectModel, EstatePropertyProjectService, EstatePropertyService, EstatePropertyShareAgencyModel, EstatePropertyShareAgencyService, EstatePropertyShareAgentModel, EstatePropertyShareAgentService, EstatePropertyShareSiteModel, EstatePropertyShareSiteService, EstatePropertySupplierCategoryModel, EstatePropertySupplierCategoryService, EstatePropertySupplierModel, EstatePropertySupplierService, EstatePropertyTypeLanduseModel, EstatePropertyTypeLanduseService, EstatePropertyTypeModel, EstatePropertyTypeService, EstatePropertyTypeUsageModel, EstatePropertyTypeUsageService, EstateUserTypeEnum, ExportFileModel, ExportFileTypeEnum, ExportReceiveMethodEnum, FieldInfoModel, FieldInputDataSourceModel, File360TourDefaultModel, File360TourHotSpotModel, File360TourModel, File360TourScenesModel, File360ViewModel, FileCategoryModel, FileCategoryService, FileCompressDtoModel, FileConfigurationService, FileContentModel, FileContentService, FileCopyCutDtoModel, FileDownloadDtoModel, FileTypeEnum, FileUploadByUrlDtoModel, FileUploadModel, FileUploadedModel, FilterDataModel, FilterDataModelSearchTypesEnum, FilterModel, FormInfoModel, FormSubmitedStatusEnum, GenderTypeEnum, GetAllDefaultPagesBySiteCategoryDtoModel, GetPropertiesInfoModel, HyperShopCategoryModel, HyperShopCategoryService, HyperShopConfigurationService, HyperShopConnectionTypeEnum, HyperShopContentModel, HyperShopContentService, HyperShopModuleConfigAdminMainValuesModel, HyperShopModuleConfigSiteAccessValuesModel, HyperShopModuleConfigSiteValuesModel, HyperShopModuleSiteStorageValuesModel, HyperShopOrderContentDtoModel, HyperShopOrderContentModel, HyperShopOrderDtoModel, HyperShopOrderModel, HyperShopOrderPaymentDtoModel, HyperShopOrderService, HyperShopOrderTypeEnum, HyperShopPaymentModel, HyperShopPaymentTypeEnum, InfoEnumModel, InputDataTypeEnum, IpModel, ItemState, LanguageEnum, LanguageFullEnum, LinkManagementAccountingDetailModel, LinkManagementAccountingDetailService, LinkManagementAccountingModel, LinkManagementAccountingService, LinkManagementBillboardModel, LinkManagementBillboardPatternModel, LinkManagementBillboardPatternService, LinkManagementBillboardService, LinkManagementBillboardTargetCategoryModel, LinkManagementBillboardTargetCategoryService, LinkManagementConfigurationService, LinkManagementEnumService, LinkManagementMemberModel, LinkManagementMemberService, LinkManagementModuleConfigAdminMainValuesModel, LinkManagementModuleConfigSiteAccessValuesModel, LinkManagementModuleConfigSiteValuesModel, LinkManagementModuleSiteStorageValuesModel, LinkManagementTargetBillboardLogModel, LinkManagementTargetBillboardLogService, LinkManagementTargetCategoryModel, LinkManagementTargetCategoryService, LinkManagementTargetModel, LinkManagementTargetService, LinkManagementTargetShortLinkGetDtoModel, LinkManagementTargetShortLinkGetResponceModel, LinkManagementTargetShortLinkSetDtoModel, LinkManagementTargetShortLinkSetResponceModel, ManageUserAccessAreaTypesEnum, ManageUserAccessDataTypesEnum, ManageUserAccessUserTypesEnum, ManagementContentSettingTypeEnum, MemberConfigurationService, MemberGroupModel, MemberGroupService, MemberHistoryModel, MemberHistoryService, MemberModuleConfigAdminMainValuesModel, MemberModuleConfigSiteAccessValuesModel, MemberModuleConfigSiteValuesModel, MemberModuleSiteStorageValuesModel, MemberPropertyAliasModel, MemberPropertyAliasService, MemberPropertyDetailDefaultValueModel, MemberPropertyDetailGroupModel, MemberPropertyDetailGroupService, MemberPropertyDetailModel, MemberPropertyDetailService, MemberPropertyDetailValueModel, MemberPropertyDetailValueService, MemberPropertyModel, MemberPropertyService, MemberPropertySiteModel, MemberPropertySiteService, MemberPropertyTypeModel, MemberPropertyTypeService, MemberPropertyTypeSiteModel, MemberPropertyTypeSiteService, MemberUserGroupModel, MemberUserGroupService, MemberUserModel, MemberUserSearchAliasModel, MemberUserSearchAliasService, MemberUserService, MemberUserSiteModel, MemberUserSiteService, MenuPlaceTypeEnum, MessageTypeEnum, MicroServiceConnectionStatusEnum, MicroServiceConnectionTypeEnum, MicroServiceModuleTypeEnum, ModuleConfigAdminMainValuesModel, ModuleConfigSiteAccessValuesModel, ModuleConfigSiteValuesModel, ModuleSiteStorageValuesModel, NewsCategoryModel, NewsCategoryService, NewsCommentModel, NewsCommentService, NewsConfigurationService, NewsContentAndParameterValueService, NewsContentCategoryModel, NewsContentCategoryService, NewsContentModel, NewsContentOtherInfoModel, NewsContentOtherInfoService, NewsContentParameterService, NewsContentParameterTypeService, NewsContentService, NewsContentSimilarModel, NewsContentSimilarService, NewsContentTagModel, NewsContentTagService, NewsModuleConfigAdminMainValuesModel, NewsModuleConfigSiteAccessValuesModel, NewsModuleConfigSiteValuesModel, NewsModuleSiteStorageValuesModel, NewsShareMainAdminSettingModel, NewsShareMainAdminSettingService, NewsShareReceiverCategoryModel, NewsShareReceiverCategoryService, NewsShareServerCategoryModel, NewsShareServerCategoryService, NotificationConnectionStatusEnum, NotificationConnectionTypeEnum, NotificationModuleTypeEnum, NotificationTypeEnum, NtkCmsApiComponent, NtkCmsApiModule, NtkCmsApiService, NtkCmsApiStoreService, OperatingSystemTypeEnum, PageAbilityTypeEnum, PageModel, PaymentMethodEnum, PollingCategoryModel, PollingCategoryService, PollingConfigurationService, PollingContentModel, PollingContentService, PollingModuleConfigAdminMainValuesModel, PollingModuleConfigSiteAccessValuesModel, PollingModuleConfigSiteValuesModel, PollingModuleSiteStorageValuesModel, PollingOptionModel, PollingOptionService, PollingVoteModel, PollingVoteService, ProcessModuleSiteDataInfoOutputModel, ProcessModuleSiteDataOptimazeOutputModel, ProcessModuleSiteDataRemoveOutputModel, PropertyExpertPriceTypeEnumEstate, RecordStatusEnum, RenderModelApplicationSendNotificationInput, ReportFileTypeEnum, RessellerChartModel, SET_IN_PROCESSING_LIST, SET_LOADING_STATE, SET_TOKEN_INFO, ScheduleCronTypeEnum, ScoreClickDtoModel, ScoreClickInfoModel, SearchTagModel, SendNotificationModel, SendSmsStatusTypeEnum, SetInProcessingList, SetLoadingState, SetTokenInfoState, ShareInfoModel, SharingAccountingTypeEnum, SharingPriceTypeEnum, SiteStatusEnum, SmsApiNumberPermissionAccessStatusEnum, SmsApiNumberPermissionActionEnum, SmsApiPathPermissionAccessStatusEnum, SmsApiPathPermissionActionEnum, SmsApiSendMessageDtoModel, SmsApiSendMessageTestDtoModel, SmsApiSendResultModel, SmsConfigurationService, SmsEnumService, SmsLogApiPathModel, SmsLogApiPathService, SmsLogInBoxModel, SmsLogInBoxService, SmsLogOutBoxDetailBulkModel, SmsLogOutBoxDetailBulkService, SmsLogOutBoxDetailModel, SmsLogOutBoxDetailService, SmsLogOutBoxModel, SmsLogOutBoxQueueModel, SmsLogOutBoxQueueService, SmsLogOutBoxScheduleRunInfoModel, SmsLogOutBoxService, SmsLogOutBoxTaskSchedulerModel, SmsLogOutBoxTaskSchedulerService, SmsMainApiNumberModel, SmsMainApiNumberPermissionModel, SmsMainApiNumberPermissionService, SmsMainApiNumberService, SmsMainApiPathAliasJsonModel, SmsMainApiPathAndApiNumberModel, SmsMainApiPathAndApiNumberService, SmsMainApiPathCompanyModel, SmsMainApiPathCompanyService, SmsMainApiPathModel, SmsMainApiPathPermissionModel, SmsMainApiPathPermissionService, SmsMainApiPathPriceServiceModel, SmsMainApiPathPriceServiceService, SmsMainApiPathProcessFlowLogModel, SmsMainApiPathProcessFlowLogService, SmsMainApiPathProcessFlowModel, SmsMainApiPathProcessFlowService, SmsMainApiPathPublicConfigAliasJsonModel, SmsMainApiPathPublicConfigModel, SmsMainApiPathPublicConfigService, SmsMainApiPathService, SmsMainApiPathSuperSederModel, SmsMainApiPathSuperSederService, SmsMainCustomerCreditModel, SmsMainCustomerCreditService, SmsMainMessageCategoryModel, SmsMainMessageCategoryService, SmsMainMessageContentModel, SmsMainMessageContentService, SmsMessageTypeEnum, SmsModuleConfigAdminMainValuesModel, SmsModuleConfigSiteAccessValuesModel, SmsModuleConfigSiteValuesModel, SmsModuleSiteStorageValuesModel, SmsOutBoxTypeEnum, SmsProcessFlowRecordStatusEnum, SmsProcessFlowSmsStatusEnum, SmsRecordStatusOutBoxEnum, SortTypeEnum, ThemeConfigLayoutModel, TicketAccessStatusEnum, TicketStatusEnum, TicketingAnswerModel, TicketingAnswerService, TicketingConfigurationService, TicketingDepartemenLogModel, TicketingDepartemenLogService, TicketingDepartemenModel, TicketingDepartemenOperatorModel, TicketingDepartemenOperatorService, TicketingDepartemenPriorityEnum, TicketingDepartemenService, TicketingEnumService, TicketingFaqModel, TicketingFaqService, TicketingModuleConfigAdminMainValuesModel, TicketingModuleConfigSiteAccessValuesModel, TicketingModuleConfigSiteValuesModel, TicketingModuleSiteStorageValuesModel, TicketingTaskDtoModel, TicketingTaskModel, TicketingTaskService, TicketingTemplateModel, TicketingTemplateService, TokenDeviceClientInfoDtoModel, TokenDeviceModel, TokenInfoModel, TransactionBankStatusEnum, TransactionLogPublicTypeEnum, TransactionRecordStatusEnum, UiPropertyDesignEnum, UniversalActionModel, UniversalMenuConfigurationService, UniversalMenuEnumService, UniversalMenuMenuItemModel, UniversalMenuMenuItemProcessModel, UniversalMenuMenuItemProcessService, UniversalMenuMenuItemService, UniversalMenuModuleConfigAdminMainValuesModel, UniversalMenuModuleConfigSiteAccessValuesModel, UniversalMenuModuleConfigSiteValuesModel, UniversalMenuModuleSiteStorageValuesModel, UniversalMenuPlatformModel, UniversalMenuPlatformService, UniversalMenuPlatformTypeEnum, UniversalMenuProcessModel, UniversalMenuProcessService, UniversalMenuRenderTypeEnum, UniversalMenuSessionModel, UniversalMenuSessionService, UpdateTypeEnum, UploadApplictionDtoModel, UserActivateTypesEnum, UserClaimGroupActionTypeEnum, UserClaimKindsEnum, WebDesignerConfigurationService, WebDesignerEnumService, WebDesignerLogMemberInfoModel, WebDesignerLogMemberInfoService, WebDesignerLogPageSafeModel, WebDesignerLogPageSafeService, WebDesignerMainIntroModel, WebDesignerMainIntroService, WebDesignerMainMenuModel, WebDesignerMainMenuService, WebDesignerMainPageDependencyModel, WebDesignerMainPageDependencyService, WebDesignerMainPageModel, WebDesignerMainPageService, WebDesignerMainPageTemplateModel, WebDesignerMainPageTemplateService, WebDesignerMainPageTemplateSiteCategoryModel, WebDesignerMainPageTemplateSiteCategoryService, WebDesignerModuleConfigAdminMainValuesModel, WebDesignerModuleConfigSiteAccessValuesModel, WebDesignerModuleConfigSiteValuesModel, WebDesignerModuleSiteStorageValuesModel, WebDesignerPageAutoAddDtoModel, stateReducer };
